// Configuration for all lessons
export const LESSONS_CONFIG = {
  1: {
    title: "الفصل ١ - الدرس ١: أنماط من عنصرين",
    exercises: [
      {
        id: "l1_ex1",
        type: "click-cycle-colors",
        title: "🎨 أكمل النمط: أحمر وأزرق",
        instruction: "انقر على الدوائر الفارغة لتغيير اللون وإكمال النمط.",
        pattern: [
          { type: "static", emoji: "🔴", color: "red" },
          { type: "static", emoji: "🔵", color: "blue" },
          { type: "static", emoji: "🔴", color: "red" },
          { type: "static", emoji: "🔵", color: "blue" },
          { type: "interactive", emoji: "⚪️", colors: ["white", "red", "blue", "green"], isCircle: true },
          { type: "interactive", emoji: "⚪️", colors: ["white", "red", "blue", "green"], isCircle: true }
        ],
        correctAnswer: ["red", "blue"],
        successMessage: "✅ أحسنت! النمط هو: أحمر، أزرق",
        errorMessage: "❌ حاول مرة أخرى! النمط هو 🔴 🔵 🔴 🔵"
      },
      {
        id: "l1_ex2",
        type: "click-cycle-colors",
        title: "🎨 أكمل النمط: أخضر وأصفر",
        instruction: "انقر على الدوائر الفارغة لتغيير اللون وإكمال النمط.",
        pattern: [
          { type: "static", emoji: "🟢", color: "green" },
          { type: "static", emoji: "🟡", color: "yellow" },
          { type: "static", emoji: "🟢", color: "green" },
          { type: "static", emoji: "🟡", color: "yellow" },
          { type: "interactive", emoji: "⚪️", colors: ["white", "green", "yellow"], isCircle: true },
          { type: "interactive", emoji: "⚪️", colors: ["white", "green", "yellow"], isCircle: true }
        ],
        correctAnswer: ["green", "yellow"],
        successMessage: "✅ ممتاز! النمط هو: أخضر، أصفر",
        errorMessage: "❌ انظر جيداً للنمط: 🟢 🟡 🟢 🟡"
      },
      {
        id: "l1_ex3",
        type: "click-cycle-colors",
        title: "🐻 أكمل نمط الدببة",
        instruction: "انقر على الدببة الفارغة لتغيير اللون.",
        backgroundColor: "#F0F8FF",
        pattern: [
          { type: "static", emoji: "🐻", color: "brown" },
          { type: "static", emoji: "🐻", color: "yellow" },
          { type: "static", emoji: "🐻", color: "brown" },
          { type: "static", emoji: "🐻", color: "yellow" },
          { type: "interactive", emoji: "🐻", colors: ["white", "brown", "yellow"] },
          { type: "interactive", emoji: "🐻", colors: ["white", "brown", "yellow"] }
        ],
        correctAnswer: ["brown", "yellow"],
        successMessage: "✅ رائع! لقد أكملت النمط.",
        errorMessage: "❌ حاول مرة أخرى. النمط هو: بني، أصفر"
      },
      {
        id: "l1_ex4",
        type: "select-option",
        title: "🍎🍌 اختر العنصر الناقص",
        instruction: "ما هو الرمز التالي في النمط؟",
        pattern: [
          { type: "static", emoji: "🍎" },
          { type: "static", emoji: "🍌" },
          { type: "static", emoji: "🍎" },
          { type: "static", emoji: "🍌" },
          { type: "static", emoji: "🍎" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["🍌", "🍎"],
        correctAnswer: "🍌",
        successMessage: "✅ صحيح! بعد التفاحة تأتي الموزة.",
        errorMessage: "❌ فكّر مرة أخرى. انظر للنمط: 🍎 🍌 🍎 🍌"
      },
      {
        id: "l1_ex5",
        type: "paint-colors",
        title: "⭐ لوّن نمطاً من عنصرين",
        instruction: "استعمل لونين لتكوين نمط جميل. انقر على النجمة لاختيار لون.",
        colors: ["red", "blue", "green", "yellow"],
        itemCount: 5,
        emoji: "⭐",
        openEnded: true,
        successMessage: "ألوانك جميلة! لقد صنعت نمطاً رائعاً."
      }
    ]
  },
  2: {
    title: "الفصل ١ - الدرس ٢: أنماط من ثلاثة عناصر",
    exercises: [
      {
        id: "l2_ex1",
        type: "click-cycle-colors",
        title: "🚗 أكمل نمط السيارات",
        instruction: "انقر على السيارة الفارغة لتغيير اللون وإكمال النمط.",
        pattern: [
          { type: "static", emoji: "🚗", color: "red" },
          { type: "static", emoji: "🚗", color: "blue" },
          { type: "static", emoji: "🚗", color: "yellow" },
          { type: "static", emoji: "🚗", color: "red" },
          { type: "static", emoji: "🚗", color: "blue" },
          { type: "interactive", emoji: "🚗", colors: ["white", "red", "blue", "yellow"] }
        ],
        correctAnswer: ["yellow"],
        successMessage: "✅ ممتاز! النمط هو: أحمر، أزرق، أصفر",
        errorMessage: "❌ ما هو اللون التالي بعد الأزرق في النمط؟"
      },
      {
        id: "l2_ex2",
        type: "click-cycle-colors",
        title: "△ أكمل نمط المثلثات",
        instruction: "انقر على المثلثات الفارغة لتغيير اللون.",
        backgroundColor: "#FFFBE6",
        pattern: [
          { type: "static", emoji: "△", color: "red" },
          { type: "static", emoji: "△", color: "green" },
          { type: "static", emoji: "△", color: "blue" },
          { type: "static", emoji: "△", color: "red" },
          { type: "interactive", emoji: "△", colors: ["white", "red", "green", "blue"] },
          { type: "interactive", emoji: "△", colors: ["white", "red", "green", "blue"] }
        ],
        correctAnswer: ["green", "blue"],
        successMessage: "✅ رائع! أحمر، أخضر، أزرق.",
        errorMessage: "❌ حاول مرة أخرى. النمط هو 🔺 💚 🔷"
      },
      {
        id: "l2_ex3",
        type: "select-option",
        title: "🌙☀️⭐ اختر العنصر الناقص",
        instruction: "ما هو الرمز التالي في النمط؟",
        pattern: [
          { type: "static", emoji: "🌙" },
          { type: "static", emoji: "☀️" },
          { type: "static", emoji: "⭐" },
          { type: "static", emoji: "🌙" },
          { type: "static", emoji: "☀️" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["⭐", "☀️", "🌙"],
        correctAnswer: "⭐",
        successMessage: "✅ صحيح! النمط هو: قمر، شمس، نجمة.",
        errorMessage: "❌ انظر جيداً للنمط الثلاثي."
      },
      {
        id: "l2_ex4",
        type: "paint-colors",
        title: "🎨 لوّن نمطاً من ثلاثة عناصر",
        instruction: "استعمل ثلاثة ألوان لتكوين نمط جميل. انقر على المربع لاختيار لون.",
        colors: ["red", "blue", "green", "yellow", "purple"],
        itemCount: 6,
        emoji: "⬜",
        openEnded: true,
        successMessage: "عمل رائع! نمطك جميل جداً."
      }
    ]
  },
  3: {
    title: "الفصل ٢ - الدرس ١: العددان ١ و ٢",
    exercises: [
      {
        id: "l3_ex1",
        type: "count-and-input",
        title: "🦆 عد واكتب العدد",
        instruction: "عد الأشياء في كل مجموعة واختر العدد الصحيح.",
        groups: [
          { emoji: "🦆", count: 1 },
          { emoji: "🐦", count: 2 }
        ],
        numbers: ["؟", "١", "٢", "٣"],
        correctAnswer: ["١", "٢"],
        successMessage: "✅ ممتاز! ١ بطة و ٢ عصفور.",
        errorMessage: "❌ عد مرة أخرى."
      },
      {
        id: "l3_ex2",
        type: "multi-select",
        title: "🐾 حيوانات تمشي على رجلين",
        instruction: "اختر كل الحيوانات التي تمشي على (رجلين اثنتين).",
        backgroundColor: "#E6FFFA",
        items: [
          { emoji: "🐓", label: "ديك", correct: true },
          { emoji: "🐎", label: "حصان", correct: false },
          { emoji: "🦆", label: "بطة", correct: true }
        ],
        successMessage: "✅ صحيح! الديك والبطة يمشيان على رجلين.",
        errorMessage: "❌ الحصان له أربع أرجل. اختر الحيوانات ذات الرجلين فقط."
      },
      {
        id: "l3_ex3",
        type: "multi-select",
        title: "🌸 اختر المجموعة الصحيحة",
        instruction: "اختر المجموعة التي تحتوي على (زهرتين اثنتين) فقط.",
        items: [
          { emoji: "🌸🌸🌸", label: "٣ زهرات", correct: false },
          { emoji: "🌸🌸", label: "٢ زهرة", correct: true }
        ],
        successMessage: "✅ أحسنت! هذه هي مجموعة الزهرتين.",
        errorMessage: "❌ نحن نبحث عن المجموعة التي فيها ٢ فقط."
      }
    ]
  },
  4: {
    title: "الفصل ٢ - الدرس ٢: العددان ٣ و ٤",
    exercises: [
      {
        id: "l4_ex1",
        type: "count-and-input",
        title: "🐔 عد واكتب العدد",
        instruction: "عد الأشياء في كل مجموعة واختر العدد الصحيح.",
        groups: [
          { emoji: "🐓", count: 3 },
          { emoji: "🐔", count: 4 },
          { emoji: "👒", count: 4 }
        ],
        numbers: ["؟", "١", "٢", "٣", "٤", "٥"],
        correctAnswer: ["٣", "٤", "٤"],
        successMessage: "✅ عد رائع! ٣ ديوك، ٤ دجاجات، ٤ قبعات.",
        errorMessage: "❌ أعد العد مرة أخرى."
      },
      {
        id: "l4_ex2",
        type: "select-option",
        title: "△ عد المثلثات",
        instruction: "كم عدد المثلثات في الصورة؟",
        pattern: [
          { type: "static", emoji: "△" },
          { type: "static", emoji: "△" },
          { type: "static", emoji: "△" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["٢", "٣", "٤"],
        correctAnswer: "٣",
        successMessage: "✅ صحيح! هناك ٣ مثلثات.",
        errorMessage: "❌ انظر جيداً وعد المثلثات."
      },
      {
        id: "l4_ex3",
        type: "click-cycle-emoji",
        title: "🔢 أكمل العد",
        instruction: "انقر على علامة الاستفهام لتكملة العد من ١ إلى ٤.",
        backgroundColor: "#F5F5DC",
        pattern: [
          { type: "static", emoji: "١" },
          { type: "interactive", emojis: ["؟", "٢", "٣"] },
          { type: "interactive", emojis: ["؟", "٣", "٤"] },
          { type: "interactive", emojis: ["؟", "٤", "١"] }
        ],
        correctAnswer: ["٢", "٣", "٤"],
        successMessage: "✅ ممتاز! ١، ٢، ٣، ٤!",
        errorMessage: "❌ حاول مرة أخرى. رتب الأعداد بالتسلسل."
      }
    ]
  },
  5: {
    title: "الفصل ٢ - الدرس ٣: العددان ٥ و ٦",
    exercises: [
      {
        id: "l5_ex1",
        type: "count-and-input",
        title: "🐧 عد واكتب العدد",
        instruction: "عد الأشياء في كل مجموعة واختر العدد الصحيح.",
        groups: [
          { emoji: "🐧", count: 5 },
          { emoji: "🐦", count: 6 }
        ],
        numbers: ["؟", "٣", "٤", "٥", "٦"],
        correctAnswer: ["٥", "٦"],
        successMessage: "✅ صحيح! ٥ بطاريق و ٦ عصافير.",
        errorMessage: "❌ أعد العد. ركز جيداً."
      },
      {
        id: "l5_ex2",
        type: "count-and-input",
        title: "🟢 عد الدوائر",
        instruction: "عد الدوائر في كل صندوق واختر العدد.",
        backgroundColor: "#E6F3E6",
        groups: [
          { emoji: "🟢", count: 5 },
          { emoji: "🟢", count: 6 },
          { emoji: "🟢", count: 5 },
          { emoji: "🟢", count: 6 }
        ],
        numbers: ["؟", "٤", "٥", "٦"],
        correctAnswer: ["٥", "٦", "٥", "٦"],
        successMessage: "✅ عد ممتاز!",
        errorMessage: "❌ انتبه للعدد في كل صندوق."
      }
    ]
  },
  6: {
    title: "الفصل ٢ - الدرس ٤: الأعداد ٧، ٨، ٩",
    exercises: [
      {
        id: "l6_ex1",
        type: "count-and-input",
        title: "📚 عد واكتب العدد",
        instruction: "عد الأشياء في كل مجموعة واختر العدد الصحيح.",
        groups: [
          { emoji: "📚", count: 9 },
          { emoji: "🎩", count: 8 },
          { emoji: "👓", count: 7 }
        ],
        numbers: ["؟", "٦", "٧", "٨", "٩"],
        correctAnswer: ["٩", "٨", "٧"],
        successMessage: "✅ أحسنت! ٩ كتب، ٨ قبعات، ٧ نظارات.",
        errorMessage: "❌ لقد أخطأت في العد. حاول مرة أخرى."
      },
      {
        id: "l6_ex2",
        type: "count-and-input",
        title: "🌿 عد الأوراق",
        instruction: "عد الأوراق في كل نبتة واختر العدد.",
        groups: [
          { emoji: "🌿", count: 7 },
          { emoji: "🌿", count: 8 },
          { emoji: "🌿", count: 9 }
        ],
        numbers: ["؟", "٦", "٧", "٨", "٩"],
        correctAnswer: ["٧", "٨", "٩"],
        successMessage: "✅ عمل رائع!",
        errorMessage: "❌ ركز جيداً أثناء العد."
      }
    ]
  },
  7: {
    title: "الفصل ٢ - الدرس ٥: العدد صفر",
    exercises: [
      {
        id: "l7_ex1",
        type: "count-and-input",
        title: "🍎 عد التفاح",
        instruction: "عد التفاح في كل طبق واختر العدد. انتبه للطبق الفارغ!",
        groups: [
          { emoji: "🍎", count: 1 },
          { emoji: "🍽️", count: 0 },
          { emoji: "🍎🍎", count: 2 }
        ],
        numbers: ["؟", "٠", "١", "٢"],
        correctAnswer: ["١", "٠", "٢"],
        successMessage: "✅ صحيح! ١، ٠، ٢. الطبق الفارغ يعني (صفر).",
        errorMessage: "❌ تذكر: لا يوجد شيء = ٠"
      },
      {
        id: "l7_ex2",
        type: "count-and-input",
        title: "✏️ عد الأشياء",
        instruction: "عد الأشياء في كل مجموعة واختر العدد.",
        backgroundColor: "#F0F0F0",
        groups: [
          { emoji: "⬜", count: 0 },
          { emoji: "✂️", count: 6 },
          { emoji: "⛏️", count: 5 }
        ],
        numbers: ["؟", "٠", "١", "٢", "٣", "٤", "٥", "٦"],
        correctAnswer: ["٠", "٦", "٥"],
        successMessage: "✅ ممتاز! ٠، ٦، ٥.",
        errorMessage: "❌ لا تنس عد الصندوق الفارغ (٠)."
      }
    ]
  },
  8: {
    title: "الفصل ٢ - الدرس ٦: الأكبر والأصغر",
    exercises: [
      {
        id: "l8_ex1",
        type: "multi-select",
        title: "🤡 اختر المجموعة الأكبر",
        instruction: "اختر المجموعة التي تحتوي على (العدد الأكبر) من المهرجين.",
        items: [
          { emoji: "🤡🤡🤡", label: "٣ مهرجين", correct: true },
          { emoji: "🤡🤡", label: "٢ مهرج", correct: false }
        ],
        successMessage: "✅ صحيح! ٣ أكبر من ٢.",
        errorMessage: "❌ أي مجموعة فيها عدد مهرجين أكثر؟"
      },
      {
        id: "l8_ex2",
        type: "multi-select",
        title: "🎈 اختر العدد الأكبر",
        instruction: "اختر البالون الذي يحمل (العدد الأكبر).",
        backgroundColor: "#FFFAF0",
        items: [
          { emoji: "🎈 ٢", label: "٢", correct: true },
          { emoji: "🎈 ١", label: "١", correct: false }
        ],
        successMessage: "✅ صحيح! ٢ أكبر من ١.",
        errorMessage: "❌ أي العددين هو الأكبر؟ ١ أم ٢؟"
      },
      {
        id: "l8_ex3",
        type: "multi-select",
        title: "🎈 اختر العدد الأكبر",
        instruction: "اختر البالون الذي يحمل (العدد الأكبر).",
        items: [
          { emoji: "🎈 ٣", label: "٣", correct: true },
          { emoji: "🎈 ٢", label: "٢", correct: false }
        ],
        successMessage: "✅ صحيح! ٣ أكبر من ٢.",
        errorMessage: "❌ أي العددين هو الأكبر؟ ٢ أم ٣؟"
      }
    ]
  },
  9: {
    title: "الفصل ٢ - الدرس ٧: المساواة",
    exercises: [
      {
        id: "l9_ex1",
        type: "select-option",
        title: "⚖️ قارن الأعداد",
        instruction: "هناك ٦ موزات و ٦ تفاحات. اختر الإشارة المناسبة.",
        pattern: [
          { type: "static", emoji: "٦" },
          { type: "missing", placeholder: "؟" },
          { type: "static", emoji: "٦" }
        ],
        options: ["=", ">", "<"],
        correctAnswer: "=",
        successMessage: "✅ صحيح! ٦ = ٦. المجموعتان متساويتان.",
        errorMessage: "❌ هل العددان متساويان أم أن أحدهما أكبر؟"
      },
      {
        id: "l9_ex2",
        type: "multi-select",
        title: "⚖️ هل المجموعتان متساويتان؟",
        instruction: "اختر المجموعة التي فيها إشارة المساواة (=) صحيحة.",
        items: [
          { emoji: "🌸🌸 = 🌸🌸", label: "٢ = ٢", correct: true },
          { emoji: "🌸🌸🌸 = 🌸", label: "٣ = ١", correct: false },
          { emoji: "🌸 = 🌸🌸🌸🌸", label: "١ = ٤", correct: false }
        ],
        successMessage: "✅ أحسنت! ٢ = ٢.",
        errorMessage: "❌ إشارة (=) تعني أن العدد هو نفسه في الجهتين."
      }
    ]
  },
  10: {
    title: "الفصل ٣ - الدرس ١: مكونات العددين ٤ و ٥",
    exercises: [
      {
        id: "l10_ex1",
        type: "click-cycle-emoji",
        title: "🌈 مكونات العدد ٤",
        instruction: "أكمل المعادلة. كم نحتاج لنصل إلى ٤؟",
        pattern: [
          { type: "static", emoji: "١" },
          { type: "static", emoji: "+" },
          { type: "interactive", emojis: ["؟", "١", "٢", "٣"] },
          { type: "static", emoji: "=" },
          { type: "static", emoji: "٤" }
        ],
        correctAnswer: ["٣"],
        successMessage: "✅ صحيح! ١ + ٣ = ٤",
        errorMessage: "❌ ١ زائد كم يساوي ٤؟"
      },
      {
        id: "l10_ex2",
        type: "click-cycle-emoji",
        title: "🌈 مكونات العدد ٤",
        instruction: "أكمل المعادلة. كم نحتاج لنصل إلى ٤؟",
        pattern: [
          { type: "static", emoji: "٢" },
          { type: "static", emoji: "+" },
          { type: "interactive", emojis: ["؟", "١", "٢", "٣"] },
          { type: "static", emoji: "=" },
          { type: "static", emoji: "٤" }
        ],
        correctAnswer: ["٢"],
        successMessage: "✅ صحيح! ٢ + ٢ = ٤",
        errorMessage: "❌ ٢ زائد كم يساوي ٤؟"
      },
      {
        id: "l10_ex3",
        type: "click-cycle-emoji",
        title: "🌈 مكونات العدد ٥",
        instruction: "أكمل المعادلة. كم نحتاج لنصل إلى ٥؟",
        backgroundColor: "#E6FFEF",
        pattern: [
          { type: "static", emoji: "٣" },
          { type: "static", emoji: "+" },
          { type: "interactive", emojis: ["؟", "١", "٢", "٣"] },
          { type: "static", emoji: "=" },
          { type: "static", emoji: "٥" }
        ],
        correctAnswer: ["٢"],
        successMessage: "✅ صحيح! ٣ + ٢ = ٥",
        errorMessage: "❌ ٣ زائد كم يساوي ٥؟"
      },
      {
        id: "l10_ex4",
        type: "click-cycle-emoji",
        title: "🌈 مكونات العدد ٥",
        instruction: "أكمل المعادلة. كم نحتاج لنصل إلى ٥؟",
        pattern: [
          { type: "static", emoji: "٤" },
          { type: "static", emoji: "+" },
          { type: "interactive", emojis: ["؟", "١", "٢", "٣", "٤"] },
          { type: "static", emoji: "=" },
          { type: "static", emoji: "٥" }
        ],
        correctAnswer: ["١"],
        successMessage: "✅ صحيح! ٤ + ١ = ٥",
        errorMessage: "❌ ٤ زائد كم يساوي ٥؟"
      }
    ]
  },
  11: {
    title: "الفصل ٣ - الدرس ٢: مكونات العدد ٦",
    exercises: [
      {
        id: "l11_ex1",
        type: "click-cycle-emoji",
        title: "🌈 مكونات العدد ٦",
        instruction: "أكمل المعادلة. كم نحتاج لنصل إلى ٦؟",
        pattern: [
          { type: "static", emoji: "٥" },
          { type: "static", emoji: "+" },
          { type: "interactive", emojis: ["؟", "١", "٢", "٣"] },
          { type: "static", emoji: "=" },
          { type: "static", emoji: "٦" }
        ],
        correctAnswer: ["١"],
        successMessage: "✅ صحيح! ٥ + ١ = ٦",
        errorMessage: "❌ ٥ زائد كم يساوي ٦؟"
      },
      {
        id: "l11_ex2",
        type: "click-cycle-emoji",
        title: "🌈 مكونات العدد ٦",
        instruction: "أكمل المعادلة. كم نحتاج لنصل إلى ٦؟",
        pattern: [
          { type: "static", emoji: "٣" },
          { type: "static", emoji: "+" },
          { type: "interactive", emojis: ["؟", "١", "٢", "٣"] },
          { type: "static", emoji: "=" },
          { type: "static", emoji: "٦" }
        ],
        correctAnswer: ["٣"],
        successMessage: "✅ صحيح! ٣ + ٣ = ٦",
        errorMessage: "❌ ٣ زائد كم يساوي ٦؟"
      }
    ]
  },
  12: {
    title: "الفصل ٣ - الدرس ٣: مكونات العدد ٧",
    exercises: [
      {
        id: "l12_ex1",
        type: "select-option",
        title: "🐝 مكونات العدد ٧",
        instruction: "كم يساوي ٦ + ١؟",
        pattern: [
          { type: "static", emoji: "٦" },
          { type: "static", emoji: "+" },
          { type: "static", emoji: "١" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["٥", "٦", "٧", "٨"],
        correctAnswer: "٧",
        successMessage: "✅ صحيح! ٦ + ١ = ٧",
        errorMessage: "❌ ٦ مضافاً إليها ١، كم يصبح المجموع؟"
      },
      {
        id: "l12_ex2",
        type: "select-option",
        title: "🐝 مكونات العدد ٧",
        instruction: "كم يساوي ٥ + ٢؟",
        pattern: [
          { type: "static", emoji: "٥" },
          { type: "static", emoji: "+" },
          { type: "static", emoji: "٢" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["٥", "٦", "٧", "٨"],
        correctAnswer: "٧",
        successMessage: "✅ صحيح! ٥ + ٢ = ٧",
        errorMessage: "❌ عد ٥، ثم ٢ بعدها. كم المجموع؟"
      }
    ]
  },
  13: {
    title: "الفصل ٣ - الدرس ٤: مكونات العددين ٨ و ٩",
    exercises: [
      {
        id: "l13_ex1",
        type: "click-cycle-emoji",
        title: "💐 مكونات العدد ٨",
        instruction: "أكمل مكونات العدد ٨.",
        pattern: [
          { type: "interactive", emojis: ["؟", "٥", "٦", "٧"] },
          { type: "static", emoji: "+" },
          { type: "static", emoji: "٢" },
          { type: "static", emoji: "=" },
          { type: "static", emoji: "٨" }
        ],
        correctAnswer: ["٦"],
        successMessage: "✅ صحيح! ٦ + ٢ = ٨",
        errorMessage: "❌ ما هو العدد الذي إذا أضفناه إلى ٢ يعطي ٨؟"
      },
      {
        id: "l13_ex2",
        type: "click-cycle-emoji",
        title: "💐 مكونات العدد ٩",
        instruction: "أكمل مكونات العدد ٩.",
        backgroundColor: "#FEF5E7",
        pattern: [
          { type: "static", emoji: "٥" },
          { type: "static", emoji: "+" },
          { type: "interactive", emojis: ["؟", "٢", "٣", "٤"] },
          { type: "static", emoji: "=" },
          { type: "static", emoji: "٩" }
        ],
        correctAnswer: ["٤"],
        successMessage: "✅ صحيح! ٥ + ٤ = ٩",
        errorMessage: "❌ ٥ زائد كم يساوي ٩؟"
      }
    ]
  },
  14: {
    title: "الفصل ٣ - الدرس ٥: استكشاف الأجزاء الناقصة",
    exercises: [
      {
        id: "l14_ex1",
        type: "click-cycle-emoji",
        title: "🍩 ما هو العدد الكلي؟",
        instruction: "أكمل المعادلة لتعرف العدد الكلي للدونات (المخبأ والظاهر).",
        pattern: [
          { type: "static", emoji: "٢" },
          { type: "static", emoji: "+" },
          { type: "static", emoji: "١" },
          { type: "static", emoji: "=" },
          { type: "interactive", emojis: ["؟", "٢", "٣", "٤"] }
        ],
        correctAnswer: ["٣"],
        successMessage: "✅ صحيح! ٢ ظاهر و ١ مخبأ = ٣",
        errorMessage: "❌ كم يساوي ٢ + ١؟"
      },
      {
        id: "l14_ex2",
        type: "click-cycle-emoji",
        title: "🍩 ما هو العدد الكلي؟",
        instruction: "أكمل المعادلة لتعرف العدد الكلي للدونات.",
        pattern: [
          { type: "static", emoji: "٣" },
          { type: "static", emoji: "+" },
          { type: "static", emoji: "٢" },
          { type: "static", emoji: "=" },
          { type: "interactive", emojis: ["؟", "٣", "٤", "٥"] }
        ],
        correctAnswer: ["٥"],
        successMessage: "✅ صحيح! ٣ ظاهر و ٢ مخبأ = ٥",
        errorMessage: "❌ كم يساوي ٣ + ٢؟"
      }
    ]
  },
  15: {
    title: "الفصل ٤ - الدرس ١: العدد ١٠",
    exercises: [
      {
        id: "l15_ex1",
        type: "click-cycle-emoji",
        title: "🔴 مكونات العدد ١٠",
        instruction: "أكمل مكونات العدد ١٠.",
        pattern: [
          { type: "static", emoji: "٩" },
          { type: "static", emoji: "+" },
          { type: "interactive", emojis: ["؟", "١", "٢"] },
          { type: "static", emoji: "=" },
          { type: "static", emoji: "١٠" }
        ],
        correctAnswer: ["١"],
        successMessage: "✅ صحيح! ٩ + ١ = ١٠",
        errorMessage: "❌ ٩ زائد كم يساوي ١٠؟"
      },
      {
        id: "l15_ex2",
        type: "click-cycle-emoji",
        title: "🔴 مكونات العدد ١٠",
        instruction: "أكمل مكونات العدد ١٠.",
        pattern: [
          { type: "static", emoji: "٨" },
          { type: "static", emoji: "+" },
          { type: "interactive", emojis: ["؟", "١", "٢", "٣"] },
          { type: "static", emoji: "=" },
          { type: "static", emoji: "١٠" }
        ],
        correctAnswer: ["٢"],
        successMessage: "✅ صحيح! ٨ + ٢ = ١٠",
        errorMessage: "❌ ٨ زائد كم يساوي ١٠؟"
      },
      {
        id: "l15_ex3",
        type: "click-cycle-emoji",
        title: "🔴 مكونات العدد ١٠",
        instruction: "أكمل مكونات العدد ١٠.",
        pattern: [
          { type: "static", emoji: "٧" },
          { type: "static", emoji: "+" },
          { type: "interactive", emojis: ["؟", "١", "٢", "٣"] },
          { type: "static", emoji: "=" },
          { type: "static", emoji: "١٠" }
        ],
        correctAnswer: ["٣"],
        successMessage: "✅ صحيح! ٧ + ٣ = ١٠",
        errorMessage: "❌ ٧ زائد كم يساوي ١٠؟"
      }
    ]
  },
  16: {
    title: "الفصل ٤ - الدرس ٢: مكونات العدد ١٠",
    exercises: [
      {
        id: "l16_ex1",
        type: "click-cycle-emoji",
        title: "🔴 مكونات العدد ١٠",
        instruction: "أكمل مكونات العدد ١٠.",
        backgroundColor: "#FFF0F5",
        pattern: [
          { type: "static", emoji: "٦" },
          { type: "static", emoji: "+" },
          { type: "interactive", emojis: ["؟", "٢", "٣", "٤"] },
          { type: "static", emoji: "=" },
          { type: "static", emoji: "١٠" }
        ],
        correctAnswer: ["٤"],
        successMessage: "✅ صحيح! ٦ + ٤ = ١٠",
        errorMessage: "❌ ٦ زائد كم يساوي ١٠؟"
      },
      {
        id: "l16_ex2",
        type: "click-cycle-emoji",
        title: "🔴 مكونات العدد ١٠",
        instruction: "أكمل مكونات العدد ١٠.",
        pattern: [
          { type: "static", emoji: "٥" },
          { type: "static", emoji: "+" },
          { type: "interactive", emojis: ["؟", "٣", "٤", "٥"] },
          { type: "static", emoji: "=" },
          { type: "static", emoji: "١٠" }
        ],
        correctAnswer: ["٥"],
        successMessage: "✅ صحيح! ٥ + ٥ = ١٠",
        errorMessage: "❌ ٥ زائد كم يساوي ١٠؟"
      }
    ]
  },
  17: {
    title: "الفصل ٤ - الدرس ٣: العد التصاعدي والتنازلي",
    exercises: [
      {
        id: "l17_ex1",
        type: "click-cycle-emoji",
        title: "🔢 أكمل العد التصاعدي",
        instruction: "انقر على الدوائر الفارغة لإكمال الأعداد بالترتيب.",
        pattern: [
          { type: "static", emoji: "١" },
          { type: "static", emoji: "٢" },
          { type: "static", emoji: "٣" },
          { type: "static", emoji: "٤" },
          { type: "interactive", emojis: ["؟", "٥", "٦"] },
          { type: "interactive", emojis: ["؟", "٥", "٦"] },
          { type: "static", emoji: "٧" }
        ],
        correctAnswer: ["٥", "٦"],
        successMessage: "✅ ممتاز! ١، ٢، ٣، ٤، ٥، ٦، ٧.",
        errorMessage: "❌ ما هي الأعداد التي تأتي بعد ٤ وقبل ٧؟"
      },
      {
        id: "l17_ex2",
        type: "click-cycle-emoji",
        title: "🔢 أكمل العد التنازلي",
        instruction: "انقر على المربعات الفارغة لإكمال الأعداد بالترتيب التنازلي.",
        backgroundColor: "#F0F8FF",
        pattern: [
          { type: "static", emoji: "٥" },
          { type: "static", emoji: "٤" },
          { type: "interactive", emojis: ["؟", "٣", "٢"] },
          { type: "interactive", emojis: ["؟", "٣", "٢"] },
          { type: "static", emoji: "١" }
        ],
        correctAnswer: ["٣", "٢"],
        successMessage: "✅ رائع! ٥، ٤، ٣، ٢، ١.",
        errorMessage: "❌ نحن نعد تنازلياً (إلى الخلف). ٥، ٤، ...؟"
      }
    ]
  },
  18: {
    title: "الفصل ٤ - الدرس ٤: العددان ١١ و ١٢",
    exercises: [
      {
        id: "l18_ex1",
        type: "count-and-input",
        title: "🌳 عد واكتب العدد",
        instruction: "عد الأشياء في كل مجموعة واختر العدد الصحيح.",
        groups: [
          { emoji: "🌳", count: 12 },
          { emoji: "🎁", count: 12 },
          { emoji: "🎈", count: 11 }
        ],
        numbers: ["؟", "١٠", "١١", "١٢"],
        correctAnswer: ["١٢", "١٢", "١١"],
        successMessage: "✅ عد ممتاز! ١٢، ١٢، ١١.",
        errorMessage: "❌ أعد العد. انتبه للأعداد الجديدة ١١ و ١٢."
      }
    ]
  },
  19: {
    title: "الفصل ٤ - الدرس ٥: مكونات العددين ١١ و ١٢",
    exercises: [
      {
        id: "l19_ex1",
        type: "select-option",
        title: "🍏 مكونات العدد ١١",
        instruction: "كم يساوي ٥ + ٦؟",
        pattern: [
          { type: "static", emoji: "٥" },
          { type: "static", emoji: "+" },
          { type: "static", emoji: "٦" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["١٠", "١١", "١٢"],
        correctAnswer: "١١",
        successMessage: "✅ صحيح! ٥ + ٦ = ١١",
        errorMessage: "❌ ٥ زائد ٦، كم المجموع؟"
      },
      {
        id: "l19_ex2",
        type: "select-option",
        title: "🍏 مكونات العدد ١٢",
        instruction: "كم يساوي ٥ + ٧؟",
        pattern: [
          { type: "static", emoji: "٥" },
          { type: "static", emoji: "+" },
          { type: "static", emoji: "٧" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["١٠", "١١", "١٢"],
        correctAnswer: "١٢",
        successMessage: "✅ صحيح! ٥ + ٧ = ١٢",
        errorMessage: "❌ ٥ زائد ٧، كم المجموع؟"
      }
    ]
  },
  20: {
    title: "الفصل ٤ - الدرس ٦: الأكبر والأصغر",
    exercises: [
      {
        id: "l20_ex1",
        type: "multi-select",
        title: "🐝 اختر المجموعة الأكبر",
        instruction: "اختر المجموعة التي تحتوي على (العدد الأكبر).",
        items: [
          { emoji: "🐝🐝🐝🐝🐝🐝", label: "٦ نحلات", correct: false },
          { emoji: "🐝🐝🐝🐝🐝🐝🐝🐝", label: "٨ نحلات", correct: true }
        ],
        successMessage: "✅ صحيح! ٨ أكبر من ٦.",
        errorMessage: "❌ أي مجموعة فيها نحل أكثر؟"
      },
      {
        id: "l20_ex2",
        type: "select-option",
        title: "⚖️ قارن الأعداد",
        instruction: "اختر الإشارة المناسبة: ٧ ؟ ٩",
        pattern: [
          { type: "static", emoji: "٧" },
          { type: "missing", placeholder: "؟" },
          { type: "static", emoji: "٩" }
        ],
        options: ["<", ">", "="],
        correctAnswer: "<",
        successMessage: "✅ صحيح! ٧ أصغر من ٩.",
        errorMessage: "❌ هل ٧ أكبر أم أصغر من ٩؟"
      },
      {
        id: "l20_ex3",
        type: "select-option",
        title: "⚖️ قارن الأعداد",
        instruction: "اختر الإشارة المناسبة: ١١ ؟ ١٠",
        pattern: [
          { type: "static", emoji: "١١" },
          { type: "missing", placeholder: "؟" },
          { type: "static", emoji: "١٠" }
        ],
        options: ["<", ">", "="],
        correctAnswer: ">",
        successMessage: "✅ صحيح! ١١ أكبر من ١٠.",
        errorMessage: "❌ هل ١١ أكبر أم أصغر من ١٠؟"
      }
    ]
  },
  21: {
    title: "الفصل ٥ - الدرس ١: استكشاف الجمع",
    exercises: [
      {
        id: "l21_ex1",
        type: "select-option",
        title: "🐼 استكشف الجمع",
        instruction: "٣ فهود + ٢ فهود = ؟",
        pattern: [
          { type: "static", emoji: "٣" },
          { type: "static", emoji: "+" },
          { type: "static", emoji: "٢" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["٣", "٤", "٥", "٦"],
        correctAnswer: "٥",
        successMessage: "✅ صحيح! ٣ + ٢ = ٥",
        errorMessage: "❌ كم مجموع ٣ و ٢ معاً؟"
      },
      {
        id: "l21_ex2",
        type: "click-cycle-emoji",
        title: "🎈 اكتب عبارة الجمع",
        instruction: "أكمل عبارة الجمع. كم عدد البالونات الزرقاء والوردية معاً؟",
        backgroundColor: "#F8F8FF",
        pattern: [
          { type: "interactive", emojis: ["؟", "١", "٢"] },
          { type: "static", emoji: "+" },
          { type: "interactive", emojis: ["؟", "١", "٢"] },
          { type: "static", emoji: "=" },
          { type: "interactive", emojis: ["؟", "٣", "٤"] }
        ],
        correctAnswer: ["٢", "٢", "٤"],
        successMessage: "✅ ممتاز! ٢ + ٢ = ٤",
        errorMessage: "❌ عد كل مجموعة، ثم المجموع الكلي."
      }
    ]
  },
  22: {
    title: "الفصل ٥ - الدرس ٢: الجمع الأفقي والعمودي",
    exercises: [
      {
        id: "l22_ex1",
        type: "select-option",
        title: "🦆 الجمع الأفقي",
        instruction: "كم يساوي ٢ + ٢؟",
        pattern: [
          { type: "static", emoji: "٢" },
          { type: "static", emoji: "+" },
          { type: "static", emoji: "٢" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["٢", "٣", "٤"],
        correctAnswer: "٤",
        successMessage: "✅ صحيح! ٢ + ٢ = ٤",
        errorMessage: "❌ ٢ زائد ٢ يساوي كم؟"
      },
      {
        id: "l22_ex2",
        type: "select-option",
        title: "🦆 الجمع العمودي",
        instruction: "كم يساوي ٢ + ٢؟ (بشكل عمودي)",
        pattern: [
          { type: "static", emoji: "٢" },
          { type: "static", emoji: "+" },
          { type: "static", emoji: "٢" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["٢", "٣", "٤"],
        correctAnswer: "٤",
        successMessage: "✅ صحيح! الجمع العمودي يعطي نفس الناتج ٤.",
        errorMessage: "❌ الناتج لا يتغير سواء كان الجمع أفقي أم عمودي."
      }
    ]
  },
  23: {
    title: "الفصل ٥ - الدرس ٣: استكشاف الطرح",
    exercises: [
      {
        id: "l23_ex1",
        type: "select-option",
        title: "🎈 ما هو ناتج الطرح؟",
        instruction: "كان هناك ٦ بالونات، تم شطب ٢. كم بقي؟ (٦ - ٢ = ؟)",
        pattern: [
          { type: "static", emoji: "٦" },
          { type: "static", emoji: "-" },
          { type: "static", emoji: "٢" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["٣", "٤", "٥", "٦"],
        correctAnswer: "٤",
        successMessage: "✅ صحيح! ٦ - ٢ = ٤",
        errorMessage: "❌ ٦ ناقص ٢، كم يبقى؟"
      },
      {
        id: "l23_ex2",
        type: "click-cycle-emoji",
        title: "🦋 اكتب عبارة الطرح",
        instruction: "كان هناك ٥ فراشات، طارت واحدة (شطبت). كم بقي؟",
        backgroundColor: "#F5FFFA",
        pattern: [
          { type: "static", emoji: "٥" },
          { type: "static", emoji: "-" },
          { type: "static", emoji: "١" },
          { type: "static", emoji: "=" },
          { type: "interactive", emojis: ["؟", "٣", "٤", "٥"] }
        ],
        correctAnswer: ["٤"],
        successMessage: "✅ ممتاز! ٥ - ١ = ٤",
        errorMessage: "❌ ٥ ناقص ١، كم يبقى؟"
      }
    ]
  },
  24: {
    title: "الفصل ٥ - الدرس ٤: الطرح الأفقي والعمودي",
    exercises: [
      {
        id: "l24_ex1",
        type: "select-option",
        title: "🦆 الطرح الأفقي",
        instruction: "كان هناك ٣ بطات، طارت واحدة. كم بقي؟ (٣ - ١ = ؟)",
        pattern: [
          { type: "static", emoji: "٣" },
          { type: "static", emoji: "-" },
          { type: "static", emoji: "١" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["١", "٢", "٣"],
        correctAnswer: "٢",
        successMessage: "✅ صحيح! ٣ - ١ = ٢",
        errorMessage: "❌ ٣ ناقص ١، كم يبقى؟"
      },
      {
        id: "l24_ex2",
        type: "select-option",
        title: "🦆 الطرح العمودي",
        instruction: "كم يساوي ٣ - ١؟ (بشكل عمودي)",
        pattern: [
          { type: "static", emoji: "٣" },
          { type: "static", emoji: "-" },
          { type: "static", emoji: "١" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["١", "٢", "٣"],
        correctAnswer: "٢",
        successMessage: "✅ صحيح! الطرح العمودي يعطي نفس الناتج ٢.",
        errorMessage: "❌ الناتج لا يتغير سواء كان الطرح أفقي أم عمودي."
      }
    ]
  },
  25: {
    title: "الفصل ٥ - الدرس ٥: حل المسائل باستعمال الجمع",
    exercises: [
      {
        id: "l25_ex1",
        type: "select-option",
        title: "🐠 حل المسألة",
        instruction: "كم عدد السمك الأصفر والأزرق معاً في الحوض؟ (٤ + ٢ = ؟)",
        pattern: [
          { type: "static", emoji: "٤" },
          { type: "static", emoji: "+" },
          { type: "static", emoji: "٢" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["٤", "٥", "٦", "٧"],
        correctAnswer: "٦",
        successMessage: "✅ صحيح! ٤ + ٢ = ٦",
        errorMessage: "❌ ٤ زائد ٢، كم المجموع؟"
      },
      {
        id: "l25_ex2",
        type: "select-option",
        title: "🐠 حل المسألة",
        instruction: "كم عدد السمك الأحمر والأخضر معاً؟ (٣ + ٣ = ؟)",
        pattern: [
          { type: "static", emoji: "٣" },
          { type: "static", emoji: "+" },
          { type: "static", emoji: "٣" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["٤", "٥", "٦", "٧"],
        correctAnswer: "٦",
        successMessage: "✅ صحيح! ٣ + ٣ = ٦",
        errorMessage: "❌ ٣ زائد ٣، كم المجموع؟"
      }
    ]
  },
  26: {
    title: "الفصل ٦ - الدرس ١: الجمع عملية تبديلية",
    exercises: [
      {
        id: "l26_ex1",
        type: "select-option",
        title: "🔴+🟢=؟",
        instruction: "كم يساوي ٤ + ١؟",
        pattern: [
          { type: "static", emoji: "٤" },
          { type: "static", emoji: "+" },
          { type: "static", emoji: "١" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["٤", "٥", "٦"],
        correctAnswer: "٥",
        successMessage: "✅ صحيح! ٤ + ١ = ٥",
        errorMessage: "❌ أعد العد."
      },
      {
        id: "l26_ex2",
        type: "select-option",
        title: "🟢+🔴=؟",
        instruction: "كم يساوي ١ + ٤؟",
        pattern: [
          { type: "static", emoji: "١" },
          { type: "static", emoji: "+" },
          { type: "static", emoji: "٤" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["٤", "٥", "٦"],
        correctAnswer: "٥",
        successMessage: "✅ صحيح! ١ + ٤ = ٥. نفس الناتج!",
        errorMessage: "❌ أعد العد. هل الناتج يختلف؟"
      }
    ]
  },
  27: {
    title: "الفصل ٦ - الدرس ٢: جمع العدد إلى نفسه",
    exercises: [
      {
        id: "l27_ex1",
        type: "select-option",
        title: "➕ جمع العدد إلى نفسه",
        instruction: "كم يساوي ٣ + ٣؟",
        pattern: [
          { type: "static", emoji: "٣" },
          { type: "static", emoji: "+" },
          { type: "static", emoji: "٣" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["٤", "٥", "٦", "٧"],
        correctAnswer: "٦",
        successMessage: "✅ صحيح! ٣ + ٣ = ٦",
        errorMessage: "❌ ٣ زائد ٣، كم المجموع؟"
      },
      {
        id: "l27_ex2",
        type: "select-option",
        title: "➕ جمع العدد إلى نفسه",
        instruction: "كم يساوي ٥ + ٥؟",
        backgroundColor: "#FFFFE0",
        pattern: [
          { type: "static", emoji: "٥" },
          { type: "static", emoji: "+" },
          { type: "static", emoji: "٥" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["٨", "٩", "١٠", "١١"],
        correctAnswer: "١٠",
        successMessage: "✅ صحيح! ٥ + ٥ = ١٠",
        errorMessage: "❌ ٥ زائد ٥، كم المجموع؟"
      }
    ]
  },
  28: {
    title: "الفصل ٦ - الدرس ٣: الجمع على مستقيم الأعداد",
    exercises: [
      {
        id: "l28_ex1",
        type: "select-option",
        title: "📏 الجمع على مستقيم الأعداد",
        instruction: "ابدأ عند ٥ واقفز ٣ خطوات. أين تصل؟ (٥ + ٣ = ؟)",
        pattern: [
          { type: "static", emoji: "٥" },
          { type: "static", emoji: "+" },
          { type: "static", emoji: "٣" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["٦", "٧", "٨", "٩"],
        correctAnswer: "٨",
        successMessage: "✅ صحيح! ٥ + ٣ = ٨",
        errorMessage: "❌ ٥... ٦، ٧، ٨. تصل عند ٨."
      }
    ]
  },
  29: {
    title: "الفصل ٦ - الدرس ٤: الطرح على مستقيم الأعداد",
    exercises: [
      {
        id: "l29_ex1",
        type: "select-option",
        title: "📏 الطرح على مستقيم الأعداد",
        instruction: "ابدأ عند ٨ وارجع خطوتين. أين تصل؟ (٨ - ٢ = ؟)",
        pattern: [
          { type: "static", emoji: "٨" },
          { type: "static", emoji: "-" },
          { type: "static", emoji: "٢" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["٥", "٦", "٧", "٨"],
        correctAnswer: "٦",
        successMessage: "✅ صحيح! ٨ - ٢ = ٦",
        errorMessage: "❌ ٨... ٧، ٦. تصل عند ٦."
      }
    ]
  },
  30: {
    title: "الفصل ٦ - الدرس ٥: حل المسائل",
    exercises: [
      {
        id: "l30_ex1",
        type: "select-option",
        title: "🖍️ حل المسألة (جمع)",
        instruction: "في علبة ٤ أقلام. أضافت التلميذة ٣ أقلام. كم أصبح المجموع؟ (٤ + ٣ = ؟)",
        pattern: [
          { type: "static", emoji: "٤" },
          { type: "static", emoji: "+" },
          { type: "static", emoji: "٣" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["٥", "٦", "٧", "٨"],
        correctAnswer: "٧",
        successMessage: "✅ صحيح! ٤ + ٣ = ٧",
        errorMessage: "❌ هذه مسألة جمع. ٤ زائد ٣."
      },
      {
        id: "l30_ex2",
        type: "select-option",
        title: "✏️ حل المسألة (طرح)",
        instruction: "مع ليلى ٧ أقلام، أعطت زميلتها ٣. كم بقي معها؟ (٧ - ٣ = ؟)",
        pattern: [
          { type: "static", emoji: "٧" },
          { type: "static", emoji: "-" },
          { type: "static", emoji: "٣" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["٣", "٤", "٥", "٦"],
        correctAnswer: "٤",
        successMessage: "✅ صحيح! ٧ - ٣ = ٤",
        errorMessage: "❌ هذه مسألة طرح. ٧ ناقص ٣."
      }
    ]
  },
  31: {
    title: "الفصل ٦ - الدرس ٦: الأعداد الترتيبية",
    exercises: [
      {
        id: "l31_ex1",
        type: "multi-select",
        title: "🎈 الأعداد الترتيبية",
        instruction: "اختر البالون (الثالث) من اليمين.",
        backgroundColor: "#F5F5F5",
        items: [
          { emoji: "🟡", label: "الأول", correct: false },
          { emoji: "🟢", label: "الثاني", correct: false },
          { emoji: "⚫", label: "الثالث", correct: true },
          { emoji: "🟠", label: "الرابع", correct: false },
          { emoji: "🟣", label: "الخامس", correct: false }
        ],
        successMessage: "✅ صحيح! هذا هو البالون الثالث.",
        errorMessage: "❌ عد بالترتيب: الأول، الثاني، الثالث..."
      },
      {
        id: "l31_ex2",
        type: "multi-select",
        title: "🚗 الأعداد الترتيبية",
        instruction: "اختر السيارة (الخامسة) من اليمين.",
        items: [
          { emoji: "🚗", label: "الأولى", correct: false },
          { emoji: "🚗", label: "الثانية", correct: false },
          { emoji: "🚗", label: "الثالثة", correct: false },
          { emoji: "🚗", label: "الرابعة", correct: false },
          { emoji: "🚗", label: "الخامسة", correct: true }
        ],
        successMessage: "✅ صحيح! هذه هي السيارة الخامسة.",
        errorMessage: "❌ عد السيارات بالترتيب من اليمين."
      }
    ]
  },
  32: {
    title: "الفصل ٧ - الدرس ١: المجسمات",
    exercises: [
      {
        id: "l32_ex1",
        type: "multi-select",
        title: "🧊 ما هو المجسم؟",
        instruction: "اختر كل الأشياء التي شكلها (مكعب).",
        items: [
          { emoji: "🎉", label: "قبعة", correct: false },
          { emoji: "🎲", label: "نرد", correct: true },
          { emoji: "⚽", label: "كرة", correct: false },
          { emoji: "🧊", label: "مكعب ثلج", correct: true },
          { emoji: "🎁", label: "هدية", correct: true }
        ],
        successMessage: "✅ صحيح! النرد والهدية ومكعب الثلج كلها مكعبات.",
        errorMessage: "❌ أي من هذه الأشكال يشبه الصندوق؟"
      },
      {
        id: "l32_ex2",
        type: "multi-select",
        title: "⚽ ما هو المجسم؟",
        instruction: "اختر كل الأشياء التي شكلها (كرة).",
        backgroundColor: "#E0FFFF",
        items: [
          { emoji: "🎉", label: "قبعة", correct: false },
          { emoji: "🎲", label: "نرد", correct: false },
          { emoji: "⚽", label: "كرة قدم", correct: true },
          { emoji: "🎾", label: "كرة تنس", correct: true },
          { emoji: "🍊", label: "برتقالة", correct: true }
        ],
        successMessage: "✅ صحيح! كلها أشياء كروية.",
        errorMessage: "❌ أي من هذه الأشكال مستدير مثل الكرة؟"
      }
    ]
  },
  33: {
    title: "الفصل ٧ - الدرس ٢: الأشكال الهندسية",
    exercises: [
      {
        id: "l33_ex1",
        type: "select-option",
        title: "△ ما هو الشكل؟",
        instruction: "ما هو اسم هذا الشكل: △؟",
        pattern: [
          { type: "static", emoji: "△" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["مربع", "دائرة", "مثلث", "مستطيل"],
        correctAnswer: "مثلث",
        successMessage: "✅ صحيح! هذا (مثلث).",
        errorMessage: "❌ هذا الشكل له ٣ أضلاع."
      },
      {
        id: "l33_ex2",
        type: "select-option",
        title: "🟥 ما هو الشكل؟",
        instruction: "ما هو اسم هذا الشكل: 🟥؟",
        pattern: [
          { type: "static", emoji: "🟥" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["مربع", "دائرة", "مثلث", "مستطيل"],
        correctAnswer: "مربع",
        successMessage: "✅ صحيح! هذا (مربع).",
        errorMessage: "❌ هذا الشكل له ٤ أضلاع متساوية."
      },
      {
        id: "l33_ex3",
        type: "select-option",
        title: "🔵 ما هو الشكل؟",
        instruction: "ما هو اسم هذا الشكل: 🔵؟",
        pattern: [
          { type: "static", emoji: "🔵" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["مربع", "دائرة", "مثلث", "مستطيل"],
        correctAnswer: "دائرة",
        successMessage: "✅ صحيح! هذه (دائرة).",
        errorMessage: "❌ هذا الشكل مستدير."
      }
    ]
  },
  34: {
    title: "الفصل ٧ - الدرس ٣: التطابق",
    exercises: [
      {
        id: "l34_ex1",
        type: "multi-select",
        title: "⭐ تمرين النجوم",
        instruction: "اختر كل الأشكال المتطابقة (لها نفس الشكل ونفس الحجم).",
        items: [
          { emoji: "✨", label: "نجمة رباعية كبيرة", correct: true },
          { emoji: "⭐", label: "نجمة خماسية كبيرة", correct: false },
          { emoji: "▫️", label: "نجمة رباعية صغيرة", correct: false },
          { emoji: "✨", label: "نجمة رباعية كبيرة", correct: true }
        ],
        successMessage: "✅ صحيح! المتطابقان لهما نفس الشكل ونفس الحجم.",
        errorMessage: "❌ تذكر: التطابق = نفس الشكل + نفس الحجم."
      },
      {
        id: "l34_ex2",
        type: "multi-select",
        title: "🔵 تمرين الدوائر",
        instruction: "اختر كل الأشكال المتطابقة (لها نفس الشكل ونفس الحجم).",
        backgroundColor: "#F0F8FF",
        items: [
          { emoji: "🔵", label: "دائرة كبيرة", correct: true },
          { emoji: "🔵", label: "دائرة كبيرة", correct: true },
          { emoji: "▫️", label: "دائرة صغيرة", correct: false },
          { emoji: "🔵", label: "دائرة كبيرة", correct: true }
        ],
        successMessage: "✅ أحسنت! الدوائر الكبيرة متطابقة.",
        errorMessage: "❌ انتبه للحجم! الدائرة الصغيرة ليست مطابقة للكبيرة."
      },
      {
        id: "l34_ex3",
        type: "multi-select",
        title: "↔️ تمرين الأسهم",
        instruction: "اختر كل الأشكال المتطابقة (لها نفس الشكل ونفس الحجم).",
        items: [
          { emoji: "↔️", label: "سهم مزدوج", correct: false },
          { emoji: "⬇️", label: "سهم لأسفل", correct: false },
          { emoji: "⬆️", label: "سهم لأعلى", correct: false },
          { emoji: "⬅️", label: "سهم لليسار", correct: false }
        ],
        successMessage: "✅ صحيح! لا يوجد أي سهمين متطابقين هنا. كلها مختلفة.",
        errorMessage: "❌ فكّر مرة أخرى. هل ترى أي سهمين لهما نفس الشكل والاتجاه والحجم؟"
      }
    ]
  },
  35:{
    "title": "الفصل ٨ - الدرس ١: استكشاف الأجزاء المتساوية",
    "exercises": [
      {
        "id": "l35_ex1",
        "type": "multi-select",
        "title": "🤔 أي الأشكال أجزاؤه متساوية؟",
        "instruction": "اختر كل الأشكال المقسمة إلى أجزاء متساوية.",
        "items": [
          { "emoji": "🔵", "label": "دائرة مقسمة بالتساوي", "correct": true },
          { "emoji": "🔺", "label": "مثلث مقسم بالتساوي", "correct": true },
          { "emoji": "🍫", "label": "مستطيل غير متساوي", "correct": false }
        ],
        "successMessage": "✅ صحيح! الأجزاء المتساوية لها نفس الحجم.",
        "errorMessage": "❌ المستطيل أجزاؤه غير متساوية."
      },
      {
        "id": "l35_ex2",
        "type": "multi-select",
        "title": "🍕 اختر الوصف الصحيح",
        "instruction": "هل أجزاء البيتزا متساوية أم غير متساوية؟",
        "items": [
          { "emoji": "🍕", "label": "أجزاء متساوية", "correct": true },
          { "emoji": "🍕", "label": "أجزاء غير متساوية", "correct": false }
        ],
        "successMessage": "✅ أحسنت! هذه الأجزاء متساوية.",
        "errorMessage": "❌ انظر جيداً، كل الأجزاء بنفس الحجم."
      },
      {
        "id": "l35_ex3",
        "type": "count-and-input",
        "title": "🔢 اكتب عدد الأجزاء المتساوية",
        "instruction": "عد الأجزاء المتساوية في كل شكل واكتب العدد.",
        "groups": [
          { "emoji": "🟧", "count": 2 },
          { "emoji": "🟩", "count": 4 },
          { "emoji": "🟦", "count": 3 }
        ],
        "numbers": ["؟", "١", "٢", "٣", "٤"],
        "correctAnswer": ["٢", "٤", "٣"],
        "successMessage": "✅ عد رائع!",
        "errorMessage": "❌ أعد عد الأجزاء في كل شكل."
      }
    ]
  },
  36:{
    "title": "الفصل ٨ - الدرس ٢: النصف",
    "exercises": [
      {
        "id": "l36_ex1",
        "type": "multi-select",
        "title": "🌗 اختر الأشكال التي تمثل النصف (١/٢)",
        "instruction": "النصف هو واحد من جزأين متطابقين.",
        "items": [
          { "emoji": "🌓", "label": "نصف دائرة", "correct": true },
          { "emoji": "🟥", "label": "نصف مربع", "correct": true },
          { "emoji": "🔺", "label": "مثلث مقسم لثلاثة", "correct": false },
          { "emoji": "🟪", "label": "نصف مستطيل", "correct": true }
        ],
        "successMessage": "✅ ممتاز! لقد عرفت النصف.",
        "errorMessage": "❌ النصف يعني أن الشكل مقسوم إلى جزأين متطابقين."
      },
      {
        "id": "l36_ex2",
        "type": "select-option",
        "title": "🍰 ماذا نسمي الجزء الباقي؟",
        "instruction": "أكل سامر نصف قطعة الحلوى. ماذا نسمي الجزء الباقي؟",
        "pattern": [
          { "type": "static", "emoji": "🍰" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["نصف", "ربع", "كامل"],
        "correctAnswer": "نصف",
        "successMessage": "✅ صحيح! النصف الآخر يبقى.",
        "errorMessage": "❌ إذا ذهب النصف، يبقى..."
      }
    ]
  },
  37:{
    "title": "الفصل ٨ - الدرس ٣: الربع",
    "exercises": [
      {
        "id": "l37_ex1",
        "type": "multi-select",
        "title": "🟩 اختر الأشكال التي تمثل الربع (١/٤)",
        "instruction": "الربع هو واحد من أربعة أجزاء متطابقة.",
        "items": [
          { "emoji": "🟩", "label": "ربع مربع", "correct": true },
          { "emoji": "🟢", "label": "ربع دائرة", "correct": true },
          { "emoji": "🟨", "label": "ربع مستطيل", "correct": true },
          { "emoji": "🔺", "label": "نصف مثلث", "correct": false }
        ],
        "successMessage": "✅ أحسنت! هذا هو الربع.",
        "errorMessage": "❌ الربع يعني أن الشكل مقسوم إلى أربعة أجزاء متطابقة."
      },
      {
        "id": "l37_ex2",
        "type": "multi-select",
        "title": "✅ اختر العبارة الصحيحة",
        "instruction": "أي عبارة تصف الربع بشكل صحيح؟",
        "items": [
          { "emoji": "✅", "label": "الربع هو جزء من أربعة أجزاء متطابقة", "correct": true },
          { "emoji": "❌", "label": "الربع هو جزء من جزأين", "correct": false },
          { "emoji": "❌", "label": "النصف هو جزء من أربعة أجزاء", "correct": false }
        ],
        "successMessage": "✅ صحيح! الربع هو ١ من ٤ أجزاء متطابقة.",
        "errorMessage": "❌ فكر مرة أخرى. ما معنى كلمة (ربع)؟"
      }
    ]
  },
  38:{
    "title": "الفصل ٩ - الدرس ١: الأعداد من ١٠ إلى ١٩",
    "exercises": [
      {
        "id": "l38_ex1",
        "type": "count-and-input",
        "title": "🔢 اكتب العدد الممثل بلوحة العشرة",
        "instruction": "لوحة عشرة ممتلئة = ١٠. عد الباقي واكتب العدد.",
        "groups": [
          { "emoji": "🔴", "count": 14 },
          { "emoji": "🔴", "count": 17 },
          { "emoji": "🔴", "count": 19 }
        ],
        "numbers": ["؟", "١٣", "١٤", "١٥", "١٦", "١٧", "١٨", "١٩"],
        "correctAnswer": ["١٤", "١٧", "١٩"],
        "successMessage": "✅ عد رائع!",
        "errorMessage": "❌ تذكر، اللوحة الممتلئة هي ١٠."
      },
      {
        "id": "l38_ex2",
        "type": "click-cycle-emoji",
        "title": "🔢 أكمل الأعداد بالترتيب",
        "instruction": "املأ الفراغات بالعدد المناسب.",
        "pattern": [
          { "type": "static", "emoji": "١٦" },
          { "type": "static", "emoji": "١٧" },
          { "type": "interactive", "emojis": ["؟", "١٨", "١٩"] },
          { "type": "interactive", "emojis": ["؟", "١٨", "١٩"] }
        ],
        "correctAnswer": ["١٨", "١٩"],
        "successMessage": "✅ ممتاز! ١٦، ١٧، ١٨، ١٩.",
        "errorMessage": "❌ ما الذي يأتي بعد ١٧؟"
      }
    ]
  },
  39:{
    "title": "الفصل ٩ - الدرس ٢: مكونات الأعداد",
    "exercises": [
      {
        "id": "l39_ex1",
        "type": "select-option",
        "title": "➕ أي من التالي من مكونات العدد ١٣؟",
        "instruction": "اختر المجموع الصحيح للعدد ١٣.",
        "pattern": [
          { "type": "static", "emoji": "١٣" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["١٠ + ٣", "٥ + ٧", "٩ + ٥"],
        "correctAnswer": "١٠ + ٣",
        "successMessage": "✅ صحيح! ١٠ + ٣ = ١٣.",
        "errorMessage": "❌ أي عددين مجموعهما ١٣؟"
      },
      {
        "id": "l39_ex2",
        "type": "select-option",
        "title": "اختر الإجابة الصحيحة: ٧ + ٨ = ؟",
        "instruction": "كم يساوي ٧ زائد ٨؟",
        "pattern": [
          { "type": "static", "emoji": "٧" },
          { "type": "static", "emoji": "+" },
          { "type": "static", "emoji": "٨" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["١٣", "١٤", "١٥", "١٦"],
        "correctAnswer": "١٥",
        "successMessage": "✅ صحيح! ٧ + ٨ = ١٥.",
        "errorMessage": "❌ حاول مرة أخرى. ٧ + ٨."
      },
      {
        "id": "l39_ex3",
        "type": "select-option",
        "title": "اختر الإجابة الصحيحة: ٤ + ١٣ = ؟",
        "instruction": "كم يساوي ٤ زائد ١٣؟",
        "pattern": [
          { "type": "static", "emoji": "٤" },
          { "type": "static", "emoji": "+" },
          { "type": "static", "emoji": "١٣" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["١٦", "١٧", "١٨", "١٩"],
        "correctAnswer": "١٧",
        "successMessage": "✅ صحيح! ٤ + ١٣ = ١٧.",
        "errorMessage": "❌ حاول مرة أخرى. ٤ + ١٣."
      }
    ]
  },
  40:{
    "title": "الفصل ٩ - الدرس ٣: مقارنة الأعداد حتى ١٩",
    "exercises": [
      {
        "id": "l40_ex1",
        "type": "select-option",
        "title": "⚖️ قارن: ١٣ ؟ ١٥",
        "instruction": "اختر الإشارة المناسبة.",
        "pattern": [
          { "type": "static", "emoji": "١٣" },
          { "type": "missing", "placeholder": "؟" },
          { "type": "static", "emoji": "١٥" }
        ],
        "options": ["<", ">", "="],
        "correctAnswer": "<",
        "successMessage": "✅ صحيح! ١٣ أصغر من ١٥.",
        "errorMessage": "❌ هل ١٣ أكبر أم أصغر من ١٥؟"
      },
      {
        "id": "l40_ex2",
        "type": "multi-select",
        "title": "⬆️ اختر العدد الأكبر",
        "instruction": "اختر العدد الأكبر بين ١٩ و ١١.",
        "items": [
          { "emoji": "١٩", "label": "19", "correct": true },
          { "emoji": "١١", "label": "11", "correct": false }
        ],
        "successMessage": "✅ صحيح! ١٩ هو الأكبر.",
        "errorMessage": "❌ أي العددين أكبر؟"
      },
      {
        "id": "l40_ex3",
        "type": "multi-select",
        "title": "⬇️ اختر العدد الأصغر",
        "instruction": "اختر العدد الأصغر بين ١٣ و ١٦.",
        "items": [
          { "emoji": "١٣", "label": "13", "correct": true },
          { "emoji": "١٦", "label": "16", "correct": false }
        ],
        "successMessage": "✅ صحيح! ١٣ هو الأصغر.",
        "errorMessage": "❌ أي العددين أصغر؟"
      }
    ]
  },
  41:{
    "title": "الفصل ٩ - الدرس ٤: الجمع بالإتمام إلى عشرة",
    "exercises": [
      {
        "id": "l41_ex1",
        "type": "select-option",
        "title": "➕ الجمع بالإتمام إلى ١٠",
        "instruction": "لإيجاد ناتج ٩ + ٤، نكمل ٩ إلى ١٠ (بأخذ ١ من ٤). ماذا يصبح الناتج؟ (١٠ + ٣ = ؟)",
        "pattern": [
          { "type": "static", "emoji": "٩" },
          { "type": "static", "emoji": "+" },
          { "type": "static", "emoji": "٤" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["١٢", "١٣", "١٤"],
        "correctAnswer": "١٣",
        "successMessage": "✅ صحيح! ٩ + ٤ = ١٠ + ٣ = ١٣.",
        "errorMessage": "❌ ٩ تحتاج ١ لتصبح ١٠. نأخذ ١ من ٤ يتبقى ٣. يصبح ١٠ + ٣."
      },
      {
        "id": "l41_ex2",
        "type": "click-cycle-emoji",
        "title": "🔟 أكمل لتكوين عشرة",
        "instruction": "كم نحتاج لنصل إلى ١٠؟",
        "pattern": [
          { "type": "static", "emoji": "٨" },
          { "type": "static", "emoji": "+" },
          { "type": "interactive", "emojis": ["؟", "١", "٢", "٣"] },
          { "type": "static", "emoji": "=" },
          { "type": "static", "emoji": "١٠" }
        ],
        "correctAnswer": ["٢"],
        "successMessage": "✅ صحيح! ٨ + ٢ = ١٠",
        "errorMessage": "❌ ٨ زائد كم يساوي ١٠؟"
      },
      {
        "id": "l41_ex3",
        "type": "select-option",
        "title": "➕ حل المسألة: ٥ + ٩ = ؟",
        "instruction": "استخدم طريقة الإتمام إلى عشرة إن أردت. (٩ + ٥ = ١٠ + ٤)",
        "pattern": [
          { "type": "static", "emoji": "٥" },
          { "type": "static", "emoji": "+" },
          { "type": "static", "emoji": "٩" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["١٣", "١٤", "١٥"],
        "correctAnswer": "١٤",
        "successMessage": "✅ صحيح! ٥ + ٩ = ١٤.",
        "errorMessage": "❌ حاول مرة أخرى."
      }
    ]
  },
  42:{
    "title": "الفصل ٩ - الدرس ٥: العلاقة بين الجمع والطرح",
    "exercises": [
      {
        "id": "l42_ex1",
        "type": "select-option",
        "title": "🤝 العلاقة بين الجمع والطرح",
        "instruction": "إذا كان ٦ + ٨ = ١٤، فما هو ناتج ١٤ - ٨؟",
        "pattern": [
          { "type": "static", "emoji": "١٤" },
          { "type": "static", "emoji": "-" },
          { "type": "static", "emoji": "٨" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٦", "٨", "١٤"],
        "correctAnswer": "٦",
        "successMessage": "✅ صحيح! لأن ٦ + ٨ = ١٤.",
        "errorMessage": "❌ انظر للمسألة الأصلية: ٦ + ٨ = ١٤."
      },
      {
        "id": "l42_ex2",
        "type": "select-option",
        "title": "🤝 العلاقة بين الجمع والطرح",
        "instruction": "إذا كان ٦ + ٨ = ١٤، فما هو ناتج ١٤ - ٦؟",
        "pattern": [
          { "type": "static", "emoji": "١٤" },
          { "type": "static", "emoji": "-" },
          { "type": "static", "emoji": "٦" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٦", "٨", "١٤"],
        "correctAnswer": "٨",
        "successMessage": "✅ صحيح! لأن ٨ + ٦ = ١٤.",
        "errorMessage": "❌ انظر للمسألة الأصلية: ٦ + ٨ = ١٤."
      },
      {
        "id": "l42_ex3",
        "type": "click-cycle-emoji",
        "title": "أكمل العبارة",
        "instruction": "٧ + ٨ = ١٥. إذن: ١٥ - ٧ = ؟",
        "pattern": [
          { "type": "static", "emoji": "١٥" },
          { "type": "static", "emoji": "-" },
          { "type": "static", "emoji": "٧" },
          { "type": "static", "emoji": "=" },
          { "type": "interactive", "emojis": ["؟", "٧", "٨", "١٥"] }
        ],
        "correctAnswer": ["٨"],
        "successMessage": "✅ ممتاز!",
        "errorMessage": "❌ ١٥ - ٧ = ؟"
      }
    ]
  },
  43:{
    "title": "الفصل ٩ - الدرس ٦: حل مسائل",
    "exercises": [
      {
        "id": "l43_ex1",
        "type": "select-option",
        "title": "🌸 مسألة جمع",
        "instruction": "قطفت حلا ٣ أزهار حمراء و ٧ صفراء. ما عدد الزهرات كلها؟ (٣ + ٧ = ؟)",
        "pattern": [
          { "type": "static", "emoji": "٣" },
          { "type": "static", "emoji": "+" },
          { "type": "static", "emoji": "٧" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٩", "١٠", "١١"],
        "correctAnswer": "١٠",
        "successMessage": "✅ صحيح! ٣ + ٧ = ١٠ زهرات.",
        "errorMessage": "❌ هذه مسألة جمع. ٣ زائد ٧."
      },
      {
        "id": "l43_ex2",
        "type": "select-option",
        "title": "🐦 مسألة طرح",
        "instruction": "في العش ٥ عصافير، طار منها ٢. كم بقي في العش؟ (٥ - ٢ = ؟)",
        "pattern": [
          { "type": "static", "emoji": "٥" },
          { "type": "static", "emoji": "-" },
          { "type": "static", "emoji": "٢" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٢", "٣", "٤"],
        "correctAnswer": "٣",
        "successMessage": "✅ صحيح! ٥ - ٢ = ٣ عصافير.",
        "errorMessage": "❌ هذه مسألة طرح. ٥ ناقص ٢."
      },
      {
        "id": "l43_ex3",
        "type": "select-option",
        "title": "🥤 مسألة طرح",
        "instruction": "يوجد على الطاولة ٨ كؤوس، ملأ أحمد ٤. كم كأساً بقيت فارغة؟ (٨ - ٤ = ؟)",
        "pattern": [
          { "type": "static", "emoji": "٨" },
          { "type": "static", "emoji": "-" },
          { "type": "static", "emoji": "٤" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٣", "٤", "٥"],
        "correctAnswer": "٤",
        "successMessage": "✅ صحيح! ٨ - ٤ = ٤ كؤوس فارغة.",
        "errorMessage": "❌ ٨ ناقص ٤."
      }
    ]
  },
  44:{
    "title": "الفصل ١٠ - الدرس ١: العد بالعشرات",
    "exercises": [
      {
        "id": "l44_ex1",
        "type": "select-option",
        "title": "🔢 العد بالعشرات",
        "instruction": "٥ عشرات = ؟",
        "pattern": [
          { "type": "static", "emoji": "٥٠" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٤٠", "٥٠", "٦٠"],
        "correctAnswer": "٥٠",
        "successMessage": "✅ صحيح! ٥ عشرات هي ٥٠.",
        "errorMessage": "❌ ١ عشرة = ١٠، ٢ عشرات = ٢٠..."
      },
      {
        "id": "l44_ex2",
        "type": "select-option",
        "title": "🔢 العد بالعشرات",
        "instruction": "٩ عشرات = ؟",
        "pattern": [
          { "type": "static", "emoji": "٩٠" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٧٠", "٨٠", "٩٠"],
        "correctAnswer": "٩٠",
        "successMessage": "✅ صحيح! ٩ عشرات هي ٩٠.",
        "errorMessage": "❌ ... ٨ عشرات = ٨٠، ٩ عشرات = ؟"
      },
      {
        "id": "l44_ex3",
        "type": "multi-select",
        "title": "🛒 ماذا أشتري؟",
        "instruction": "مع هديل ٦٠ ليرة. اختر كل ما تستطيع شراءه (سعر كل لعبة ٦٠ ليرة أو أقل).",
        "items": [
          { "emoji": "🚗 ٤٠ ليرة", "label": "سيارة (٤٠ ليرة)", "correct": true },
          { "emoji": "✈️ ٦٠ ليرة", "label": "طائرة (٦٠ ليرة)", "correct": true },
          { "emoji": "🦆 ٣٠ ليرة", "label": "بطة (٣٠ ليرة)", "correct": true },
          { "emoji": "🪀 ٢٠ ليرة", "label": "يويو (٢٠ ليرة)", "correct": true }
        ],
        "successMessage": "✅ صحيح! يمكنها شراء أي لعبة سعرها ٦٠ أو أقل.",
        "errorMessage": "❌ لديها ٦٠ ليرة. هل يمكنها شراء اللعبة؟"
      }
    ]
  },
  45:{
    "title": "الفصل ١٠ - الدرس ٢: الأعداد حتى ٩٩",
    "exercises": [
      {
        "id": "l45_ex1",
        "type": "select-option",
        "title": "🔢 الآحاد والعشرات",
        "instruction": "٤ آحاد و ٣ عشرات = ؟",
        "pattern": [
          { "type": "static", "emoji": "٤" },
          { "type": "static", "emoji": "و" },
          { "type": "static", "emoji": "٣٠" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٤٣", "٣٤", "٧"],
        "correctAnswer": "٣٤",
        "successMessage": "✅ صحيح! ٣ عشرات هي ٣٠، زائد ٤ = ٣٤.",
        "errorMessage": "❌ انتبه! ٣ هي العشرات."
      },
      {
        "id": "l45_ex2",
        "type": "multi-select",
        "title": "اختر العدد الصحيح",
        "instruction": "ما هو العدد الممثل بالمكعبات؟ (٦ عشرات، ٨ آحاد)",
        "items": [
          { "emoji": "٦٨", "label": "٦٨", "correct": true },
          { "emoji": "٨٦", "label": "٨٦", "correct": false },
          { "emoji": "٦٧", "label": "٦٧", "correct": false }
        ],
        "successMessage": "✅ صحيح! ٦ عشرات و ٨ آحاد.",
        "errorMessage": "❌ عد العشرات (الأعمدة) والآحاد (المكعبات المفردة)."
      }
    ]
  },
  46:{
    "title": "الفصل ١٠ - الدرس ٣: آحاد وعشرات حتى ٩٩",
    "exercises": [
      {
        "id": "l46_ex1",
        "type": "select-option",
        "title": "🔢 العدد ١٥",
        "instruction": "العدد ١٥. كم آحاد وكم عشرات؟",
        "pattern": [
          { "type": "static", "emoji": "١٥" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["١ آحاد، ٥ عشرات", "٥ آحاد، ١ عشرات"],
        "correctAnswer": "٥ آحاد، ١ عشرات",
        "successMessage": "✅ صحيح! ٥ في منزلة الآحاد، و ١ في منزلة العشرات.",
        "errorMessage": "❌ الرقم على اليمين هو الآحاد، وعلى اليسار هو العشرات."
      },
      {
        "id": "l46_ex2",
        "type": "select-option",
        "title": "❓ ما هو العدد؟",
        "instruction": "ما العدد الذي آحاده ٦ وعشراته ٣؟",
        "pattern": [
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٦٣", "٣٦"],
        "correctAnswer": "٣٦",
        "successMessage": "✅ صحيح! ٣ عشرات (٣٠) و ٦ آحاد = ٣٦.",
        "errorMessage": "❌ ٣ عشرات تعني ٣٠."
      },
      {
        "id": "l46_ex3",
        "type": "select-option",
        "title": "❓ لغز العدد",
        "instruction": "أنا عدد عشراتي ٨ وآحادي أصغر من عشراتي بـ ٣. فمن أنا؟",
        "pattern": [
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٣٨", "٨٣", "٨٥"],
        "correctAnswer": "٨٥",
        "successMessage": "✅ صحيح! العشرات ٨، الآحاد ٨ - ٣ = ٥. العدد هو ٨٥.",
        "errorMessage": "❌ العشرات ٨. الآحاد = ٨ ناقص ٣. كم يساوي؟"
      }
    ]
  },
  47:{
    "title": "الفصل ١٠ - الدرس ٤: مقارنة الأعداد حتى ٩٩",
    "exercises": [
      {
        "id": "l47_ex1",
        "type": "select-option",
        "title": "⚖️ كيف نقارن؟",
        "instruction": "للمقارنة بين ٦٥ و ٣٢، نبدأ بمنزلة...",
        "pattern": [
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["الآحاد", "العشرات"],
        "correctAnswer": "العشرات",
        "successMessage": "✅ صحيح! نبدأ دائماً بالمنزلة الأكبر (العشرات).",
        "errorMessage": "❌ نبدأ بالمنزلة التي لها القيمة الأكبر."
      },
      {
        "id": "l47_ex2",
        "type": "select-option",
        "title": "⚖️ قارن: ٦٥ ؟ ٣٢",
        "instruction": "اختر الإشارة المناسبة. (٦ عشرات أكبر من ٣ عشرات)",
        "pattern": [
          { "type": "static", "emoji": "٦٥" },
          { "type": "missing", "placeholder": "؟" },
          { "type": "static", "emoji": "٣٢" }
        ],
        "options": ["<", ">", "="],
        "correctAnswer": ">",
        "successMessage": "✅ صحيح! ٦٥ أكبر من ٣٢.",
        "errorMessage": "❌ ٦ عشرات أكبر من ٣ عشرات."
      },
      {
        "id": "l47_ex3",
        "type": "select-option",
        "title": "⚖️ قارن: ١٤ ؟ ١٦",
        "instruction": "اختر الإشارة المناسبة. (العشرات متساوية، نقارن الآحاد)",
        "pattern": [
          { "type": "static", "emoji": "١٤" },
          { "type": "missing", "placeholder": "؟" },
          { "type": "static", "emoji": "١٦" }
        ],
        "options": ["<", ">", "="],
        "correctAnswer": "<",
        "successMessage": "✅ صحيح! ١٤ أصغر من ١٦.",
        "errorMessage": "❌ العشرات (١) متساوية. ٤ آحاد أصغر من ٦ آحاد."
      }
    ]
  },
  48:{
    "title": "الفصل ١٠ - الدرس ٥: ترتيب الاعداد حتى ٩٩",
    "exercises": [
      {
        "id": "l48_ex1",
        "type": "select-option",
        "title": "⏮️ العدد السابق",
        "instruction": "ما العدد السابق للعدد ٤٧؟",
        "pattern": [
          { "type": "missing", "placeholder": "؟" },
          { "type": "static", "emoji": "٤٧" }
        ],
        "options": ["٤٦", "٤٧", "٤٨"],
        "correctAnswer": "٤٦",
        "successMessage": "✅ صحيح! ٤٦ يأتي قبل ٤٧.",
        "errorMessage": "❌ ما هو العدد الذي يأتي (قبل) ٤٧؟"
      },
      {
        "id": "l48_ex2",
        "type": "select-option",
        "title": "⏭️ العدد التالي",
        "instruction": "ما العدد التالي للعدد ١٤؟",
        "pattern": [
          { "type": "static", "emoji": "١٤" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["١٣", "١٤", "١٥"],
        "correctAnswer": "١٥",
        "successMessage": "✅ صحيح! ١٥ يأتي بعد ١٤.",
        "errorMessage": "❌ ما هو العدد الذي يأتي (بعد) ١٤؟"
      },
      {
        "id": "l48_ex3",
        "type": "select-option",
        "title": "⏸️ العدد البيني",
        "instruction": "ما العدد الذي يقع بين ٧٥ و ٧٧؟",
        "pattern": [
          { "type": "static", "emoji": "٧٥" },
          { "type": "missing", "placeholder": "؟" },
          { "type": "static", "emoji": "٧٧" }
        ],
        "options": ["٧٥", "٧٦", "٧٧"],
        "correctAnswer": "٧٦",
        "successMessage": "✅ صحيح! ٧٦ يقع بين ٧٥ و ٧٧.",
        "errorMessage": "❌ ٧٥... ؟ ... ٧٧"
      }
    ]
  },
  49:{
    "title": "الفصل ١٠ - الدرس ٦: العد التجاوزي بالاثنينات",
    "exercises": [
      {
        "id": "l49_ex1",
        "type": "click-cycle-emoji",
        "title": "🔢 أكمل العد بالاثنينات",
        "instruction": "٢، ٤، ...؟، ٨",
        "pattern": [
          { "type": "static", "emoji": "٢" },
          { "type": "static", "emoji": "٤" },
          { "type": "interactive", "emojis": ["؟", "٥", "٦", "٧"] },
          { "type": "static", "emoji": "٨" }
        ],
        "correctAnswer": ["٦"],
        "successMessage": "✅ صحيح! ٢، ٤، ٦، ٨.",
        "errorMessage": "❌ نحن نضيف ٢ في كل مرة."
      },
      {
        "id": "l49_ex2",
        "type": "click-cycle-emoji",
        "title": "🔢 أكمل العد بالاثنينات",
        "instruction": "١٤، ١٦، ...؟، ٢٠",
        "pattern": [
          { "type": "static", "emoji": "١٤" },
          { "type": "static", "emoji": "١٦" },
          { "type": "interactive", "emojis": ["؟", "١٧", "١٨", "١٩"] },
          { "type": "static", "emoji": "٢٠" }
        ],
        "correctAnswer": ["١٨"],
        "successMessage": "✅ صحيح! ١٤، ١٦، ١٨، ٢٠.",
        "errorMessage": "❌ ١٦ زائد ٢ يساوي كم؟"
      },
      {
        "id": "l49_ex3",
        "type": "select-option",
        "title": "🦆 كم عدد الأرجل؟",
        "instruction": "لدى حسام ٤ بطات. ما عدد أرجل البطات الأربعة؟ (٤ مجموعات من ٢)",
        "pattern": [
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٤", "٦", "٨", "١٠"],
        "correctAnswer": "٨",
        "successMessage": "✅ صحيح! ٢ + ٢ + ٢ + ٢ = ٨.",
        "errorMessage": "❌ كل بطة لها رجلان. عد بالاثنينات ٤ مرات."
      }
    ]
  },
  50:{
    "title": "الفصل ١٠ - الدرس ٧: العد التجاوزي بالخمسات",
    "exercises": [
      {
        "id": "l50_ex1",
        "type": "click-cycle-emoji",
        "title": "🔢 أكمل العد بالخمسات",
        "instruction": "٥، ١٠، ...؟، ٢٠",
        "pattern": [
          { "type": "static", "emoji": "٥" },
          { "type": "static", "emoji": "١٠" },
          { "type": "interactive", "emojis": ["؟", "١٢", "١٥", "١٨"] },
          { "type": "static", "emoji": "٢٠" }
        ],
        "correctAnswer": ["١٥"],
        "successMessage": "✅ صحيح! ٥، ١٠، ١٥، ٢٠.",
        "errorMessage": "❌ نحن نضيف ٥ في كل مرة."
      },
      {
        "id": "l50_ex2",
        "type": "click-cycle-emoji",
        "title": "🔢 أكمل العد بالخمسات",
        "instruction": "٥٠، ٥٥، ...؟، ٦٥",
        "pattern": [
          { "type": "static", "emoji": "٥٠" },
          { "type": "static", "emoji": "٥٥" },
          { "type": "interactive", "emojis": ["؟", "٥٦", "٦٠", "٦٢"] },
          { "type": "static", "emoji": "٦٥" }
        ],
        "correctAnswer": ["٦٠"],
        "successMessage": "✅ صحيح! ٥٠، ٥٥، ٦٠، ٦٥.",
        "errorMessage": "❌ ٥٥ زائد ٥ يساوي كم؟"
      },
      {
        "id": "l50_ex3",
        "type": "select-option",
        "title": "🐦 كم عدد العصافير؟",
        "instruction": "وقف على كل غصن ٥ عصافير. كم عصفوراً وقف على ٣ أغصان؟ (٣ مجموعات من ٥)",
        "pattern": [
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٥", "١٠", "١٥", "٢٠"],
        "correctAnswer": "١٥",
        "successMessage": "✅ صحيح! ٥ + ٥ + ٥ = ١٥.",
        "errorMessage": "❌ عد بالخمسات ٣ مرات."
      }
    ]
  },
  51:{
    "title": "الفصل ١١ - الدرس ١: النقود",
    "exercises": [
      {
        "id": "l51_ex1",
        "type": "multi-select",
        "title": "💵 ما هي الأوراق النقدية؟",
        "instruction": "اختر (الأوراق) النقدية فقط.",
        "items": [
          { "emoji": "💰", "label": "٥ ل.س (قطعة)", "correct": false },
          { "emoji": "💵", "label": "٥٠ ل.س (ورقة)", "correct": true },
          { "emoji": "💵", "label": "١٠٠ ل.س (ورقة)", "correct": true },
          { "emoji": "💰", "label": "٢٥ ل.س (قطعة)", "correct": false }
        ],
        "successMessage": "✅ صحيح! ٥٠ و ١٠٠ هي أوراق.",
        "errorMessage": "❌ الأوراق هي ٥٠ و ١٠٠."
      },
      {
        "id": "l51_ex2",
        "type": "multi-select",
        "title": "💰 ما هي القطع النقدية؟",
        "instruction": "اختر (القطع) النقدية فقط.",
        "items": [
          { "emoji": "💰", "label": "٥ ل.س (قطعة)", "correct": true },
          { "emoji": "💰", "label": "١٠ ل.س (قطعة)", "correct": true },
          { "emoji": "💰", "label": "٢٥ ل.س (قطعة)", "correct": true },
          { "emoji": "💵", "label": "٥٠ ل.س (ورقة)", "correct": false }
        ],
        "successMessage": "✅ صحيح! ٥، ١٠، ٢٥ هي قطع نقدية.",
        "errorMessage": "❌ ٥٠ ليرة هي ورقة نقدية."
      }
    ]
  },
  52:{
    "title": "الفصل ١١ - الدرس ٢: القطع النقدية ومكوناتها",
    "exercises": [
      {
        "id": "l52_ex1",
        "type": "select-option",
        "title": "💰 مكونات ١٠ ل.س",
        "instruction": "كم قطعة من فئة ٥ ليرات تساوي قطعة من فئة ١٠ ليرات؟",
        "pattern": [
          { "type": "static", "emoji": "١٠" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["١", "٢", "٣"],
        "correctAnswer": "٢",
        "successMessage": "✅ صحيح! ٥ + ٥ = ١٠.",
        "errorMessage": "❌ ٥ + ٥ = ؟"
      },
      {
        "id": "l52_ex2",
        "type": "select-option",
        "title": "💰 مكونات ٢٥ ل.س",
        "instruction": "كم قطعة من فئة ٥ ليرات تساوي قطعة من فئة ٢٥ ليرة؟",
        "pattern": [
          { "type": "static", "emoji": "٢٥" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٣", "٤", "٥"],
        "correctAnswer": "٥",
        "successMessage": "✅ صحيح! ٥ + ٥ + ٥ + ٥ + ٥ = ٢٥.",
        "errorMessage": "❌ عد بالخمسات حتى تصل إلى ٢٥."
      },
      {
        "id": "l52_ex3",
        "type": "select-option",
        "title": "💰 ما هي القيمة؟",
        "instruction": "ما قيمة: قطعة ١٠ ل.س + قطعة ٥ ل.س + قطعة ٥ ل.س؟",
        "pattern": [
          { "type": "static", "emoji": "١٠+٥+٥" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["١٥ ل.س", "٢٠ ل.س", "٢٥ ل.س"],
        "correctAnswer": "٢٠ ل.س",
        "successMessage": "✅ صحيح! ١٠ + ٥ + ٥ = ٢٠.",
        "errorMessage": "❌ ١٠ + ٥ = ١٥. ١٥ + ٥ = ؟"
      }
    ]
  },
  53:{
    "title": "الفصل ١١ - الدرس ٣: الأوراق النقدية ومكوناتها",
    "exercises": [
      {
        "id": "l53_ex1",
        "type": "select-option",
        "title": "💵 مكونات ١٠٠ ل.س",
        "instruction": "كم ورقة من فئة ٥٠ ليرة تساوي ورقة من فئة ١٠٠ ليرة؟",
        "pattern": [
          { "type": "static", "emoji": "١٠٠" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["١", "٢", "٣"],
        "correctAnswer": "٢",
        "successMessage": "✅ صحيح! ٥٠ + ٥٠ = ١٠٠.",
        "errorMessage": "❌ ٥٠ + ٥٠ = ؟"
      },
      {
        "id": "l53_ex2",
        "type": "select-option",
        "title": "💵 مكونات ٥٠ ل.س",
        "instruction": "كم قطعة من فئة ٢٥ ليرة تساوي ورقة من فئة ٥٠ ليرة؟",
        "pattern": [
          { "type": "static", "emoji": "٥٠" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["١", "٢", "٣"],
        "correctAnswer": "٢",
        "successMessage": "✅ صحيح! ٢٥ + ٢٥ = ٥٠.",
        "errorMessage": "❌ ٢٥ + ٢٥ = ؟"
      },
      {
        "id": "l53_ex3",
        "type": "select-option",
        "title": "💵 ما هي القيمة؟",
        "instruction": "ما قيمة: ورقة ٥٠ ل.س + قطعة ١٠ ل.س + قطعة ١٠ ل.س؟",
        "pattern": [
          { "type": "static", "emoji": "٥٠+١٠+١٠" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٦٠ ل.س", "٧٠ ل.س", "٨٠ ل.س"],
        "correctAnswer": "٧٠ ل.س",
        "successMessage": "✅ صحيح! ٥٠ + ١٠ + ١٠ = ٧٠.",
        "errorMessage": "❌ ٥٠ + ١٠ = ٦٠. ٦٠ + ١٠ = ؟"
      }
    ]
  },
  54:{
    "title": "الفصل ١١ - الدرس ٤: حل المسائل (النقود)",
    "exercises": [
      {
        "id": "l54_ex1",
        "type": "select-option",
        "title": "🛒 هل تكفي نقودي؟",
        "instruction": "سعر الشطيرة ١٠٠ ليرة. معي ٧٠ ليرة. هل تكفي نقودي؟",
        "pattern": [
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["نعم", "لا"],
        "correctAnswer": "لا",
        "successMessage": "✅ صحيح! ٧٠ أصغر من ١٠٠. النقود لا تكفي.",
        "errorMessage": "❌ ٧٠ أصغر من ١٠٠."
      },
      {
        "id": "l54_ex2",
        "type": "select-option",
        "title": "🛒 هل تكفي نقودي؟",
        "instruction": "سعر الكيك ٤٥ ليرة. معي ٥٠ ليرة. هل تكفي نقودي؟",
        "pattern": [
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["نعم", "لا"],
        "correctAnswer": "نعم",
        "successMessage": "✅ صحيح! ٥٠ أكبر من ٤٥. النقود تكفي.",
        "errorMessage": "❌ ٥٠ أكبر من ٤٥."
      },
      {
        "id": "l54_ex3",
        "type": "select-option",
        "title": "💰 ما الباقي؟",
        "instruction": "لدى رند ١٠٠ ليرة. اشترت مضارب بـ ٩٥ ليرة. كم ليرة الباقي معها؟ (١٠٠ - ٩٥ = ؟)",
        "pattern": [
          { "type": "static", "emoji": "١٠٠-٩٥" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٥", "١٠", "١٥"],
        "correctAnswer": "٥",
        "successMessage": "✅ صحيح! ١٠٠ - ٩٥ = ٥ ليرات.",
        "errorMessage": "❌ ١٠٠ ناقص ٩٥."
      }
    ]
  },
  55:{
    "title": "الفصل ١٢ - الدرس ١: جمع ثلاثة أعداد بالترتيب",
    "exercises": [
      {
        "id": "l55_ex1",
        "type": "select-option",
        "title": "➕ الجمع بالترتيب",
        "instruction": "احسب الناتج: ٦ + ٢ + ٣ = ؟ (اجمع ٦ + ٢ أولاً)",
        "pattern": [
          { "type": "static", "emoji": "٦+٢+٣" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٩", "١٠", "١١"],
        "correctAnswer": "١١",
        "successMessage": "✅ صحيح! ٦ + ٢ = ٨. ثم ٨ + ٣ = ١١.",
        "errorMessage": "❌ ٦ + ٢ = ٨. ٨ + ٣ = ؟"
      },
      {
        "id": "l55_ex2",
        "type": "select-option",
        "title": "➕ الجمع بالترتيب",
        "instruction": "احسب الناتج: ٧ + ٢ + ٥ = ؟ (اجمع ٧ + ٢ أولاً)",
        "pattern": [
          { "type": "static", "emoji": "٧+٢+٥" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["١٢", "١٣", "١٤"],
        "correctAnswer": "١٤",
        "successMessage": "✅ صحيح! ٧ + ٢ = ٩. ثم ٩ + ٥ = ١٤.",
        "errorMessage": "❌ ٧ + ٢ = ٩. ٩ + ٥ = ؟"
      }
    ]
  },
  56:{
    "title": "الفصل ١٢ - الدرس ٢: جمع ثلاثة أعداد بتكوين عشرة",
    "exercises": [
      {
        "id": "l56_ex1",
        "type": "select-option",
        "title": "🔟 تكوين عشرة",
        "instruction": "لجمع ٧ + ٦ + ٣، نجمع أولاً...",
        "pattern": [
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٧ + ٦", "٧ + ٣", "٦ + ٣"],
        "correctAnswer": "٧ + ٣",
        "successMessage": "✅ صحيح! نجمع ٧ + ٣ لنكون ١٠ أولاً.",
        "errorMessage": "❌ ابحث عن عددين مجموعهما ١٠."
      },
      {
        "id": "l56_ex2",
        "type": "select-option",
        "title": "➕ ما ناتج ٧ + ٦ + ٣؟",
        "instruction": "استخدم طريقة تكوين عشرة: (٧ + ٣) + ٦ = ؟",
        "pattern": [
          { "type": "static", "emoji": "٧+٦+٣" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["١٥", "١٦", "١٧"],
        "correctAnswer": "١٦",
        "successMessage": "✅ صحيح! (٧ + ٣) = ١٠. ١٠ + ٦ = ١٦.",
        "errorMessage": "❌ ٧ + ٣ = ١٠. ١٠ + ٦ = ؟"
      },
      {
        "id": "l56_ex3",
        "type": "select-option",
        "title": "➕ احسب الناتج: ٨ + ٢ + ٣ = ؟",
        "instruction": "استخدم طريقة تكوين عشرة: (٨ + ٢) + ٣ = ؟",
        "pattern": [
          { "type": "static", "emoji": "٨+٢+٣" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["١١", "١٢", "١٣"],
        "correctAnswer": "١٣",
        "successMessage": "✅ صحيح! (٨ + ٢) = ١٠. ١٠ + ٣ = ١٣.",
        "errorMessage": "❌ ٨ + ٢ = ١٠. ١٠ + ٣ = ؟"
      }
    ]
  },
  57:{
    "title": "الفصل ١٢ - الدرس ٣: جمع العشرات وطرحها",
    "exercises": [
      {
        "id": "l57_ex1",
        "type": "select-option",
        "title": "➕ جمع العشرات",
        "instruction": "٤ عشرات + ٢ عشرات = ؟",
        "pattern": [
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٥ عشرات (٥٠)", "٦ عشرات (٦٠)", "٧ عشرات (٧٠)"],
        "correctAnswer": "٦ عشرات (٦٠)",
        "successMessage": "✅ صحيح! ٤ + ٢ = ٦. إذن ٦ عشرات.",
        "errorMessage": "❌ ٤ + ٢ = ؟"
      },
      {
        "id": "l57_ex2",
        "type": "select-option",
        "title": "➖ طرح العشرات",
        "instruction": "٦ عشرات - ٣ عشرات = ؟",
        "pattern": [
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٣ عشرات (٣٠)", "٤ عشرات (٤٠)", "٥ عشرات (٥٠)"],
        "correctAnswer": "٣ عشرات (٣٠)",
        "successMessage": "✅ صحيح! ٦ - ٣ = ٣. إذن ٣ عشرات.",
        "errorMessage": "❌ ٦ - ٣ = ؟"
      },
      {
        "id": "l57_ex3",
        "type": "select-option",
        "title": "➕ احسب الناتج: ٦٠ + ٣٠ = ؟",
        "instruction": "٦ عشرات + ٣ عشرات",
        "pattern": [
          { "type": "static", "emoji": "٦٠+٣٠" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٧٠", "٨٠", "٩٠"],
        "correctAnswer": "٩٠",
        "successMessage": "✅ صحيح! ٦ + ٣ = ٩.",
        "errorMessage": "❌ ٦ + ٣ = ؟"
      },
      {
        "id": "l57_ex4",
        "type": "select-option",
        "title": "➖ احسب الناتج: ٩٠ - ٥٠ = ؟",
        "instruction": "٩ عشرات - ٥ عشرات",
        "pattern": [
          { "type": "static", "emoji": "٩٠-٥٠" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٣٠", "٤٠", "٥٠"],
        "correctAnswer": "٤٠",
        "successMessage": "✅ صحيح! ٩ - ٥ = ٤.",
        "errorMessage": "❌ ٩ - ٥ = ؟"
      }
    ]
  },
  58:{
    "title": "الفصل ١٢ - الدرس ٤: جمع وطرح عدد من منزلتين مع عشرات",
    "exercises": [
      {
        "id": "l58_ex1",
        "type": "select-option",
        "title": "➕ احسب الناتج: ٥٤ + ٢٠ = ؟",
        "instruction": "اجمع الآحاد (٤+٠) واجمع العشرات (٥+٢).",
        "pattern": [
          { "type": "static", "emoji": "٥٤+٢٠" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٦٤", "٧٤", "٨٤"],
        "correctAnswer": "٧٤",
        "successMessage": "✅ صحيح! الآحاد ٤، العشرات ٧. الناتج ٧٤.",
        "errorMessage": "❌ ٤+٠=٤. ٥+٢=٧."
      },
      {
        "id": "l58_ex2",
        "type": "select-option",
        "title": "➖ احسب الناتج: ٥٩ - ٤٠ = ؟",
        "instruction": "اطرح الآحاد (٩-٠) واطرح العشرات (٥-٤).",
        "pattern": [
          { "type": "static", "emoji": "٥٩-٤٠" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["١٩", "٢٩", "٣٩"],
        "correctAnswer": "١٩",
        "successMessage": "✅ صحيح! الآحاد ٩، العشرات ١. الناتج ١٩.",
        "errorMessage": "❌ ٩-٠=٩. ٥-٤=١."
      },
      {
        "id": "l58_ex3",
        "type": "select-option",
        "title": "💰 مسألة جمع",
        "instruction": "مع خالد ٦٥ ليرة، أعطاه والده ٣٠ ليرة. كم أصبح معه؟ (٦٥ + ٣٠ = ؟)",
        "pattern": [
          { "type": "static", "emoji": "٦٥+٣٠" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٧٥", "٨٥", "٩٥"],
        "correctAnswer": "٩٥",
        "successMessage": "✅ صحيح! ٦٥ + ٣٠ = ٩٥ ليرة.",
        "errorMessage": "❌ ٥+٠=٥. ٦+٣=٩."
      }
    ]
  },
  59:{
    "title": "الفصل ١٢ - الدرس ٥: جمع عدد من منزلتين مع آحاد",
    "exercises": [
      {
        "id": "l59_ex1",
        "type": "select-option",
        "title": "➕ احسب الناتج: ٤٢ + ٧ = ؟",
        "instruction": "اجمع الآحاد (٢+٧) واجمع العشرات (٤+٠).",
        "pattern": [
          { "type": "static", "emoji": "٤٢+٧" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٤٧", "٤٨", "٤٩"],
        "correctAnswer": "٤٩",
        "successMessage": "✅ صحيح! الآحاد ٩، العشرات ٤. الناتج ٤٩.",
        "errorMessage": "❌ ٢+٧=٩. ٤+٠=٤."
      },
      {
        "id": "l59_ex2",
        "type": "select-option",
        "title": "➕ احسب الناتج: ٣٣ + ٢ = ؟",
        "instruction": "اجمع الآحاد (٣+٢) واجمع العشرات (٣+٠).",
        "pattern": [
          { "type": "static", "emoji": "٣٣+٢" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٣٤", "٣٥", "٣٦"],
        "correctAnswer": "٣٥",
        "successMessage": "✅ صحيح! الآحاد ٥، العشرات ٣. الناتج ٣٥.",
        "errorMessage": "❌ ٣+٢=٥. ٣+٠=٣."
      }
    ]
  },
  60:{
    "title": "الفصل ١٢ - الدرس ٦: جمع عددين من منزلتين",
    "exercises": [
      {
        "id": "l60_ex1",
        "type": "select-option",
        "title": "➕ احسب الناتج: ١٦ + ٢٣ = ؟",
        "instruction": "اجمع الآحاد (٦+٣) واجمع العشرات (١+٢).",
        "pattern": [
          { "type": "static", "emoji": "١٦+٢٣" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٣٧", "٣٨", "٣٩"],
        "correctAnswer": "٣٩",
        "successMessage": "✅ صحيح! الآحاد ٩، العشرات ٣. الناتج ٣٩.",
        "errorMessage": "❌ ٦+٣=٩. ١+٢=٣."
      },
      {
        "id": "l60_ex2",
        "type": "select-option",
        "title": "➕ احسب الناتج: ١٥ + ١٤ = ؟",
        "instruction": "اجمع الآحاد (٥+٤) واجمع العشرات (١+١).",
        "pattern": [
          { "type": "static", "emoji": "١٥+١٤" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٢٩", "٣٩", "٤٩"],
        "correctAnswer": "٢٩",
        "successMessage": "✅ صحيح! الآحاد ٩، العشرات ٢. الناتج ٢٩.",
        "errorMessage": "❌ ٥+٤=٩. ١+١=٢."
      },
      {
        "id": "l60_ex3",
        "type": "select-option",
        "title": "➕ احسب الناتج: ٥٠ + ٤١ = ؟",
        "instruction": "اجمع الآحاد (٠+١) واجمع العشرات (٥+٤).",
        "pattern": [
          { "type": "static", "emoji": "٥٠+٤١" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٩٠", "٩١", "٩٢"],
        "correctAnswer": "٩١",
        "successMessage": "✅ صحيح! الآحاد ١، العشرات ٩. الناتج ٩١.",
        "errorMessage": "❌ ٠+١=١. ٥+٤=٩."
      }
    ]
  },
  61:{
    "title": "الفصل ١٢ - الدرس ٧: طرح آحاد من عدد من منزلتين",
    "exercises": [
      {
        "id": "l61_ex1",
        "type": "select-option",
        "title": "➖ احسب الناتج: ٤٥ - ٣ = ؟",
        "instruction": "اطرح الآحاد (٥-٣) واطرح العشرات (٤-٠).",
        "pattern": [
          { "type": "static", "emoji": "٤٥-٣" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٤٠", "٤١", "٤٢"],
        "correctAnswer": "٤٢",
        "successMessage": "✅ صحيح! الآحاد ٢، العشرات ٤. الناتج ٤٢.",
        "errorMessage": "❌ ٥-٣=٢. ٤-٠=٤."
      },
      {
        "id": "l61_ex2",
        "type": "select-option",
        "title": "➖ احسب الناتج: ٥٦ - ٢ = ؟",
        "instruction": "اطرح الآحاد (٦-٢) واطرح العشرات (٥-٠).",
        "pattern": [
          { "type": "static", "emoji": "٥٦-٢" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٥٢", "٥٣", "٥٤"],
        "correctAnswer": "٥٤",
        "successMessage": "✅ صحيح! الآحاد ٤، العشرات ٥. الناتج ٥٤.",
        "errorMessage": "❌ ٦-٢=٤. ٥-٠=٥."
      },
      {
        "id": "l61_ex3",
        "type": "select-option",
        "title": "✏️ حساب ذهني",
        "instruction": "معي ١٢ قلماً أعطيت أخي ٥ أقلام. كم قلماً بقي معي؟ (١٢ - ٥ = ؟)",
        "pattern": [
          { "type": "static", "emoji": "١٢-٥" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٦", "٧", "٨"],
        "correctAnswer": "٧",
        "successMessage": "✅ صحيح! ١٢ - ٥ = ٧.",
        "errorMessage": "❌ ١٢ ناقص ٥."
      }
    ]
  },
  62:{
    "title": "الفصل ١٢ - الدرس ٨: طرح عددين من منزلتين",
    "exercises": [
      {
        "id": "l62_ex1",
        "type": "select-option",
        "title": "➖ احسب الناتج: ٤٦ - ٣٤ = ؟",
        "instruction": "اطرح الآحاد (٦-٤) واطرح العشرات (٤-٣).",
        "pattern": [
          { "type": "static", "emoji": "٤٦-٣٤" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["١٠", "١٢", "١٤"],
        "correctAnswer": "١٢",
        "successMessage": "✅ صحيح! الآحاد ٢، العشرات ١. الناتج ١٢.",
        "errorMessage": "❌ ٦-٤=٢. ٤-٣=١."
      },
      {
        "id": "l62_ex2",
        "type": "select-option",
        "title": "➖ احسب الناتج: ٥٧ - ٤٥ = ؟",
        "instruction": "اطرح الآحاد (٧-٥) واطرح العشرات (٥-٤).",
        "pattern": [
          { "type": "static", "emoji": "٥٧-٤٥" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["١٢", "١٣", "٢٢"],
        "correctAnswer": "١٢",
        "successMessage": "✅ صحيح! الآحاد ٢، العشرات ١. الناتج ١٢.",
        "errorMessage": "❌ ٧-٥=٢. ٥-٤=١."
      },
      {
        "id": "l62_ex3",
        "type": "select-option",
        "title": "✉️ مسألة طرح",
        "instruction": "لدى سمر ٤٧ طابعاً، أعطت أختها ١٢ طابعاً. كم بقي لديها؟ (٤٧ - ١٢ = ؟)",
        "pattern": [
          { "type": "static", "emoji": "٤٧-١٢" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٢٥", "٣٥", "٤٥"],
        "correctAnswer": "٣٥",
        "successMessage": "✅ صحيح! ٤٧ - ١٢ = ٣٥ طابعاً.",
        "errorMessage": "❌ ٧-٢=٥. ٤-١=٣."
      }
    ]
  },
  63:{
    "title": "الفصل ١٢ - الدرس ٩: حل مسائل (اختيار العملية)",
    "exercises": [
      {
        "id": "l63_ex1",
        "type": "select-option",
        "title": "🚌 رحلة المدرسة",
        "instruction": "رحلة فيها ٣٢ تلميذاً و ٣٧ ولي أمر. ما (عدد المشاركين الكلي)؟ اختر العملية.",
        "pattern": [
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["جمع", "طرح"],
        "correctAnswer": "جمع",
        "successMessage": "✅ صحيح! لمعرفة المجموع الكلي نستخدم (الجمع).",
        "errorMessage": "❌ نحن نريد معرفة العدد (الكلي)."
      },
      {
        "id": "l63_ex2",
        "type": "select-option",
        "title": "🏀 مباراة السلة",
        "instruction": "فريق سجل ٧٥ نقطة والفريق الثاني ٤٣. ما (الفرق) بين النقط؟ اختر العملية.",
        "pattern": [
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["جمع", "طرح"],
        "correctAnswer": "طرح",
        "successMessage": "✅ صحيح! لمعرفة (الفرق) نستخدم (الطرح).",
        "errorMessage": "❌ نحن نريد معرفة (الفرق) أو (كم يزيد)."
      },
      {
        "id": "l63_ex3",
        "type": "select-option",
        "title": "🖊️ مسألة الدفتر والقلم",
        "instruction": "دفتر سعره ٧٠ ليرة وقلم سعره ٣٠ ليرة. (كم يزيد) سعر الدفتر؟ (٧٠ - ٣٠ = ؟)",
        "pattern": [
          { "type": "static", "emoji": "٧٠-٣٠" },
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٣٠", "٤٠", "١٠٠"],
        "correctAnswer": "٤٠",
        "successMessage": "✅ صحيح! ٧٠ - ٣٠ = ٤٠ ليرة.",
        "errorMessage": "❌ (كم يزيد) تعني عملية طرح."
      }
    ]
  },
  64:{
    "title": "الفصل ١٣ - الدرس ١: الساعة",
    "exercises": [
      {
        "id": "l64_ex1",
        "type": "select-option",
        "title": "⏰ قراءة الساعة",
        "instruction": "العقرب الكبير يشير إلى ١٢ والعقرب الصغير إلى ٩. ما الوقت؟",
        "pattern": [
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["١٢:٠٠", "٩:٠٠", "٣:٠٠"],
        "correctAnswer": "٩:٠٠",
        "successMessage": "✅ صحيح! إنها الساعة التاسعة تماماً.",
        "errorMessage": "❌ العقرب الصغير للساعات، والكبير للدقائق (عند ١٢ يعني تماماً)."
      },
      {
        "id": "l64_ex2",
        "type": "select-option",
        "title": "⏰ ما الوقت؟",
        "instruction": "ما الوقت الذي تشير إليه الساعة؟ (تشير إلى ٧:٠٠)",
        "pattern": [
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٥:٠٠", "٦:٠٠", "٧:٠٠"],
        "correctAnswer": "٧:٠٠",
        "successMessage": "✅ صحيح! إنها الساعة السابعة تماماً.",
        "errorMessage": "❌ العقرب الصغير يشير إلى ٧."
      },
      {
        "id": "l64_ex3",
        "type": "select-option",
        "title": "🏫 وقت المدرسة",
        "instruction": "يبدأ الدوام المدرسي الساعة...",
        "pattern": [
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["٨:٠٠", "٢:٠٠", "٩:٠٠"],
        "correctAnswer": "٨:٠٠",
        "successMessage": "✅ صحيح! يبدأ الدوام الساعة ٨:٠٠.",
        "errorMessage": "❌ اختر الوقت المناسب لبداية الدوام."
      }
    ]
  },
  65:{
    "title": "الفصل ١٣ - الدرس ٢: قياس الطول بوحدات غير نظامية",
    "exercises": [
      {
        "id": "l65_ex1",
        "type": "select-option",
        "title": "📏 وحدات القياس",
        "instruction": "نستخدم وحدات غير نظامية لقياس الطول مثل...",
        "pattern": [
          { "type": "missing", "placeholder": "؟" }
        ],
        "options": ["الكتاب", "المتر", "السنتيمتر"],
        "correctAnswer": "الكتاب",
        "successMessage": "✅ صحيح! الكتاب أو الممحاة أو اليد هي وحدات غير نظامية.",
        "errorMessage": "❌ المتر والسنتيمتر هي وحدات (نظامية)."
      },
      {
        "id": "l65_ex2",
        "type": "multi-select",
        "title": "⬆️ أشر إلى الأطول",
        "instruction": "اختر الشيء الأطول.",
        "items": [
          { "emoji": "✏️", "label": "القلم", "correct": true },
          { "emoji": " Eraser ", "label": "الممحاة", "correct": false }
        ],
        "successMessage": "✅ صحيح! القلم أطول من الممحاة.",
        "errorMessage": "❌ أيهما أطول؟"
      },
      {
        "id": "l65_ex3",
        "type": "multi-select",
        "title": "⬇️ أشر إلى الأقصر",
        "instruction": "اختر الشيء الأقصر.",
        "items": [
          { "emoji": "🕯️", "label": "الشمعة الطويلة", "correct": false },
          { "emoji": "🕯️", "label": "الشمعة القصيرة", "correct": true }
        ],
        "successMessage": "✅ صحيح! الشمعة القصيرة هي الأقصر.",
        "errorMessage": "❌ أيهما أقصر؟"
      }
    ]
  }
  /* اللغة العربية */
,
66: {
    title: "الوحدة ١ - الدرس ١: الشَّجَرَةُ",
    exercises: [
      {
        id: "l35_ex1",
        type: "select-option",
        title: "🌳 ماذا تعطينا الشجرة؟",
        instruction: "أَضَعُ إِشَارَةَ ( ✓ ) تَحْتَ الصُّورَةِ الْمُنَاسِبَةِ",
        pattern: [
          { type: "static", emoji: "الشجرة تعطينا:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["🍊", "🚗"],
        correctAnswer: "🍊",
        successMessage: "✅ صحيح! تُعطينا الشَّجَرَةُ الثمار",
        errorMessage: "❌ خطأ! السيارة ليست من عطايا الشجرة"
      },
      {
        id: "l35_ex2",
        type: "select-option",
        title: "❤️ ما معنى كلمة (أهوى)؟",
        instruction: "أَضَعُ إِشَارَةَ ( ✓ ) تَحْتَ الصُّورَةِ الْمُنَاسِبَةِ",
        pattern: [
          { type: "static", emoji: "معنى (أهوى):" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["❤️", "✍️"],
        correctAnswer: "❤️",
        successMessage: "✅ ممتاز! أهوى تعني أُحِبُّ",
        errorMessage: "❌ أهوى لا تعني أكتب"
      },
      {
        id: "l35_ex3",
        type: "select-option",
        title: "📚 أنمي لغتي: أكمل الجملة",
        instruction: "أحاكي النموذج: الثمر (على) الأشجار. الكتاب ....... المقعد",
        pattern: [
          { type: "static", emoji: "الكتاب" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["على", "في"],
        correctAnswer: "على",
        successMessage: "✅ صحيح! الكتاب (على) المقعد",
        errorMessage: "❌ حاول مرة أخرى. انظر إلى النموذج: الثمر (على) الأشجار"
      },
      {
        id: "l35_ex4",
        type: "click-cycle-emoji",
        title: "🧩 ركّب الكلمة",
        instruction: "أركب من المقطعين الآتيين كلمةً، ثُمَّ أقرؤها: (ظا + هر)",
        pattern: [
          { type: "static", emoji: "ظا" },
          { type: "static", emoji: "هر" },
          { type: "static", emoji: "=" },
          { type: "interactive", emojis: ["؟", "ظاهر", "هرظا"] }
        ],
        correctAnswer: ["ظاهر"],
        successMessage: "✅ أحسنت! الكلمة هي (ظاهر)",
        errorMessage: "❌ حاول تجميع المقطعين بالترتيب"
      }
    ]
  },
  67: {
    title: "الوحدة ١ - الدرس ٢: العصفورة",
    exercises: [
      {
        id: "l36_ex1",
        type: "multi-select",
        title: "🎧 استمع وأناقش",
        instruction: "أحوطُ الكَلِمَةَ التي سَمِعْتُها فِي النَّص:",
        items: [
          { emoji: "🟢", label: "أخضر", correct: true },
          { emoji: "🟡", label: "أصفر", correct: false },
          { emoji: "🔴", label: "أحمر", correct: false }
        ],
        successMessage: "✅ صحيح! النص ذكر (الرَّوْضَ الأَخْضَرَ)",
        errorMessage: "❌ لم أسمع هذا اللون في النص"
      },
      {
        id: "l36_ex2",
        type: "select-option",
        title: "☁️ ما معنى (الغمام)؟",
        instruction: "أضع تحت الصُّورَةِ الَّتي تَدُلُّ على المعنى الصحيح لِكَلِمَةِ (الغَمام):",
        pattern: [
          { type: "static", emoji: "الغمام هو:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["☀️", "☁️"],
        correctAnswer: "☁️",
        successMessage: "✅ صحيح! الغمام هو الغيوم",
        errorMessage: "❌ هذه الشمس، الغمام هو الغيوم"
      },
      {
        id: "l36_ex3",
        type: "select-option",
        title: "🕊️ أكمل الجملة شفوياً",
        instruction: "أَخْتارُ الكَلِمَةَ الصَّحِيحَةَ: تَنْشُرُ ...",
        pattern: [
          { type: "static", emoji: "تنشر" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["السلام", "الألحان", "السماء"],
        correctAnswer: "السلام",
        successMessage: "✅ صحيح! تَنْشُرُ السَّلام في الأرض والسماء",
        errorMessage: "❌ خطأ! هي (تبدع) الألحان"
      },
      {
        id: "l36_ex4",
        type: "select-option",
        title: "⛔ أنمي لغتي: النفي",
        instruction: "أكمل العبارة محاكياً النموذج: (يلعب الطفل في الملعب) -> (... يلعب الطفل في الشارع)",
        pattern: [
          { type: "missing", placeholder: "؟" },
          { type: "static", emoji: "يلعب الطفل في الشارع" }
        ],
        options: ["لا", "نعم"],
        correctAnswer: "لا",
        successMessage: "✅ أحسنت! (لا يلعب الطفل في الشارع)",
        errorMessage: "❌ نستخدم (لا) للنفي"
      }
    ]
  },
  68: {
    title: "الوحدة ١ - الدرس ٣: صديقتي المياه",
    exercises: [
      {
        id: "l37_ex1",
        type: "select-option",
        title: "💧 استمع وأناقش",
        instruction: "أَخْتارُ الإِجابة الصحيحة: صديقة الطفل هي...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["المياه", "الطيور", "الأزهار"],
        correctAnswer: "المياه",
        successMessage: "✅ صحيح! المياه صديقة الإنسان",
        errorMessage: "❌ النص يتحدث عن (صديقتي المياه)"
      },
      {
        id: "l37_ex2",
        type: "select-option",
        title: "🌳 أقرأ وأفهم",
        instruction: "أكمل الجملة: تَشْرَبُ مِنْهَا الأَشْجارُ فَتُعطينا...",
        pattern: [
          { type: "static", emoji: "فتعطينا" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الثمار", "الهواء", "الحياة"],
        correctAnswer: "الثمار",
        successMessage: "✅ صحيح! فَتُعطينا الثمار",
        errorMessage: "❌ الأشجار تعطينا الثمار عندما تشرب"
      },
      {
        id: "l37_ex3",
        type: "select-option",
        title: "💧➡️💧💧 أنمي لغتي: الجمع",
        instruction: "أَنْتَبِهُ إلى الصُّورِ، ما هو جمع (قَطْرَة)؟",
        pattern: [
          { type: "static", emoji: "قطرة" },
          { type: "static", emoji: "⬅️" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["قَطَرات", "قِطار"],
        correctAnswer: "قَطَرات",
        successMessage: "✅ أحسنت! جمع (قطرة) هو (قَطَرات)",
        errorMessage: "❌ حاول مرة أخرى"
      },
      {
        id: "l37_ex4",
        type: "select-option",
        title: "🦋➡️🦋🦋 أنمي لغتي: الجمع",
        instruction: "أَنْتَبِهُ إلى الصُّورِ، ما هو جمع (فَراشَة)؟",
        pattern: [
          { type: "static", emoji: "فراشة" },
          { type: "static", emoji: "⬅️" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["فَراشات", "فِراش"],
        correctAnswer: "فَراشات",
        successMessage: "✅ أحسنت! جمع (فراشة) هو (فَراشات)",
        errorMessage: "❌ حاول مرة أخرى"
      }
    ]
  },
  69: {
    title: "الوحدة ١ - الدرس ٤: الشتاء",
    exercises: [
      {
        id: "l38_ex1",
        type: "select-option",
        title: "🌨️ استمع وأناقش",
        instruction: "أحوط الإجابة الصحيحة: تكَلَّمَتِ الأُنشودة عن فَصْلِ...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الصَّيف", "الربيع", "الشَّتاء"],
        correctAnswer: "الشَّتاء",
        successMessage: "✅ صحيح! الأنشودة عن (الشتاء)",
        errorMessage: "❌ خطأ، الأنشودة ذكرت (قد أقبل الشتاء)"
      },
      {
        id: "l38_ex2",
        type: "select-option",
        title: "🌧️ ما معنى (تهطل)؟",
        instruction: "أُلوِّنُ المعنى الصَّحيحَ لكلمة (تهطل)",
        pattern: [
          { type: "static", emoji: "تهطل الأمطار يعني:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["تضع", "تنزل", "تنشر"],
        correctAnswer: "تنزل",
        successMessage: "✅ صحيح! (تهطل) تعني (تنزل)",
        errorMessage: "❌ (تهطل) تعني (تنزل)"
      },
      {
        id: "l38_ex3",
        type: "multi-select",
        title: "📖 أقرأ وأفهم",
        instruction: "أُلونُ الكَلِماتِ الَّتِي قَرَأْتُها فِي الأُنشودَةِ:",
        items: [
          { emoji: "🏞️", label: "الحقول", correct: true },
          { emoji: "☁️", label: "الغيوم", correct: false },
          { emoji: "🌧️", label: "الأمطار", correct: true },
          { emoji: "⭐", label: "النجوم", correct: false }
        ],
        successMessage: "✅ أحسنت! (الحقول) و (الأمطار) ذُكرت في الأنشودة",
        errorMessage: "❌ (الغيوم) و (النجوم) لم تُذكر في الأنشودة"
      },
      {
        id: "l38_ex4",
        type: "select-option",
        title: "✍️ أنمي لغتي: تحويل الفعل",
        instruction: "أقرأ وأحاكي النموذج: (يكتب الطفل) ⬅️ (كتب الطفل). (يرسم الطفل) ⬅️ ...",
        pattern: [
          { type: "static", emoji: "يرسم الطفل" },
          { type: "static", emoji: "⬅️" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["رسم الطفل", "يرسمون الطفل"],
        correctAnswer: "رسم الطفل",
        successMessage: "✅ ممتاز! (يرسم) في المضارع تصبح (رسم) في الماضي",
        errorMessage: "❌ (يكتب) أصبحت (كتب). (يرسم) تصبح...؟"
      }
    ]
  },
  70: {
    title: "الوحدة ٢ - الدرس ١: أُنظف مدرستي",
    exercises: [
      {
        id: "l39_ex1",
        type: "select-option",
        title: "🤝 استمع وأناقش",
        instruction: "أختار الإجابة الصحيحة: اتَّفق التلاميذ على...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["لعب مباراة", "تنظيف المدرسة", "إقامة حفلة"],
        correctAnswer: "تنظيف المدرسة",
        successMessage: "✅ صحيح! اتَّفق التلاميذ على تنظيفِ المَدْرَسَةِ",
        errorMessage: "❌ اقرأ النص مرة أخرى"
      },
      {
        id: "l39_ex2",
        type: "select-option",
        title: "💡 أقرأ وأفهم: ما معنى (أَجْمَل)؟",
        instruction: "ألون كل بطاقتين مُتماثلتين في المعنى: أَجْمَل ⬅️ ...",
        pattern: [
          { type: "static", emoji: "أَجْمَل" },
          { type: "static", emoji: "⬅️" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["أَحلى", "أَصْغَر", "لَعِبَ"],
        correctAnswer: "أَحلى",
        successMessage: "✅ صحيح! أَجْمَل تعني أَحلى",
        errorMessage: "❌ (أَجْمَل) لها نفس معنى (أَحلى)"
      },
      {
        id: "l39_ex3",
        type: "select-option",
        title: "💡 أقرأ وأفهم: ما معنى (التقط)؟",
        instruction: "ألون كل بطاقتين مُتماثلتين في المعنى: التقط ⬅️ ...",
        pattern: [
          { type: "static", emoji: "التقط" },
          { type: "static", emoji: "⬅️" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["أَمْسَكَ", "أَصْغَر", "أَحلى"],
        correctAnswer: "أَمْسَكَ",
        successMessage: "✅ صحيح! التقط تعني أَمْسَكَ",
        errorMessage: "❌ (التقط) لها نفس معنى (أَمْسَكَ)"
      },
      {
        id: "l39_ex4",
        type: "multi-select",
        title: "🔡 أنمي لغتي: أحرف العطف",
        instruction: "اختر الجمل التي تستخدم (و) أو (ثُمَّ) بشكل صحيح:",
        items: [
          { emoji: "أكتب وظائفي، ثم ألعب بالكرة", label: "أكتب وظائفي، ثم ألعب بالكرة", correct: true },
          { emoji: "أُحِبُّ البرتقال و التفاح", label: "أُحِبُّ البرتقال و التفاح", correct: true },
          { emoji: "أكتب وظائفي و ألعب بالكرة", label: "أكتب وظائفي و ألعب بالكرة", correct: false }
        ],
        successMessage: "✅ أحسنت! (ثم) تفيد الترتيب، (و) تفيد المشاركة",
        errorMessage: "❌ (ثم) نستخدمها للترتيب (أولاً ثم ثانياً)، (و) نستخدمها للجمع بين شيئين"
      }
    ]
  },
  71: {
    title: "الوحدة ٢ - الدرس ٢: صحة الأسنان",
    exercises: [
      {
        id: "l40_ex1",
        type: "select-option",
        title: "👨‍⚕️ استمع وأناقش",
        instruction: "أختار الإجابة الصحيحة: يتحدَّثُ النَّص عن...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["طَبيب الأسنان", "المعلم", "عامل النظافة"],
        correctAnswer: "طَبيب الأسنان",
        successMessage: "✅ صحيح! ذهب الولد إلى طبيب الأسنان",
        errorMessage: "❌ اقرأ النص مرة أخرى"
      },
      {
        id: "l40_ex2",
        type: "select-option",
        title: "🦷 أقرأ وأفهم",
        instruction: "كي أحافظ على صحة أسناني أستعمل...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["مُشطاً", "فُرْشَاةً", "قَلَماً"],
        correctAnswer: "فُرْشَاةً",
        successMessage: "✅ صحيح! أستعمل (فُرْشَاةً) ومعجوناً",
        errorMessage: "❌ المشط للشعر والقلم للكتابة"
      },
      {
        id: "l40_ex3",
        type: "select-option",
        title: "💡 أقرأ وأفهم: ما معنى (أعنى)؟",
        instruction: "أختار الإجابة الصحيحة: معنى أعنى...",
        pattern: [
          { type: "static", emoji: "أعنى بأسناني يعني:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["أَهْتَمْ", "أَعْمَلُ"],
        correctAnswer: "أَهْتَمْ",
        successMessage: "✅ صحيح! أعنى تعني أَهْتَمْ",
        errorMessage: "❌ (أعنى) تعني (أَهْتَمْ)"
      },
      {
        id: "l40_ex4",
        type: "click-cycle-emoji",
        title: "🧑‍🏫 أنمي لغتي: حوّل إلى الجمع",
        instruction: "أُكْمِلُ الكلمات وَفْقَ النموذج: (معلم ⬅️ معلمون). (مهندس ⬅️ ...)",
        pattern: [
          { type: "static", emoji: "مهندس" },
          { type: "static", emoji: "⬅️" },
          { type: "interactive", emojis: ["؟", "مهندسون", "مهندسات"] }
        ],
        correctAnswer: ["مهندسون"],
        successMessage: "✅ أحسنت! جمع المذكر السالم (مهندسون)",
        errorMessage: "❌ (معلم) أصبحت (معلمون). (مهندس) تصبح...؟"
      }
    ]
  },
  72: {
    title: "الوحدة ٢ - الدرس ٣: غذائي",
    exercises: [
      {
        id: "l41_ex1",
        type: "select-option",
        title: "🥛 استمع وأناقش",
        instruction: "ماذا يشربُ الطِّفلُ في الصَّبَاحِ؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الحليب", "العصير", "الماء"],
        correctAnswer: "الحليب",
        successMessage: "✅ صحيح! فَأشرب الحليب",
        errorMessage: "❌ استمع للأنشودة: (أفيق في الصباح فأشرب...)"
      },
      {
        id: "l41_ex2",
        type: "select-option",
        title: "🍎 استمع وأناقش",
        instruction: "أكمل الجملة: وآكل ...",
        pattern: [
          { type: "static", emoji: "وآكل" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الموز", "التفاح", "العِنَب"],
        correctAnswer: "التفاح",
        successMessage: "✅ صحيح! وآكل التفاح",
        errorMessage: "❌ استمع للأنشودة: (وآكل ...)"
      },
      {
        id: "l41_ex3",
        type: "select-option",
        title: "🥐 أقرأ وأفهم",
        instruction: "نُسمّي وَجْبَةَ الصَّباح:",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["غَداء", "عشاء", "فطور"],
        correctAnswer: "فطور",
        successMessage: "✅ صحيح! وجبة الصباح هي الفطور",
        errorMessage: "❌ الغداء في الظهر والعشاء في المساء"
      },
      {
        id: "l41_ex4",
        type: "select-option",
        title: "✍️ أنمي لغتي: أكمل الجملة",
        instruction: "أكمل الجملة الآتية: آكل ...",
        pattern: [
          { type: "static", emoji: "آكل" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["التفاح", "الدروس", "الأعداد"],
        correctAnswer: "التفاح",
        successMessage: "✅ أحسنت! آكل التفاح",
        errorMessage: "❌ نأكل الطعام (التفاح)"
      }
    ]
  },
  73: {
    title: "الوحدة ٢ - الدرس ٤: الحواس الخمس",
    exercises: [
      {
        id: "l42_ex1",
        type: "multi-select",
        title: "👃 أقرأ وأفهم: صل الحاسّة بالعضو",
        instruction: "اختر العضو المناسب لحاسة (الشم)",
        items: [
          { emoji: "👃", label: "الأنف", correct: true },
          { emoji: "👁️", label: "العين", correct: false },
          { emoji: "👂", label: "الأذن", correct: false },
          { emoji: "👅", label: "اللسان", correct: false }
        ],
        successMessage: "✅ صحيح! بالأنف أشم الوردة",
        errorMessage: "❌ نحن (نشم) بالأنف"
      },
      {
        id: "l42_ex2",
        type: "multi-select",
        title: "👁️ أقرأ وأفهم: صل الحاسّة بالعضو",
        instruction: "اختر العضو المناسب لحاسة (الرؤية)",
        items: [
          { emoji: "👃", label: "الأنف", correct: false },
          { emoji: "👁️", label: "العين", correct: true },
          { emoji: "👂", label: "الأذن", correct: false },
          { emoji: "🤚", label: "اليد", correct: false }
        ],
        successMessage: "✅ صحيح! بالعينين أرى الأعلام",
        errorMessage: "❌ نحن (نرى) بالعين"
      },
      {
        id: "l42_ex3",
        type: "multi-select",
        title: "👂 أقرأ وأفهم: صل الحاسّة بالعضو",
        instruction: "اختر العضو المناسب لحاسة (السمع)",
        items: [
          { emoji: "👅", label: "اللسان", correct: false },
          { emoji: "👁️", label: "العين", correct: false },
          { emoji: "👂", label: "الأذن", correct: true },
          { emoji: "🤚", label: "اليد", correct: false }
        ],
        successMessage: "✅ صحيح! بالأذنين، أسمع تغريد العصفور",
        errorMessage: "❌ نحن (نسمع) بالأذن"
      },
      {
        id: "l42_ex4",
        type: "select-option",
        title: "🤩 أنمي لغتي: أسلوب التعجب",
        instruction: "أكمل شفوياً وَفْقَ المثال: (ما أزكى العِطر!). ما ... المدرسة!",
        pattern: [
          { type: "static", emoji: "ما" },
          { type: "missing", placeholder: "؟" },
          { type: "static", emoji: "المدرسة!" }
        ],
        options: ["أجمل", "نظافة", "طعام"],
        correctAnswer: "أجمل",
        successMessage: "✅ صحيح! (ما أجمل المدرسة!)",
        errorMessage: "❌ نستخدم صيغة (ما أفعل!) للتعجب"
      }
    ]
  },
  74: {
    title: "الوحدة ٣ - الدرس ١: في قلبي",
    exercises: [
      {
        id: "l43_ex1",
        type: "select-option",
        title: "❤️ استمع وأناقش",
        instruction: "تَحَدَّثَ جُمَلُ النَّصِّ عن:",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الأسرة", "المدرسة", "الملعب"],
        correctAnswer: "الأسرة",
        successMessage: "✅ صحيح! النص يتحدث عن الأسرة (أمي وأبي وإخوتي)",
        errorMessage: "❌ النص ذكر (نحن أسرة سعيدة)"
      },
      {
        id: "l43_ex2",
        type: "select-option",
        title: "🏡 أقرأ وأفهم",
        instruction: "على ماذا تتعاون الأسرة؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["ترتيب بيتنا", "اللعب فقط", "مشاهدة التلفاز"],
        correctAnswer: "ترتيب بيتنا",
        successMessage: "✅ صحيح! نتساعد معاً على ترتيب بيتنا",
        errorMessage: "❌ اقرأ النص: (نتساعد معاً على...)"
      },
      {
        id: "l43_ex3",
        type: "select-option",
        title: "✈️ أنمي لغتي: الضمائر",
        instruction: "أملأ الفراغ: ... أسافر بالطائرة",
        pattern: [
          { type: "missing", placeholder: "؟" },
          { type: "static", emoji: "أسافر بالطائرة" }
        ],
        options: ["أنا", "نحن"],
        correctAnswer: "أنا",
        successMessage: "✅ صحيح! (أنا أسافر)",
        errorMessage: "❌ (أسافر) تبدأ بـ (أ) فتكون (أنا)"
      },
      {
        id: "l43_ex4",
        type: "select-option",
        title: "✈️ أنمي لغتي: الضمائر",
        instruction: "أملأ الفراغ: ... نسافر بالطائرة",
        pattern: [
          { type: "missing", placeholder: "؟" },
          { type: "static", emoji: "نسافر بالطائرة" }
        ],
        options: ["أنا", "نحن"],
        correctAnswer: "نحن",
        successMessage: "✅ صحيح! (نحن نسافر)",
        errorMessage: "❌ (نسافر) تبدأ بـ (ن) فتكون (نحن)"
      }
    ]
  },
  75: {
    title: "الوحدة ٣ - الدرس ٢: التَّعاون",
    exercises: [
      {
        id: "l44_ex1",
        type: "select-option",
        title: "🏰 استمع وأناقش",
        instruction: "أختار الجملة التي سمعتها في الأنشودة:",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["كلٌّ منا صار يبني جداراً", "كلٌّ منا صار يبني نصف جدار"],
        correctAnswer: "كلٌّ منا صار يبني نصف جدار",
        successMessage: "✅ صحيح! (كلٌّ منا صار يبني نصف جدار)",
        errorMessage: "❌ استمع جيداً للأنشودة"
      },
      {
        id: "l44_ex2",
        type: "select-option",
        title: "🏖️ أقرأ وأفهم",
        instruction: "استعمل الأطفال لبناء القلعة:",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["جحر وصَدَف", "رمل مبلل بالماء"],
        correctAnswer: "رمل مبلل بالماء",
        successMessage: "✅ صحيح! (رملٌ مبللٌ بالماء)",
        errorMessage: "❌ اقرأ الأنشودة: (رملٌ مبللٌ...)"
      },
      {
        id: "l44_ex3",
        type: "select-option",
        title: "👨‍👩‍👧‍👦 أقرأ وأفهم: ما ضِدّ (مجتمعين)؟",
        instruction: "أختار ضِدّ كَلِمَةِ (مجتمعين) مُسْتَعيناً بالصور",
        pattern: [
          { type: "static", emoji: "مجتمعين" },
          { type: "static", emoji: "⬅️" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["متفرقين", "نائمين", "يلعبون"],
        correctAnswer: "متفرقين",
        successMessage: "✅ صحيح! ضِدّ (مجتمعين) هو (متفرقين)",
        errorMessage: "❌ (مجتمعين) تعني معاً. ما هو العكس؟"
      },
      {
        id: "l44_ex4",
        type: "select-option",
        title: "🔡 أنمي لغتي: الضمائر",
        instruction: "أحاكي النموذج: (أنا ألعب بالكرة). (هو ... بالكرة)",
        pattern: [
          { type: "static", emoji: "هو" },
          { type: "missing", placeholder: "؟" },
          { type: "static", emoji: "بالكرة" }
        ],
        options: ["يلعب", "ألعب", "تلعب"],
        correctAnswer: "يلعب",
        successMessage: "✅ صحيح! (هو يلعب بالكرة)",
        errorMessage: "❌ (أنا ألعب)، (هو ...)"
      }
    ]
  },
  76: {
    title: "الوحدة ٣ - الدرس ٣: الصغيرَةُ الجَميلَةُ",
    exercises: [
      {
        id: "l45_ex1",
        type: "select-option",
        title: "👩‍👧 استمع وأناقش",
        instruction: "مَنْ لَعِبَ مَعَ الطِّفلةِ أَوَّلاً؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الأم", "الأطفال", "الطبيب"],
        correctAnswer: "الأم",
        successMessage: "✅ صحيح! (قالت الأم: أنا سألعب مَعَكِ)",
        errorMessage: "❌ استمع جيداً للقصة"
      },
      {
        id: "l45_ex2",
        type: "select-option",
        title: "🙂 أقرأ وأفهم: ضِدّ (حزينة)",
        instruction: "أَدُلُّ بِإِشارَةٍ ( ✓ ) عَلى ضِدِّ كَلِمَةِ (حزينة):",
        pattern: [
          { type: "static", emoji: "ضد (حزينة):" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["سعيدة", "نشيطة", "سريعة"],
        correctAnswer: "سعيدة",
        successMessage: "✅ صحيح! ضِدّ (حزينة) هو (سعيدة)",
        errorMessage: "❌ ما هو عكس (حزينة)؟"
      },
      {
        id: "l45_ex3",
        type: "multi-select",
        title: "👍 أقرأ وأفهم: اختر التصرف الصحيح",
        instruction: "أختارُ التصرُّفَ الصَّحيحَ مِنْ قِبَلِ الأَطْفَال:",
        items: [
          { emoji: "شاهدوا الطفلة تلعب مع أمها", label: "شاهدوا الطفلة تلعب مع أمها", correct: false },
          { emoji: "تسابق الجميع لمساعدة الطفلة", label: "تسابق الجميع لمساعدة الطفلة", correct: true }
        ],
        successMessage: "✅ أحسنت! التصرف الصحيح هو (تسابق الجميع لمساعدة الطفلة)",
        errorMessage: "❌ (تسابق الجميع لمساعدة الطفلة) هو التصرف الصحيح"
      },
      {
        id: "l45_ex4",
        type: "select-option",
        title: "❓ أنمي لغتي: الاستفهام",
        instruction: "أقرأ الجملة وأضع علامة الترقيم المناسبة: (لماذا أنت حزينة يا صغيرتي)",
        pattern: [
          { type: "static", emoji: "لماذا أنت حزينة يا صغيرتي" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["؟", "."],
        correctAnswer: "؟",
        successMessage: "✅ صحيح! نضع (؟) لأن الجملة سؤال",
        errorMessage: "❌ الجملة تبدأ بـ (لماذا)، إذن هي سؤال"
      }
    ]
  },
  77: {
    title: "الوحدة ٣ - الدرس ٤: أحب أن أكون",
    exercises: [
      {
        id: "l46_ex1",
        type: "select-option",
        title: "👨‍🚒 استمع وأناقش",
        instruction: "أضع خطاً تحت المهنة التي (لم) ترد في النص:",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["رجل الإطفاء", "الطبيبة", "الخباز", "المعلم"],
        correctAnswer: "رجل الإطفاء",
        successMessage: "✅ صحيح! لم يُذكر (رجل الإطفاء) في النص",
        errorMessage: "❌ (الخباز) ذُكر ضمناً (الفلاح يزرع لنأكل). المعلم والطبيبة ذُكرا"
      },
      {
        id: "l46_ex2",
        type: "select-option",
        title: "🧑‍🌾 أقرأ وأفهم: صل العمل بصاحبه",
        instruction: "أَصِلُ بينَ العَمَلِ وصاحِبِهِ: (الفلاح)",
        pattern: [
          { type: "static", emoji: "الفلاح ⬅️" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["يصنع مقاعد الدراسة", "يعالج المرضى", "يزرع الأرض", "يعلم الأجيال"],
        correctAnswer: "يزرع الأرض",
        successMessage: "✅ صحيح! الفلاح يزرع الأرض",
        errorMessage: "❌ الفلاح (يزرع)"
      },
      {
        id: "l46_ex3",
        type: "select-option",
        title: "🧑‍🏫 أقرأ وأفهم: صل العمل بصاحبه",
        instruction: "أَصِلُ بينَ العَمَلِ وصاحِبِهِ: (المعلم)",
        pattern: [
          { type: "static", emoji: "المعلم ⬅️" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["يصنع مقاعد الدراسة", "يعالج المرضى", "يزرع الأرض", "يعلم الأجيال"],
        correctAnswer: "يعلم الأجيال",
        successMessage: "✅ صحيح! المعلم يعلم الأجيال",
        errorMessage: "❌ المعلم (يعلم)"
      },
      {
        id: "l46_ex4",
        type: "select-option",
        title: "👨‍⚕️ أقرأ وأفهم: صل العمل بصاحبه",
        instruction: "أَصِلُ بينَ العَمَلِ وصاحِبِهِ: (الطبيبة)",
        pattern: [
          { type: "static", emoji: "الطبيبة ⬅️" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["يصنع مقاعد الدراسة", "تعالج المرضى", "تزرع الأرض", "تعلم الأجيال"],
        correctAnswer: "تعالج المرضى",
        successMessage: "✅ صحيح! الطبيبة تعالج المرضى",
        errorMessage: "❌ الطبيبة (تعالج)"
      },
      {
        id: "l46_ex5",
        type: "select-option",
        title: "💡 أقرأ وأفهم: ما ضِدّ (يُغلق)؟",
        instruction: "أَصِلُ الكَلِمَةَ بِضِدِّها: (يُغلق)",
        pattern: [
          { type: "static", emoji: "ضد (يُغلق):" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["يفتح", "يفرح", "يشفى"],
        correctAnswer: "يفتح",
        successMessage: "✅ صحيح! ضِدّ (يُغلق) هو (يفتح)",
        errorMessage: "❌ ما هو عكس (يُغلق)؟"
      }
    ]
  }
,
78: {
    title: "الوحدة ١ - الدرس ١: مَنْ أنا؟",
    exercises: [
      {
        id: "l77_ex1",
        type: "select-option",
        title: "🏠 أعرّفُ بمدينة سامر",
        instruction: "سامر قال: 'أنا من محافظة حلب'. اختر المحافظة التي ينتمي إليها سامر.",
        pattern: [
          { type: "static", emoji: "محافظة سامر هي:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["حلب", "دمشق", "اللاذقية"],
        correctAnswer: "حلب",
        successMessage: "✅ صحيح! سامر من محافظة حلب.",
        errorMessage: "❌ حاول مرة أخرى. المعلومة موجودة في نص السؤال."
      },
      {
        id: "l77_ex2",
        type: "multi-select",
        title: "⚽ ما هي الأنشطة التي أحبها؟",
        instruction: "اختر الأنشطة التي تميزك وتفضّل القيام بها (مثال: كرة القدم).",
        items: [
          { emoji: "⚽", label: "لعب كرة القدم", correct: true },
          { emoji: "🎨", label: "الرسم والتلوين", correct: true },
          { emoji: "📖", label: "القراءة والاطلاع", correct: true },
          { emoji: "😴", label: "النوم لوقت متأخر", correct: false }
        ],
        successMessage: "✅ ممتاز! هذه أنشطة ممتعة ومفيدة.",
        errorMessage: "❌ اختر ما يميزك أنت."
      },
      {
        id: "l77_ex3",
        type: "select-option",
        title: "🎂 ما هو عمري؟",
        instruction: "أنا طفل في الصف الأول، عمري عادةً:",
        pattern: [
          { type: "static", emoji: "عمري (بالأرقام):" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["٥", "٦", "٧"],
        correctAnswer: "٦",
        successMessage: "✅ صحيح! ست سنوات.",
        errorMessage: "❌ انتبه للرقم ٦."
      }
    ]
  },

  /*         الدراسات الاجتماعية   */
  79: {
    title: "الوحدة ١ - الدرس ٢: نتشابه ونختلف",
    exercises: [
      {
        id: "l78_ex1",
        type: "multi-select",
        title: "👤 بماذا نختلف؟",
        instruction: "اختر الصفات التي تجعلنا مختلفين عن بعضنا كأطفال.",
        items: [
          { emoji: "🧑‍🦱", label: "لون الشعر", correct: true },
          { emoji: "📏", label: "الطول", correct: true },
          { emoji: "🍎", label: "نوع الفاكهة المفضلة", correct: true },
          { emoji: "🎒", label: "حقيبة المدرسة", correct: false }
        ],
        successMessage: "✅ صحيح! نختلف في الشكل والاهتمامات.",
        errorMessage: "❌ حقيبة المدرسة ليست صفة شخصية."
      },
      {
        id: "l78_ex2",
        type: "select-option",
        title: "📏 من هو الأطول؟",
        instruction: "إذا كان سامر أطول من لين، فاختر الإشارة المناسبة للمقارنة بين طوليهما.",
        pattern: [
          { type: "static", emoji: "طول سامر" },
          { type: "missing", placeholder: "؟" },
          { type: "static", emoji: "طول لين" }
        ],
        options: ["أطول من", "أقصر من", "يساوي"],
        correctAnswer: "أطول من",
        successMessage: "✅ ممتاز! سامر أطول من لين.",
        errorMessage: "❌ إذا كان أطول، فما هي الإشارة؟"
      },
      {
        id: "l78_ex3",
        type: "multi-select",
        title: "🤝 بماذا نتشابه؟",
        instruction: "اختر الصفات التي يتشابه فيها معظم أطفال الصف الأول.",
        items: [
          { emoji: "🧠", label: "حب التعلم", correct: true },
          { emoji: "🏫", label: "الذهاب إلى المدرسة", correct: true },
          { emoji: "⚽", label: "القدرة على اللعب", correct: true },
          { emoji: "🕰️", label: "لون البشرة", correct: false }
        ],
        successMessage: "✅ صحيح! الجميع يحب التعلم واللعب ويذهب للمدرسة.",
        errorMessage: "❌ لون البشرة صفة تختلف من شخص لآخر."
      }
    ]
  },
  80: {
    title: "الوحدة ١ - الدرس ٣: مشاعري",
    exercises: [
      {
        id: "l79_ex1",
        type: "select-option",
        title: "😢 أي وجه يعبر عن شعور (الحزن)؟",
        instruction: "اختر الشعور الذي يظهر عندما يسقط منك شيء تحبه.",
        pattern: [
          { type: "static", emoji: "شعور الحزن:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["😊 (فرح)", "😢 (حزن)", "😠 (غضب)"],
        correctAnswer: "😢 (حزن)",
        successMessage: "✅ صحيح! الحزن يظهر بالعبوس والبكاء.",
        errorMessage: "❌ الوجه العابس يعبر عن الحزن."
      },
      {
        id: "l79_ex2",
        type: "select-option",
        title: "😠 أي وجه يعبر عن شعور (الغضب)؟",
        instruction: "اختر الشعور الذي يظهر عندما يصرخ شخص بصوت عالٍ.",
        pattern: [
          { type: "static", emoji: "شعور الغضب:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["😊 (فرح)", "😢 (حزن)", "😠 (غضب)"],
        correctAnswer: "😠 (غضب)",
        successMessage: "✅ صحيح! الغضب يظهر بالصراخ وشد الوجه.",
        errorMessage: "❌ الغضب يعبر عن انزعاج شديد."
      },
      {
        id: "l79_ex3",
        type: "multi-select",
        title: "✅ مشاعر إيجابية",
        instruction: "اختر المشاعر الإيجابية التي تجعلك سعيداً.",
        items: [
          { emoji: "😃", label: "السعادة", correct: true },
          { emoji: "😨", label: "الخوف", correct: false },
          { emoji: "❤️", label: "الحب", correct: true },
          { emoji: "😔", label: "الندم", correct: false }
        ],
        successMessage: "✅ ممتاز! السعادة والحب مشاعر إيجابية.",
        errorMessage: "❌ الخوف والندم مشاعر غير إيجابية."
      }
    ]
  },
  81: {
    title: "الوحدة ١ - الدرس ٤: كيف أمضي يومي؟",
    exercises: [
      {
        id: "l80_ex1",
        type: "click-cycle-emoji",
        title: "🗓️ رتّب أنشطتي اليومية",
        instruction: "رتّب الأنشطة اليومية بالترتيب الزمني (من الصباح إلى المساء).",
        pattern: [
          { type: "interactive", emojis: ["❓", "استيقاظ", "مدرسة", "نوم"] },
          { type: "interactive", emojis: ["❓", "مدرسة", "نوم"] },
          { type: "interactive", emojis: ["❓", "نوم"] }
        ],
        correctAnswer: ["استيقاظ", "مدرسة", "نوم"],
        successMessage: "✅ صحيح! يبدأ اليوم بالاستيقاظ وينتهي بالنوم.",
        errorMessage: "❌ تذكر أن النشاطات اليومية تكون بالترتيب الزمني."
      },
      {
        id: "l80_ex2",
        type: "select-option",
        title: "⏰ ما هو النشاط التالي؟",
        instruction: "ما هو النشاط الذي يأتي عادةً بعد الذهاب إلى المدرسة؟",
        pattern: [
          { type: "static", emoji: "الذهاب إلى المدرسة ➡️" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الاستيقاظ", "مشاهدة التلفاز/اللعب", "النوم"],
        correctAnswer: "مشاهدة التلفاز/اللعب",
        successMessage: "✅ ممتاز! بعد المدرسة نلعب أو نشاهد التلفاز.",
        errorMessage: "❌ النوم يكون في نهاية اليوم."
      },
      {
        id: "l80_ex3",
        type: "select-option",
        title: "🧺 أنشطة المساء",
        instruction: "ما هو النشاط الذي يُفضّل القيام به قبل النوم مباشرةً؟",
        pattern: [
          { type: "static", emoji: "قبل النوم" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["تنظيف الحديقة", "مشاهدة التلفاز", "قراءة قصة هادئة"],
        correctAnswer: "قراءة قصة هادئة",
        successMessage: "✅ صحيح! القراءة الهادئة تساعد على النوم.",
        errorMessage: "❌ الأنشطة الهادئة أفضل للمساء."
      }
    ]
  },
  82: {
    title: "الوحدة ١ - الدرس ٥: أنا قادر",
    exercises: [
      {
        id: "l81_ex1",
        type: "multi-select",
        title: "🎨 مهاراتي وقدراتي",
        instruction: "اختر الأعمال التي تصف قدرة أو مهارة لديك (ليست مجرد عمل يومي).",
        items: [
          { emoji: "🏃", label: "الركض السريع", correct: true },
          { emoji: "🤹", label: "لعب الجمباز بمهارة", correct: true },
          { emoji: "📱", label: "استخدام الهاتف", correct: false },
          { emoji: "🧩", label: "تركيب البزل (الأحجية)", correct: true }
        ],
        successMessage: "✅ ممتاز! هذه قدرات ومهارات مميزة.",
        errorMessage: "❌ استخدام الهاتف ليس مهارة شخصية مميزة مثل الجمباز."
      },
      {
        id: "l81_ex2",
        type: "select-option",
        title: "✏️ مهارة يدوية",
        instruction: "أي من هذه المهارات تعتبر مهارة يدوية (فنية)؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["السباحة", "الرسم والتلوين", "القفز"],
        correctAnswer: "الرسم والتلوين",
        successMessage: "✅ صحيح! الرسم والتلوين مهارة تحتاج لليدين.",
        errorMessage: "❌ السباحة والقفز مهارات جسدية (رياضية)."
      },
      {
        id: "l81_ex3",
        type: "multi-select",
        title: "🥇 ما هي صفات الشباب الناجح؟",
        instruction: "اختر صفات الشباب الناجحين (مثل بطل السباحة والرسام في الصور).",
        items: [
          { emoji: "🏊", label: "التدريب المستمر", correct: true },
          { emoji: "🎨", label: "الاجتهاد في الموهبة", correct: true },
          { emoji: "😴", label: "الكسل والتأجيل", correct: false }
        ],
        successMessage: "✅ صحيح! التدريب والاجتهاد يؤديان إلى النجاح.",
        errorMessage: "❌ الكسل يمنعنا من النجاح."
      }
    ]
  },
  83: {
    title: "الوحدة ١ - الدرس ٦: سأحقق هدفي",
    exercises: [
      {
        id: "l82_ex1",
        type: "click-cycle-emoji",
        title: "🪜 رتّب خطوات تحقيق الهدف",
        instruction: "رتّب الخطوات الأربع اللازمة لتحقيق أي هدف بالترتيب الصحيح.",
        pattern: [
          { type: "interactive", emojis: ["❓", "تنظيم الوقت", "التدريب", "إعادة المحاولة", "تحديد الهدف"] },
          { type: "interactive", emojis: ["❓", "التدريب", "إعادة المحاولة", "تحديد الهدف"] },
          { type: "interactive", emojis: ["❓", "إعادة المحاولة", "تحديد الهدف"] },
          { type: "interactive", emojis: ["❓", "تحديد الهدف"] }
        ],
        correctAnswer: ["تحديد الهدف", "تنظيم الوقت", "التدريب", "إعادة المحاولة"],
        successMessage: "✅ أحسنت! هذا هو الترتيب المنطقي لتحقيق الهدف.",
        errorMessage: "❌ يجب أن تعرف هدفك أولاً، ثم تنظّم وقتك."
      },
      {
        id: "l82_ex2",
        type: "select-option",
        title: "❌ خطأ في تحقيق الهدف",
        instruction: "أي مما يلي لا يعتبر خطوة للنجاح في تحقيق الهدف؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الاستسلام عند الفشل", "التدريب المستمر", "تحديد هدف واضح"],
        correctAnswer: "الاستسلام عند الفشل",
        successMessage: "✅ صحيح! يجب عليك (إعادة المحاولة) وليس الاستسلام.",
        errorMessage: "❌ يجب ألا نستسلم أبداً."
      },
      {
        id: "l82_ex3",
        type: "select-option",
        title: "🍯 أهمية المحاولة",
        instruction: "لماذا يجب أن (نُعيد المحاولة) حتى لو واجهنا صعوبة؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["لأن الكسل أفضل", "للوصول إلى الهدف وتحقيقه", "لإضاعة الوقت"],
        correctAnswer: "للوصول إلى الهدف وتحقيقه",
        successMessage: "✅ ممتاز! المحاولة والإصرار هما مفتاح النجاح.",
        errorMessage: "❌ المحاولة مهمة للوصول للهدف."
      }
    ]
  },
  84: {
    title: "الوحدة ٢ - الدرس ١: صغار كبار",
    exercises: [
      {
        id: "l83_ex1",
        type: "click-cycle-emoji",
        title: "👶 رتّب مراحل العمر (بالأفعال)",
        instruction: "رتّب الأفعال التي يقوم بها الطفل من الأصغر (سنة) إلى الأكبر (٦ سنوات).",
        pattern: [
          { type: "interactive", emojis: ["❓", "يحاول المشي", "يلعب بالمكعبات", "يتعلم ركوب الدراجة", "يذهب للمدرسة"] },
          { type: "interactive", emojis: ["❓", "يلعب بالمكعبات", "يتعلم ركوب الدراجة", "يذهب للمدرسة"] },
          { type: "interactive", emojis: ["❓", "يتعلم ركوب الدراجة", "يذهب للمدرسة"] },
          { type: "interactive", emojis: ["❓", "يذهب للمدرسة"] }
        ],
        correctAnswer: ["يحاول المشي", "يلعب بالمكعبات", "يتعلم ركوب الدراجة", "يذهب للمدرسة"],
        successMessage: "✅ ممتاز! المشي (سنة) ثم اللعب (٣ سنوات) ثم الدراجة (٥ سنوات) ثم المدرسة (٦ سنوات).",
        errorMessage: "❌ تذكر أن الطفل يتعلم المشي أولاً."
      },
      {
        id: "l83_ex2",
        type: "select-option",
        title: "1️⃣ نشاط عمر السنة",
        instruction: "ما هو النشاط الذي يمارسه الطفل وعمره سنة واحدة؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["يحاول المشي", "يتعلم القراءة", "يذهب للمدرسة"],
        correctAnswer: "يحاول المشي",
        successMessage: "✅ صحيح! الطفل يحاول المشي في عمر السنة.",
        errorMessage: "❌ القراءة والمدرسة تكون في عمر أكبر."
      },
      {
        id: "l83_ex3",
        type: "select-option",
        title: "6️⃣ نشاط عمر الست سنوات",
        instruction: "ما هو النشاط الذي يمارسه الطفل وعمره ست سنوات؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["يذهب للمدرسة", "يحاول المشي", "يبني برجاً"],
        correctAnswer: "يذهب للمدرسة",
        successMessage: "✅ صحيح! يذهب للمدرسة في عمر الست سنوات.",
        errorMessage: "❌ الذهاب للمدرسة يكون في عمر الست سنوات."
      }
    ]
  },
  85: {
    title: "الوحدة ٢ - الدرس ٢: أنا وأسرتي",
    exercises: [
      {
        id: "l84_ex1",
        type: "click-cycle-emoji",
        title: "👨‍👩‍👧‍👦 رتّب أفراد الأسرة حسب العمر",
        instruction: "رتّب أفراد الأسرة (الأب، الأم، الأبناء) من الأكبر إلى الأصغر.",
        pattern: [
          { type: "interactive", emojis: ["❓", "الأب", "الأم", "الابنة"] },
          { type: "interactive", emojis: ["❓", "الأم", "الابنة"] },
          { type: "interactive", emojis: ["❓", "الابنة"] }
        ],
        correctAnswer: ["الأب", "الأم", "الابنة"],
        successMessage: "✅ صحيح! الأب والأم هم الأكبر ثم الأبناء.",
        errorMessage: "❌ الأب ثم الأم ثم الأبناء."
      },
      {
        id: "l84_ex2",
        type: "select-option",
        title: "👵 من هو الأكبر سناً؟",
        instruction: "من هو الأكبر سناً في العائلة الموسعة؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الأخ الأكبر", "الجد أو الجدة", "الأم"],
        correctAnswer: "الجد أو الجدة",
        successMessage: "✅ صحيح! الجد والجدة هما الأكبر سناً.",
        errorMessage: "❌ الأجداد هم كبار العائلة."
      },
      {
        id: "l84_ex3",
        type: "select-option",
        title: "❤️ من يستحق الرعاية؟",
        instruction: "من هو الشخص الذي يحتاج إلى الرعاية والاهتمام في الأسرة؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الجد والجدة", "الأم والأب", "الأبناء"],
        correctAnswer: "الجد والجدة",
        successMessage: "✅ صحيح! الجد والجدة هما من يستحقان رعايتنا.",
        errorMessage: "❌ الجد والجدة يحتاجان إلى اهتمام خاص."
      }
    ]
  },
  86: {
    title: "الوحدة ٢ - الدرس ٣: أحب المساعدة",
    exercises: [
      {
        id: "l85_ex1",
        type: "multi-select",
        title: "✅ أفعال المساعدة",
        instruction: "اختر أفعالاً تدل على المساعدة في المنزل.",
        items: [
          { emoji: "🧹", label: "تنظيف الأثاث", correct: true },
          { emoji: "💦", label: "سقاية النباتات", correct: true },
          { emoji: "📺", label: "اللعب طوال اليوم", correct: false },
          { emoji: "🧺", label: "ترتيب الغرفة", correct: true }
        ],
        successMessage: "✅ ممتاز! التنظيف والسقاية والترتيب أفعال مساعدة.",
        errorMessage: "❌ اللعب ليس مساعدة."
      },
      {
        id: "l85_ex2",
        type: "select-option",
        title: "😊 المشاعر بعد المساعدة",
        instruction: "ما هو شعور الشخص الذي يتلقى المساعدة؟",
        pattern: [
          { type: "static", emoji: "شعور الشخص الآخر:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الحزن", "الفرح والامتنان", "الغضب"],
        correctAnswer: "الفرح والامتنان",
        successMessage: "✅ صحيح! نشعر بالفرح والامتنان عندما يساعدنا أحد.",
        errorMessage: "❌ المساعدة تجلب الفرح."
      },
      {
        id: "l85_ex3",
        type: "select-option",
        title: "🚼 أهمية مساعدة الصغار",
        instruction: "ما هو السبب الأكثر أهمية لمساعدة الصغار على عبور طريق خطير؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["لأنهم يصرخون", "لأنهم معرضون للخطر", "لأنهم يحبون الألعاب"],
        correctAnswer: "لأنهم معرضون للخطر",
        successMessage: "✅ صحيح! سلامتهم هي الأولوية.",
        errorMessage: "❌ السلامة هي الأهم."
      }
    ]
  },
  87: {
    title: "الوحدة ٢ - الدرس ٤: آداب الحوار",
    exercises: [
      {
        id: "l86_ex1",
        type: "multi-select",
        title: "✅ آداب الحوار السليم",
        instruction: "اختر آداب الحوار التي يجب الالتزام بها.",
        items: [
          { emoji: "👂", label: "الإصغاء وعدم المقاطعة", correct: true },
          { emoji: "😠", label: "رفع الصوت", correct: false },
          { emoji: "⏳", label: "انتظار دورك في الكلام", correct: true },
          { emoji: "😊", label: "التحدث بابتسامة وهدوء", correct: true }
        ],
        successMessage: "✅ ممتاز! الإصغاء والانتظار والهدوء هي آداب الحوار.",
        errorMessage: "❌ رفع الصوت ليس من آداب الحوار."
      },
      {
        id: "l86_ex2",
        type: "select-option",
        title: "🚫 التصرف الخاطئ",
        instruction: "ما هو التصرف الخاطئ الذي يجب تجنبه أثناء الحوار؟",
        pattern: [
          { type: "static", emoji: "التصرف الخاطئ هو:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["التحدث بهدوء", "مقاطعة المتحدث", "شكر المتحدث"],
        correctAnswer: "مقاطعة المتحدث",
        successMessage: "✅ صحيح! مقاطعة الآخرين سلوك خاطئ.",
        errorMessage: "❌ يجب أن ننتظر حتى يُنهي المتحدث كلامه."
      },
      {
        id: "l86_ex3",
        type: "select-option",
        title: "🤫 نبرة الصوت",
        instruction: "ما هي نبرة الصوت المناسبة أثناء الحوار؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["صوت مرتفع جداً", "صوت منخفض وهادئ", "صوت غير مسموع"],
        correctAnswer: "صوت منخفض وهادئ",
        successMessage: "✅ صحيح! الصوت الهادئ والمناسب هو الأفضل.",
        errorMessage: "❌ الصوت العالي يزعج الآخرين."
      }
    ]
  }
,

88: {
    title: "الوحدة ٣ - الدرس ١: أعبر الشارع بأمان",
    exercises: [
      {
        id: "l87_ex1",
        type: "select-option",
        title: "🚦 متى تعبر الشارع؟",
        instruction: "لعبور الشارع بأمان، يجب أن يكون ضوء إشارة المرور للسيارات بلون...",
        pattern: [
          { type: "static", emoji: "الضوء الذي يسمح بعبور المشاة هو عندما يكون للسيارات:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الأحمر (توقف)", "الأخضر (سير)", "الأصفر (استعداد)"],
        correctAnswer: "الأحمر (توقف)",
        successMessage: "✅ صحيح! عندما تتوقف السيارات (الضوء الأحمر) يمكن للمشاة العبور.",
        errorMessage: "❌ الضوء الأخضر يعني أن السيارة تسير، وهذا خطر."
      },
      {
        id: "l87_ex2",
        type: "select-option",
        title: "🚸 الطريقة الآمنة للعبور",
        instruction: "أي سلوك من السلوكات التالية يضمن عبور الشارع بأمان؟",
        pattern: [
          { type: "static", emoji: "العبور الآمن هو:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الركض مسرعاً", "الانتظار حتى تتوقف السيارات ثم العبور", "العبور بين السيارات"],
        correctAnswer: "الانتظار حتى تتوقف السيارات ثم العبور",
        successMessage: "✅ صحيح! يجب الانتظار لضمان السلامة.",
        errorMessage: "❌ الركض أو العبور بين السيارات سلوك غير آمن."
      },
      {
        id: "l87_ex3",
        type: "select-option",
        title: "🟠 إشارة الاستعداد",
        instruction: "تنبه إشارة المرور ذات اللون البرتقالي السيارات بأنها في حالة...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["السير", "التوقف", "الاستعداد للسير أو التوقف"],
        correctAnswer: "الاستعداد للسير أو التوقف",
        successMessage: "✅ صحيح! الضوء البرتقالي يعني الاستعداد للتوقف أو السير.",
        errorMessage: "❌ البرتقالي هو للتنبيه والاستعداد."
      }
    ]
  },
  89: {
    title: "الوحدة ٣ - الدرس ٢: ألعب بأمان",
    exercises: [
      {
        id: "l88_ex1",
        type: "multi-select",
        title: "✔️/❌ الأماكن الآمنة للعب",
        instruction: "اختر الأماكن التي يُمكن أن تلعب فيها بأمان، بعيداً عن الخطر.",
        items: [
          { emoji: "🎠", label: "حديقة الألعاب", correct: true },
          { emoji: "🏞️", label: "المنحدرات الشديدة", correct: false },
          { emoji: "⚽", label: "ملعب كرة القدم", correct: true },
          { emoji: "🚧", label: "مكان عليه علامة (خطر)", correct: false }
        ],
        successMessage: "✅ ممتاز! حديقة الألعاب وملعب كرة القدم آمنة.",
        errorMessage: "❌ تجنب الأماكن الخطرة والمنحدرات."
      },
      {
        id: "l88_ex2",
        type: "select-option",
        title: "🚫 تجنب المنحدرات",
        instruction: "لماذا يجب أن تتجنب اللعب في المنحدرات الشديدة؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["لأنها جميلة", "لأنها أماكن آمنة", "لأنها قد تعرضك للسقوط والخطر"],
        correctAnswer: "لأنها قد تعرضك للسقوط والخطر",
        successMessage: "✅ صحيح! المنحدرات خطرة على سلامتك.",
        errorMessage: "❌ سلامتك هي الأهم، تجنب الأماكن الخطرة."
      },
      {
        id: "l88_ex3",
        type: "multi-select",
        title: "⛔ علامات الخطر",
        instruction: "ما هو الواجب عليك عند رؤية علامة (خطر)؟",
        items: [
          { emoji: "🏃", label: "الابتعاد عنها فوراً", correct: true },
          { emoji: "🗣️", label: "تحذير الأصدقاء منها", correct: true },
          { emoji: "🛑", label: "الاقتراب منها لاكتشافها", correct: false }
        ],
        successMessage: "✅ ممتاز! يجب الابتعاد والتحذير من علامات الخطر.",
        errorMessage: "❌ لا يجب الاقتراب من علامات الخطر أبداً."
      }
    ]
  },
  90: {
    title: "الوحدة ٣ - الدرس ٣: أبقى حذراً",
    exercises: [
      {
        id: "l89_ex1",
        type: "multi-select",
        title: "⚠️ كن حذراً! اختر الأشياء الخطرة",
        instruction: "اختر الأشياء التي تُعَدُّ خطراً على سلامتك داخل المنزل.",
        items: [
          { emoji: "✂️", label: "المقص الحاد", correct: true },
          { emoji: "🔌", label: "الكهرباء (القابس)", correct: true },
          { emoji: "🔥", label: "الموقد (الفرن)", correct: true },
          { emoji: "🧸", label: "لعبة الدب", correct: false }
        ],
        successMessage: "✅ أحسنت! المقص والكهرباء والموقد خطيرة.",
        errorMessage: "❌ تذكر أن بعض الأدوات المنزلية خطيرة إذا لم تستخدم بحذر."
      },
      {
        id: "l89_ex2",
        type: "select-option",
        title: "🔥 حذر حول النار",
        instruction: "لماذا يجب أن نكون حذرين حول الموقد (الفرن)؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["لأنه يضيء الغرفة", "لأنه قد يسبب حروقاً خطيرة", "لأنه مكان لتخزين الألعاب"],
        correctAnswer: "لأنه قد يسبب حروقاً خطيرة",
        successMessage: "✅ صحيح! الحرارة والنار خطيرة وتسبب حروقاً.",
        errorMessage: "❌ يجب الابتعاد عن النار."
      },
      {
        id: "l89_ex3",
        type: "select-option",
        title: "❌ تجنب مخاطر الكهرباء",
        instruction: "ما هو السلوك الخاطئ عند التعامل مع الكهرباء؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["إدخال أشياء في القابس", "استخدام الأجهزة بأمان", "تجنب لمس الأسلاك العارية"],
        correctAnswer: "إدخال أشياء في القابس",
        successMessage: "✅ صحيح! إدخال أشياء في القابس يعرضنا لصدمة كهربائية.",
        errorMessage: "❌ لمس الكهرباء خطير جداً."
      }
    ]
  },
  91: {
    title: "الوحدة ٣ - الدرس ٤: اللقاح حقي",
    exercises: [
      {
        id: "l90_ex1",
        type: "select-option",
        title: "💉 لماذا نأخذ اللقاح؟",
        instruction: "نأخذ اللقاح (المطعوم) لحمايتنا من الأمراض الخطرة ولجعلنا...",
        pattern: [
          { type: "static", emoji: "نأخذ اللقاح لكي نكون:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["مرضى وضعفاء", "أصحاء أقوياء", "أطفالاً أغنياء"],
        correctAnswer: "أصحاء أقوياء",
        successMessage: "✅ صحيح! اللقاح يحمينا ويجعلنا أقوياء.",
        errorMessage: "❌ الهدف هو أن نكون أصحاء وأقوياء."
      },
      {
        id: "l90_ex2",
        type: "select-option",
        title: "📜 شعار اللقاح",
        instruction: "ما هي العبارة التي تعبر عن أهمية اللقاح (الشعار الرسمي)؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["اللقاح سعادة", "اللقاح صحة", "اللقاح لعب"],
        correctAnswer: "اللقاح صحة",
        successMessage: "✅ صحيح! الشعار هو (اللقاح صحة).",
        errorMessage: "❌ العبارة التي سمعتها هي (اللقاح صحة)."
      },
      {
        id: "l90_ex3",
        type: "multi-select",
        title: "✅ حقوق الطفل",
        instruction: "اختر حقوق الطفل التي تنتمي إلى (الرعاية الصحية).",
        items: [
          { emoji: "💉", label: "الحصول على اللقاح", correct: true },
          { emoji: "🏥", label: "الرعاية الصحية العامة", correct: true },
          { emoji: "📚", label: "التعليم المجاني", correct: false }
        ],
        successMessage: "✅ صحيح! اللقاح والرعاية الصحية من الحقوق الأساسية.",
        errorMessage: "❌ التعليم ليس رعاية صحية."
      }
    ]
  },
  92: {
    title: "الوحدة ٤ - الدرس ١: في مدرستي",
    exercises: [
      {
        id: "l91_ex1",
        type: "select-option",
        title: "📚 السلوك المناسب في المدرسة",
        instruction: "أي سلوك من هذه السلوكات مناسب داخل المدرسة؟",
        pattern: [
          { type: "static", emoji: "السلوك السليم هو:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الركض بعنف في الممرات", "رمي الأوساخ في الساحة", "المحافظة على نظافة الأثاث"],
        correctAnswer: "المحافظة على نظافة الأثاث",
        successMessage: "✅ صحيح! المحافظة على المدرسة واجب.",
        errorMessage: "❌ الركض ورمي الأوساخ سلوك غير سليم."
      },
      {
        id: "l91_ex2",
        type: "select-option",
        title: "🚫 السلوك غير السليم",
        instruction: "أي سلوك من هذه السلوكات غير مناسب في الصف؟",
        pattern: [
          { type: "static", emoji: "السلوك الخاطئ هو:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["المشاركة في النقاش", "الكتابة على الجدران", "الاستماع للمعلم"],
        correctAnswer: "الكتابة على الجدران",
        successMessage: "✅ صحيح! الكتابة على الجدران سلوك غير سليم.",
        errorMessage: "❌ يجب احترام ممتلكات المدرسة."
      },
      {
        id: "l91_ex3",
        type: "select-option",
        title: "✨ قيمة النظام",
        instruction: "لماذا يجب أن تكون مدرستنا نظيفة ومرتبة؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["لأن ذلك يجعلنا نحبها أكثر", "لأنها لا تخصنا", "لأننا نكره العمل"],
        correctAnswer: "لأن ذلك يجعلنا نحبها أكثر",
        successMessage: "✅ صحيح! النظافة والترتيب يجعلان المكان مريحاً ومحبوباً.",
        errorMessage: "❌ مدرستنا هي بيتنا الثاني."
      }
    ]
  },
  93: {
    title: "الوحدة ٤ - الدرس ٢: حقوقي وواجباتي",
    exercises: [
      {
        id: "l92_ex1",
        type: "select-option",
        title: "👶 حق الطفل",
        instruction: "اختر حقاً من حقوق الطفل الأساسية.",
        pattern: [
          { type: "static", emoji: "من حقوقي:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["حمل حقيبة الأب", "الحق في التعليم", "شراء سيارة"],
        correctAnswer: "الحق في التعليم",
        successMessage: "✅ صحيح! التعليم هو حق أساسي.",
        errorMessage: "❌ الحق هو شيء يجب أن يوفره لك المجتمع."
      },
      {
        id: "l92_ex2",
        type: "multi-select",
        title: "✅ واجباتي في المدرسة",
        instruction: "اختر واجبات عليك القيام بها تجاه مدرستك.",
        items: [
          { emoji: "✏️", label: "الحفاظ على الدفاتر والكتب", correct: true },
          { emoji: "🪑", label: "المحافظة على مقعدي ونظافته", correct: true },
          { emoji: "🗑️", label: "رمي القمامة في سلة المهملات", correct: true },
          { emoji: "🤫", label: "الهروب من الصف", correct: false }
        ],
        successMessage: "✅ ممتاز! هذه واجبات تجعل المدرسة أفضل.",
        errorMessage: "❌ الهروب سلوك خاطئ."
      },
      {
        id: "l92_ex3",
        type: "select-option",
        title: "😟 سبب الحزن",
        instruction: "لماذا يحزن الطفل عندما يجد مكان اللعب متسخاً؟",
        pattern: [
          { type: "static", emoji: "سبب الحزن هو:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["لأنه حُرِمَ حقه في اللعب بمكان نظيف", "لأنه لا يحب الألوان", "لأنه لا يملك أصدقاء"],
        correctAnswer: "لأنه حُرِمَ حقه في اللعب بمكان نظيف",
        successMessage: "✅ صحيح! من حق الطفل أن يلعب في مكان نظيف وآمن.",
        errorMessage: "❌ القذارة تحرم الطفل من حقه في اللعب."
      }
    ]
  },
  94: {
    title: "الوحدة ٤ - الدرس ٣: لي دور",
    exercises: [
      {
        id: "l93_ex1",
        type: "select-option",
        title: "👨‍🔧 دور الكبار",
        instruction: "أي من هذه الأعمال هو دور للكبار (مثل الأب أو الأم)؟",
        pattern: [
          { type: "static", emoji: "دور للكبار:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["إعادة القصص للمكتبة", "إصلاح دراجة الأخت", "ترتيب الألعاب"],
        correctAnswer: "إصلاح دراجة الأخت",
        successMessage: "✅ صحيح! إصلاح الأشياء يحتاج لمهارات الكبار.",
        errorMessage: "❌ ترتيب القصص والألعاب من أدوار الأطفال."
      },
      {
        id: "l93_ex2",
        type: "multi-select",
        title: "👧 دور الأطفال",
        instruction: "اختر الأعمال التي يمكن للأطفال القيام بها كجزء من دورهم في الأسرة.",
        items: [
          { emoji: "🧸", label: "ترتيب الألعاب", correct: true },
          { emoji: "🍽️", label: "تحضير وجبة الغداء", correct: false },
          { emoji: "📖", label: "إعادة القصص للمكتبة", correct: true },
          { emoji: "🧺", label: "مساعدة الأم في الطي", correct: true }
        ],
        successMessage: "✅ ممتاز! الترتيب والمساعدة في المهام البسيطة هو دور الأطفال.",
        errorMessage: "❌ تحضير الغداء الكامل دور للكبار."
      },
      {
        id: "l93_ex3",
        type: "select-option",
        title: "🏗️ دور المستقبل",
        instruction: "أي دور مستقبلي يساهم في بناء الوطن؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الكسل والجلوس في المنزل", "العمل كمهندس أو طبيب أو مزارع", "اللعب طوال الحياة"],
        correctAnswer: "العمل كمهندس أو طبيب أو مزارع",
        successMessage: "✅ صحيح! كل المهن تساهم في بناء الوطن.",
        errorMessage: "❌ العمل بجد يخدم الوطن."
      }
    ]
  },
  95: {
    title: "الوحدة ٥ - الدرس ١: الطبيعة والمزرعة",
    exercises: [
      {
        id: "l94_ex1",
        type: "multi-select",
        title: "🦁 حيوانات الطبيعة والمزرعة",
        instruction: "اختر الحيوانات التي يمكن تربيتها في المزرعة.",
        items: [
          { emoji: "🐑", label: "الخروف", correct: true },
          { emoji: "🐘", label: "الفيل", correct: false },
          { emoji: "🦓", label: "الحمار الوحشي", correct: false },
          { emoji: "🐄", label: "البقرة", correct: true }
        ],
        successMessage: "✅ صحيح! الخروف والبقرة حيوانات مزرعة.",
        errorMessage: "❌ الفيل والحمار الوحشي حيوانات برية."
      },
      {
        id: "l94_ex2",
        type: "multi-select",
        title: "🍏 النباتات الصالحة للزراعة",
        instruction: "اختر النباتات التي يمكن زراعتها في المزرعة (وليست برية).",
        items: [
          { emoji: "🍑", label: "المشمش", correct: true },
          { emoji: "🌵", label: "الصبار", correct: false },
          { emoji: "🍎", label: "التفاح", correct: true },
          { emoji: "🥬", label: "الخس", correct: true }
        ],
        successMessage: "✅ ممتاز! المشمش والتفاح والخس نباتات مزرعة.",
        errorMessage: "❌ الصبار نبات صحراوي لا يُزرع في المزرعة."
      },
      {
        id: "l94_ex3",
        type: "select-option",
        title: "🐘 الحيوانات البرية",
        instruction: "لماذا لا يمكننا تربية حيوان مثل الفيل في مزرعتنا؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["لأنه كبير ويحتاج مساحة كبيرة", "لأنه لا يحب المزرعة", "لأنه لا يأكل العشب"],
        correctAnswer: "لأنه كبير ويحتاج مساحة كبيرة",
        successMessage: "✅ صحيح! الفيل كبير جداً ويحتاج إلى بيئة طبيعية واسعة.",
        errorMessage: "❌ الحجم والمساحة هما المشكلة."
      }
    ]
  },
  96: {
    title: "الوحدة ٥ - الدرس ٢: الأصدقاء الأربعة",
    exercises: [
      {
        id: "l95_ex1",
        type: "select-option",
        title: "☀️ من أكون؟",
        instruction: "أنا صاحب الشمس الساطعة والحرارة المرتفعة، من أكون؟",
        pattern: [
          { type: "static", emoji: "☀️" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الشتاء", "الربيع", "الصيف", "الخريف"],
        correctAnswer: "الصيف",
        successMessage: "✅ صحيح! هذا هو فصل الصيف.",
        errorMessage: "❌ الشمس ساطعة والحرارة مرتفعة في الصيف."
      },
      {
        id: "l95_ex2",
        type: "select-option",
        title: "❄️ من أكون؟",
        instruction: "أنا صاحب الثلوج والأمطار والحرارة المنخفضة، من أكون؟",
        pattern: [
          { type: "static", emoji: "❄️" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الشتاء", "الربيع", "الصيف", "الخريف"],
        correctAnswer: "الشتاء",
        successMessage: "✅ صحيح! هذا هو فصل الشتاء.",
        errorMessage: "❌ الثلوج والأمطار والبرد تكون في الشتاء."
      },
      {
        id: "l95_ex3",
        type: "select-option",
        title: "🌷 من أكون؟",
        instruction: "أنا صاحب الأرض الخضراء والحرارة المعتدلة، من أكون؟",
        pattern: [
          { type: "static", emoji: "🌷" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الشتاء", "الربيع", "الصيف", "الخريف"],
        correctAnswer: "الربيع",
        successMessage: "✅ صحيح! هذا هو فصل الربيع.",
        errorMessage: "❌ الأرض خضراء والجو معتدل في الربيع."
      },
      {
        id: "l95_ex4",
        type: "select-option",
        title: "🍂 من أكون؟",
        instruction: "أنا صاحب الرياح والحرارة المعتدلة (مع تساقط الأوراق)، من أكون؟",
        pattern: [
          { type: "static", emoji: "🍂" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الشتاء", "الربيع", "الصيف", "الخريف"],
        correctAnswer: "الخريف",
        successMessage: "✅ صحيح! هذا هو فصل الخريف.",
        errorMessage: "❌ الأوراق تتساقط في الخريف."
      }
    ]
  },
  97: {
    title: "الوحدة ٥ - الدرس ٣: طبيعتنا الجميلة",
    exercises: [
      {
        id: "l96_ex1",
        type: "select-option",
        title: "🗺️ جهة الشروق",
        instruction: "مكان شروق الشمس صباحاً هو:",
        pattern: [
          { type: "static", emoji: "شروق الشمس" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الشرق", "الغرب", "الشمال"],
        correctAnswer: "الشرق",
        successMessage: "✅ صحيح! الشمس تشرق من الشرق.",
        errorMessage: "❌ شروق الشمس دائماً من الشرق."
      },
      {
        id: "l96_ex2",
        type: "select-option",
        title: "🗺️ جهة الغروب",
        instruction: "تغرب الشمس مساءً في:",
        pattern: [
          { type: "static", emoji: "غروب الشمس" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الشرق", "الغرب", "الجنوب"],
        correctAnswer: "الغرب",
        successMessage: "✅ صحيح! الشمس تغرب في الغرب.",
        errorMessage: "❌ غروب الشمس دائماً في الغرب."
      },
      {
        id: "l96_ex3",
        type: "select-option",
        title: "🏔️ المظاهر الطبيعية",
        instruction: "أي من هذه المظاهر الطبيعية يُوصف بأنه مرتفع جداً؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["جبل", "سهل", "وادي"],
        correctAnswer: "جبل",
        successMessage: "✅ صحيح! الجبل هو المرتفع.",
        errorMessage: "❌ الوادي والسهل مناطق منخفضة أو منبسطة."
      }
    ]
  },
  98: {
    title: "الوحدة ٥ - الدرس ٤: أغلى من الذهب",
    exercises: [
      {
        id: "l97_ex1",
        type: "select-option",
        title: "🌱 أهمية التربة",
        instruction: "أي من الكائنات التالية يستفيد من التربة في غذائه؟",
        pattern: [
          { type: "static", emoji: "يستفيد من التربة:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["البحر", "النبات والإنسان", "الغيوم"],
        correctAnswer: "النبات والإنسان",
        successMessage: "✅ صحيح! التربة تغذي النبات الذي نأكله نحن.",
        errorMessage: "❌ التربة مهمة للزراعة."
      },
      {
        id: "l97_ex2",
        type: "select-option",
        title: "🏺 التربة والطين",
        instruction: "أي من الأشياء التالية يمكن أن يُصنع من التربة الطينية؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["أوانٍ فخارية", "نقود معدنية", "ورق"],
        correctAnswer: "أوانٍ فخارية",
        successMessage: "✅ صحيح! الفخار يُصنع من الطين (التربة).",
        errorMessage: "❌ النقود من المعدن والورق من الخشب."
      },
      {
        id: "l97_ex3",
        type: "select-option",
        title: "👶 سلامة اللعب",
        instruction: "لماذا تُستخدم الرمال (التربة) في أماكن لعب الأطفال؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["لأن لونها جميل", "لأنها تحمي الأطفال من الإصابة عند السقوط", "لأنها تزيد من السرعة"],
        correctAnswer: "لأنها تحمي الأطفال من الإصابة عند السقوط",
        successMessage: "✅ صحيح! الرمال تحمي من الإصابات.",
        errorMessage: "❌ السلامة هي الهدف الأساسي."
      }
    ]
  },
  99: {
    title: "الوحدة ٥ - الدرس ٥: كنزنا الثمين",
    exercises: [
      {
        id: "l98_ex1",
        type: "select-option",
        title: "🌊 تصنيف المياه",
        instruction: "مياه النهر والنبع والبحيرة عذبة، أما مياه البحر فهي...",
        pattern: [
          { type: "static", emoji: "مياه البحر هي:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["عذبة", "مالحة", "ساخنة"],
        correctAnswer: "مالحة",
        successMessage: "✅ صحيح! مياه البحر مالحة.",
        errorMessage: "❌ تذكر أن مياه البحر مالحة."
      },
      {
        id: "l98_ex2",
        type: "multi-select",
        title: "💧 مصادر المياه العذبة",
        instruction: "اختر مصادر المياه العذبة.",
        items: [
          { emoji: "🌊", label: "مياه البحر", correct: false },
          { emoji: "💧", label: "مياه النبع", correct: true },
          { emoji: "🏞️", label: "مياه النهر", correct: true },
          { emoji: "🧂", label: "مياه البحيرة المالحة", correct: false }
        ],
        successMessage: "✅ ممتاز! مياه النبع والنهر عذبة.",
        errorMessage: "❌ مياه البحر مالحة."
      },
      {
        id: "l98_ex3",
        type: "select-option",
        title: "🚿 فائدة المياه",
        instruction: "ما هي الفائدة الأكثر أهمية للمياه؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الزينة فقط", "الشرب والحياة", "السباحة فقط"],
        correctAnswer: "الشرب والحياة",
        successMessage: "✅ صحيح! المياه هي سر الحياة.",
        errorMessage: "❌ أهم فائدة هي الشرب."
      }
    ]
  },
  100: {
    title: "الوحدة ٥ - الدرس ٦: رحلة في الفضاء",
    exercises: [
      {
        id: "l99_ex1",
        type: "count-and-input",
        title: "🪐 عد الكواكب",
        instruction: "عد الكواكب في المجموعة الشمسية.",
        groups: [
          { emoji: "🪐", count: 8 }
        ],
        numbers: ["؟", "٧", "٨", "٩"],
        correctAnswer: ["٨"],
        successMessage: "✅ صحيح! عدد الكواكب هو ٨.",
        errorMessage: "❌ عد الكواكب مرة أخرى."
      },
      {
        id: "l99_ex2",
        type: "select-option",
        title: "🌍 الكوكب الذي نعيش عليه",
        instruction: "أكتب اسم الكوكب الذي نعيش عليه.",
        pattern: [
          { type: "static", emoji: "نحن نعيش على كوكب:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["المريخ", "الأرض", "عطارد"],
        correctAnswer: "الأرض",
        successMessage: "✅ صحيح! نحن نعيش على كوكب الأرض.",
        errorMessage: "❌ كوكب المريخ لونه أحمر."
      },
      {
        id: "l99_ex3",
        type: "click-cycle-emoji",
        title: "🔢 ترتيب الكواكب",
        instruction: "رتّب أول ثلاثة كواكب من الأقرب إلى الشمس.",
        pattern: [
          { type: "interactive", emojis: ["❓", "عطارد", "الزهرة", "الأرض"] },
          { type: "interactive", emojis: ["❓", "الزهرة", "الأرض"] },
          { type: "interactive", emojis: ["❓", "الأرض"] }
        ],
        correctAnswer: ["عطارد", "الزهرة", "الأرض"],
        successMessage: "✅ ممتاز! الترتيب هو: عطارد، الزهرة، الأرض.",
        errorMessage: "❌ عطارد هو الكوكب الأقرب للشمس."
      }
    ]
  },

  /* العلوم */
  


  101: {
    title: "الوحدة الأولى - الدرس ١: حي وغير حي",
    exercises: [
      {
        id: "l101_ex1",
        type: "multi-select",
        title: "🌱 تصنيف الكائنات",
        instruction: "اختر الكائنات (الحيّة) من القائمة التالية. الكائن الحي ينمو ويتغذى.",
        items: [
          { emoji: "👶", label: "طفل", correct: true },
          { emoji: "🌳", label: "شجرة", correct: true },
          { emoji: "🪨", label: "صخر", correct: false },
          { emoji: "🐦", label: "عصفور", correct: true }
        ],
        successMessage: "✅ صحيح! الإنسان والنبات والحيوان كائنات حية.",
        errorMessage: "❌ الصخر شيء غير حي."
      },
      {
        id: "l101_ex2",
        type: "multi-select",
        title: "🪑 تصنيف الأشياء",
        instruction: "اختر الأشياء (غير الحية) من القائمة.",
        items: [
          { emoji: "🌼", label: "وردة", correct: false },
          { emoji: "🪑", label: "كرسي خشبي", correct: true },
          { emoji: "🎈", label: "بالون", correct: true },
          { emoji: "🐈", label: "قطة", correct: false }
        ],
        successMessage: "✅ ممتاز! الكرسي والبالون أشياء غير حية.",
        errorMessage: "❌ الوردة والقطة كائنات حية."
      },
      {
        id: "l101_ex3",
        type: "select-option",
        title: "❓ تعريف الكائن الحي",
        instruction: "ما هي الصفة الأساسية التي تميز الكائن الحي؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["ينمو ويتكاثر", "لا يتحرك", "مُصنَّع من البلاستيك"],
        correctAnswer: "ينمو ويتكاثر",
        successMessage: "✅ صحيح! النمو والتكاثر من صفات الكائن الحي.",
        errorMessage: "❌ الكائن الحي ينمو."
      }
    ]
  },
  102: {
    title: "الوحدة الأولى - الدرس ٢: تعيش معنا",
    exercises: [
      {
        id: "l102_ex1",
        type: "multi-select",
        title: "🗂️ تصنيف الكائنات الحية",
        instruction: "اختر التصنيفات الرئيسية للكائنات الحية.",
        items: [
          { emoji: "👶", label: "إنسان", correct: true },
          { emoji: "🪨", label: "صخر", correct: false },
          { emoji: "🌳", label: "نبات", correct: true },
          { emoji: "🐑", label: "حيوان", correct: true }
        ],
        successMessage: "✅ صحيح! إنسان ونبات وحيوان هي تصنيفات الكائنات الحية.",
        errorMessage: "❌ الصخر غير حي."
      },
      {
        id: "l102_ex2",
        type: "select-option",
        title: "🌱 ما هو التصنيف الصحيح؟",
        instruction: "ما هو تصنيف الشجرة؟",
        pattern: [
          { type: "static", emoji: "تصنيف الشجرة:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["حيوان", "نبات", "إنسان"],
        correctAnswer: "نبات",
        successMessage: "✅ صحيح! الشجرة من فئة النباتات.",
        errorMessage: "❌ الشجرة تنمو وتتغذى من التربة."
      },
      {
        id: "l102_ex3",
        type: "select-option",
        title: "🐶 ما هو التصنيف الصحيح؟",
        instruction: "ما هو تصنيف الكلب؟",
        pattern: [
          { type: "static", emoji: "تصنيف الكلب:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["حيوان", "نبات", "إنسان"],
        correctAnswer: "حيوان",
        successMessage: "✅ صحيح! الكلب من فئة الحيوانات.",
        errorMessage: "❌ الكلب حيوان أليف."
      }
    ]
  },
  103: {
    title: "الوحدة الأولى - الدرس ٣: كانت حية",
    exercises: [
      {
        id: "l103_ex1",
        type: "multi-select",
        title: "🌳 مصدرها حي",
        instruction: "الأشياء غير الحية قد يكون مصدرها حي. اختر الأشياء غير الحية التي كان أصلها كائناً حياً.",
        items: [
          { emoji: "🪑", label: "كرسي خشبي", correct: true },
          { emoji: "🪨", label: "حجر (صخر)", correct: false },
          { emoji: "🪵", label: "خشب", correct: true },
          { emoji: "🧶", label: "صوف (من الأغنام)", correct: true }
        ],
        successMessage: "✅ صحيح! الخشب والصوف كانا حيين سابقاً.",
        errorMessage: "❌ الصخر لم يكن حياً أبداً."
      },
      {
        id: "l103_ex2",
        type: "multi-select",
        title: "🪨 مصدرها غير حي",
        instruction: "اختر الأشياء غير الحية التي لم تكن حية إطلاقاً.",
        items: [
          { emoji: "🧱", label: "طوب البناء", correct: true },
          { emoji: "🪵", label: "جذع شجرة", correct: false },
          { emoji: "🪨", label: "حجر", correct: true },
          { emoji: "🎈", label: "بالون", correct: true }
        ],
        successMessage: "✅ ممتاز! الطوب والحجر والبالون لم تكن حية أبداً.",
        errorMessage: "❌ جذع الشجرة كان جزءاً من نبات حي."
      },
      {
        id: "l103_ex3",
        type: "select-option",
        title: "🌱 عملية التوقف عن النمو",
        instruction: "متى يتوقف نمو الشجرة وتصبح مادة غير حية؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["عندما تُسقى بالماء", "عندما تُقطع", "عندما تظهر أوراقها"],
        correctAnswer: "عندما تُقطع",
        successMessage: "✅ صحيح! عند قطع الشجرة يتوقف نموها.",
        errorMessage: "❌ النمو يتوقف عند القطع."
      }
    ]
  },
  104: {
    title: "الوحدة الأولى - الدرس ٤: أكتشف عالمي",
    exercises: [
      {
        id: "l104_ex1",
        type: "multi-select",
        title: "🍎 صفات المادة",
        instruction: "اختر الصفات التي يمكن أن نصف بها مادة (مثل التفاحة).",
        items: [
          { emoji: "🔴", label: "اللون", correct: true },
          { emoji: "📏", label: "الحجم", correct: true },
          { emoji: "👃", label: "الرائحة", correct: true },
          { emoji: "🥳", label: "الشعور بالفرح", correct: false }
        ],
        successMessage: "✅ صحيح! اللون والحجم والرائحة صفات للمادة.",
        errorMessage: "❌ المادة لا تشعر بالفرح."
      },
      {
        id: "l104_ex2",
        type: "select-option",
        title: "🧱 تعريف المادة",
        instruction: "المادة هي كل ما له كتلة ويشغل...",
        pattern: [
          { type: "static", emoji: "المادة تشغل:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["أفكارنا", "مكانًا (حيزًا) في الفراغ", "اللوحة"],
        correctAnswer: "مكانًا (حيزًا) في الفراغ",
        successMessage: "✅ ممتاز! المادة لها كتلة وتشغل حيزاً.",
        errorMessage: "❌ المادة تشغل حيزاً في الفراغ."
      },
      {
        id: "l104_ex3",
        type: "select-option",
        title: "⚖️ الكتلة",
        instruction: "الأشياء الثقيلة لها كتلة...",
        pattern: [
          { type: "static", emoji: "كتلة الأشياء الثقيلة:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["أكبر", "أصغر", "نفس الكتلة"],
        correctAnswer: "أكبر",
        successMessage: "✅ صحيح! الأشياء الثقيلة كتلتها أكبر.",
        errorMessage: "❌ الكتلة تقيس كمية المادة، والثقيل كتلته أكبر."
      }
    ]
  },
  105: {
    title: "الوحدة الأولى - الدرس ٥: ثلج وماء وهواء",
    exercises: [
      {
        id: "l105_ex1",
        type: "multi-select",
        title: "🧊 حالات الماء",
        instruction: "اختر حالات الماء الثلاثة الموجودة في الطبيعة.",
        items: [
          { emoji: "🧊", label: "صلب", correct: true },
          { emoji: "☕", label: "دافئ", correct: false },
          { emoji: "💧", label: "سائل", correct: true },
          { emoji: "💨", label: "غاز", correct: true }
        ],
        successMessage: "✅ صحيح! الماء موجود في حالات صلبة وسائلة وغازية.",
        errorMessage: "❌ دافئ ليست حالة للمادة."
      },
      {
        id: "l105_ex2",
        type: "select-option",
        title: "🧱 صفات المادة الصلبة",
        instruction: "المادة الصلبة (مثل مكعب الثلج) لها شكل... وحجم...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["شكل محدد وحجم ثابت", "شكل متغير وحجم ثابت", "شكل وحجم متغيران"],
        correctAnswer: "شكل محدد وحجم ثابت",
        successMessage: "✅ ممتاز! المادة الصلبة تحافظ على شكلها وحجمها.",
        errorMessage: "❌ الصلب يحافظ على شكله."
      },
      {
        id: "l105_ex3",
        type: "select-option",
        title: "💧 صفات المادة السائلة",
        instruction: "المادة السائلة (مثل الماء) يتغير شكلها وفق الإناء الذي توضع فيه، ويبقى حجمها...",
        pattern: [
          { type: "static", emoji: "حجم السائل:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["متغير", "ثابت", "كبير جداً"],
        correctAnswer: "ثابت",
        successMessage: "✅ صحيح! السائل يأخذ شكل الإناء لكن حجمه لا يتغير.",
        errorMessage: "❌ الحجم ثابت والشكل متغير."
      }
    ]
  },
  106: {
    title: "الوحدة الأولى - الدرس ٦: عالمي يتغير",
    exercises: [
      {
        id: "l106_ex1",
        type: "select-option",
        title: "🌡️ عملية الانصهار",
        instruction: "تحول المادة من الحالة (الصلبة) إلى (السائلة) باكتساب الحرارة يسمى:",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["تبخر", "تجمد", "انصهار"],
        correctAnswer: "انصهار",
        successMessage: "✅ صحيح! انصهار الثلج مثال على الانصهار.",
        errorMessage: "❌ الانصهار يكون بالحرارة."
      },
      {
        id: "l106_ex2",
        type: "select-option",
        title: "❄️ عملية التجمد",
        instruction: "تحول المادة من الحالة (السائلة) إلى (الصلبة) بالتبريد يسمى:",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["تجمد", "انصهار", "تكاثف"],
        correctAnswer: "تجمد",
        successMessage: "✅ صحيح! التجمد يكون بالتبريد.",
        errorMessage: "❌ الماء يتجمد ليصبح ثلجاً."
      },
      {
        id: "l106_ex3",
        type: "select-option",
        title: "💨 عملية التبخر",
        instruction: "تحول المادة من الحالة (السائلة) إلى (الغازية) بالتسخين يسمى:",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["تبخر", "تكاثف", "تجمد"],
        correctAnswer: "تبخر",
        successMessage: "✅ صحيح! التبخر هو تحول الماء إلى بخار.",
        errorMessage: "❌ التسخين يسبب التبخر."
      },
      {
        id: "l106_ex4",
        type: "select-option",
        title: "☁️ عملية التكاثف",
        instruction: "تحول المادة من الحالة (الغازية) إلى (السائلة) بفقدان الحرارة يسمى:",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["تبخر", "تكاثف", "انصهار"],
        correctAnswer: "تكاثف",
        successMessage: "✅ صحيح! التكاثف هو عكس التبخر (تكوّن قطرات الماء على غطاء ساخن).",
        errorMessage: "❌ فقدان الحرارة يسبب التكاثف."
      }
    ]
  },
  107: {
    title: "الوحدة الأولى - الدرس ٧: حيث نعيش",
    exercises: [
      {
        id: "l107_ex1",
        type: "select-option",
        title: "🗺️ تصنيف البيئات",
        instruction: "ما هو التصنيفان الرئيسيان للبيئة من حولنا؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["بيئة حارة وباردة", "بيئة يابسة ومائية", "بيئة صحراوية وغابية"],
        correctAnswer: "بيئة يابسة ومائية",
        successMessage: "✅ صحيح! البيئة تقسم إلى يابسة (أرض) ومائية.",
        errorMessage: "❌ التصنيف الأساسي هو يابسة ومائية."
      },
      {
        id: "l107_ex2",
        type: "multi-select",
        title: "🌱 حاجات الكائنات الحية",
        instruction: "اختر الأشياء الضرورية لعيش النباتات والحيوانات في أي بيئة.",
        items: [
          { emoji: "🍔", label: "غذاء (طعام)", correct: true },
          { emoji: "🏠", label: "منزل فاخر", correct: false },
          { emoji: "💧", label: "ماء", correct: true },
          { emoji: "💨", label: "هواء", correct: true }
        ],
        successMessage: "✅ صحيح! الغذاء والماء والهواء أساسيات.",
        errorMessage: "❌ المنزل ليس من الحاجات الأساسية للبقاء."
      },
      {
        id: "l107_ex3",
        type: "select-option",
        title: "🦊 بيئة الثعلب",
        instruction: "الثعلب القطبي (الثلجي) الأبيض يعيش في بيئة...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["حارة وجافة", "باردة ثلجية", "مائية عميقة"],
        correctAnswer: "باردة ثلجية",
        successMessage: "✅ صحيح! الثعلب الأبيض يعيش في البيئات الباردة الثلجية.",
        errorMessage: "❌ الثعلب الأبيض يتكيف مع البرد."
      }
    ]
  },
  108: {
    title: "الوحدة الأولى - الدرس ٨: نكتشف معاً",
    exercises: [
      {
        id: "l108_ex1",
        type: "select-option",
        title: "🌳 البيئة المحلية",
        instruction: "البيئة المحلية هي المنطقة التي ...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["تحتوي على كل كواكب المجموعة الشمسية", "نعيش فيها ونلاحظ ما يحيط بنا", "موجودة فقط في التلفاز"],
        correctAnswer: "نعيش فيها ونلاحظ ما يحيط بنا",
        successMessage: "✅ صحيح! البيئة المحلية هي منطقتنا المحيطة بنا.",
        errorMessage: "❌ البيئة المحلية هي مكان عيشنا."
      },
      {
        id: "l108_ex2",
        type: "multi-select",
        title: "🐞 ماذا نكتشف في حديقة المدرسة؟",
        instruction: "اختر الكائنات التي تتوقع رؤيتها في حديقة المدرسة (البيئة المحلية).",
        items: [
          { emoji: "🐝", label: "نحل", correct: true },
          { emoji: "🌸", label: "ورود ونباتات", correct: true },
          { emoji: "🐍", label: "أفعى عملاقة", correct: false },
          { emoji: "🐟", label: "سمك في البركة", correct: true }
        ],
        successMessage: "✅ ممتاز! النحل والورود والسمك في البركة أمثلة على البيئة المحلية.",
        errorMessage: "❌ الأفعى العملاقة غالباً لا تكون في البيئة المحلية الآمنة."
      }
    ]
  },
  109: {
    title: "الوحدة الثانية - الدرس ١: صغار الحيوانات",
    exercises: [
      {
        id: "l109_ex1",
        type: "select-option",
        title: "🐴 التشابه مع الوالدين",
        instruction: "صغير الحصان (المُهر) ... والديه.",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["يشبه", "لا يشبه", "يختلف تماماً عن"],
        correctAnswer: "يشبه",
        successMessage: "✅ صحيح! صغير الحصان يشبه والديه.",
        errorMessage: "❌ معظم صغار الثدييات تشبه والديها."
      },
      {
        id: "l109_ex2",
        type: "select-option",
        title: "🐸 دورة الحياة",
        instruction: "صغير الضفدع (أبو ذنيبة) ... والديه.",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["يشبه تماماً", "لا يشبه في الشكل", "يستطيع الطيران"],
        correctAnswer: "لا يشبه في الشكل",
        successMessage: "✅ صحيح! صغير الضفدع لا يشبه والديه حتى ينمو.",
        errorMessage: "❌ الضفدع يتغير شكله كثيراً (دورة حياة)."
      },
      {
        id: "l109_ex3",
        type: "multi-select",
        title: "🔄 دورة حياة الحيوان",
        instruction: "اختر العبارات الصحيحة حول دورة حياة الحيوان.",
        items: [
          { emoji: "🐣", label: "تتغير وتنمو جميع صغار الحيوانات حتى تصبح كباراً.", correct: true },
          { emoji: "🐣", label: "تستطيع جميع صغار الحيوانات العناية بنفسها.", correct: false },
          { emoji: "🐣", label: "دورة الحياة هي التغيرات التي يمر بها الحيوان أثناء نموه.", correct: true }
        ],
        successMessage: "✅ ممتاز! جميع صغار الحيوانات تنمو وتتغير، ودورة الحياة هي وصف لهذه التغيرات.",
        errorMessage: "❌ بعض الصغار لا تستطيع العناية بنفسها وتحتاج مساعدة."
      }
    ]
  },
  110: {
    title: "الوحدة الثانية - الدرس ٢: عطاء الله",
    exercises: [
      {
        id: "l110_ex1",
        type: "multi-select",
        title: "🐑 فوائد الحيوانات الأليفة",
        instruction: "اختر فوائد الحيوانات الأليفة (مثل البقرة، الدجاجة، الخروف، النحل).",
        items: [
          { emoji: "🥛", label: "تعطينا الحليب والبيض", correct: true },
          { emoji: "👕", label: "تعطينا الصوف لملابسنا", correct: true },
          { emoji: "🍯", label: "تعطينا العسل اللذيذ", correct: true },
          { emoji: "❌", label: "تأكل ملابسنا", correct: false }
        ],
        successMessage: "✅ صحيح! الحيوانات مصدر للغذاء والملبس.",
        errorMessage: "❌ الحيوانات مفيدة للإنسان."
      },
      {
        id: "l110_ex2",
        type: "select-option",
        title: "🥚 مصدر البيض",
        instruction: "من هو الحيوان الذي يُهدِينا (البيض اللذيذ)؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["البقرة", "الدجاجة", "الخروف"],
        correctAnswer: "الدجاجة",
        successMessage: "✅ صحيح! الدجاجة تعطينا البيض.",
        errorMessage: "❌ البقرة للحليب."
      },
      {
        id: "l110_ex3",
        type: "select-option",
        title: "🍯 مصدر العسل",
        instruction: "من هو الحيوان الذي يُهدِينا (العسل الحلو اللذيذ)؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["النحلة", "الذئب", "الخروف"],
        correctAnswer: "النحلة",
        successMessage: "✅ صحيح! النحلة تصنع العسل.",
        errorMessage: "❌ النحلة هي صانعة العسل."
      }
    ]
  },
  111: {
    title: "الوحدة الثانية - الدرس ٣: ألعب وأتحرك",
    exercises: [
      {
        id: "l111_ex1",
        type: "select-option",
        title: "📍 تعريف الموقع",
        instruction: "الموقع هو مكان وجود الجسم بالنسبة إلى...",
        pattern: [
          { type: "static", emoji: "الموقع هو مكان وجود الجسم بالنسبة لـ:" },
          { type: "missing", placeholder: "؟" }
        ],
        options: ["نفسه", "جسم آخر", "فراغ مطلق"],
        correctAnswer: "جسم آخر",
        successMessage: "✅ صحيح! الموقع يُحدد بالنسبة لمرجع آخر.",
        errorMessage: "❌ الموقع نسبي لجسم آخر."
      },
      {
        id: "l111_ex2",
        type: "multi-select",
        title: "🔄 طرائق الحركة",
        instruction: "اختر طرائق الحركة التي يمكن أن تسلكها الأجسام.",
        items: [
          { emoji: "➡️", label: "خط مستقيم", correct: true },
          { emoji: "🔄", label: "شكل دائري", correct: true },
          { emoji: "〰️", label: "خط متعرج", correct: true },
          { emoji: "🛑", label: "التوقف التام", correct: false }
        ],
        successMessage: "✅ ممتاز! الأجسام تتحرك بخط مستقيم، دائري، ومتعرج.",
        errorMessage: "❌ التوقف ليس طريقة حركة."
      },
      {
        id: "l111_ex3",
        type: "select-option",
        title: "🚄 السرعة",
        instruction: "سيارة وعربة يجرها حصان انطلقتا معاً. وصلت السيارة بعد نصف ساعة ووصلت العربة بعد 3 ساعات. أيهما أسرع؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["السيارة", "العربة", "متساويتان"],
        correctAnswer: "السيارة",
        successMessage: "✅ صحيح! السيارة أسرع لأنها استغرقت وقتاً أقل.",
        errorMessage: "❌ الأسرع يستغرق وقتاً أقل للوصول."
      }
    ]
  },
  112: {
    title: "الوحدة الثانية - الدرس ٤: أدفع .... أسحب",
    exercises: [
      {
        id: "l112_ex1",
        type: "multi-select",
        title: "➡️ القوة: دفع أم سحب؟",
        instruction: "اختر الحالات التي تحتاج فيها إلى (قوة الدفع) لإبعاد الجسم عنك أو تحريكه.",
        items: [
          { emoji: "🛒", label: "تحريك عربة التسوق أمامك", correct: true },
          { emoji: "🎣", label: "سحب سنارة الصيد", correct: false },
          { emoji: "🚪", label: "إغلاق الباب بيدك", correct: true },
          { emoji: "🧲", label: "سحب المغناطيس للدبابيس", correct: false }
        ],
        successMessage: "✅ صحيح! الدفع لإبعاد الجسم (العربة، الباب).",
        errorMessage: "❌ السحب يكون لتقريب الجسم."
      },
      {
        id: "l112_ex2",
        type: "multi-select",
        title: "⬅️ القوة: دفع أم سحب؟",
        instruction: "اختر الحالات التي تحتاج فيها إلى (قوة السحب) لتقريب الجسم منك.",
        items: [
          { emoji: "🎣", label: "سحب سنارة الصيد", correct: true },
          { emoji: "🛒", label: "دفع عربة التسوق", correct: false },
          { emoji: "🚪", label: "فتح الباب نحوك", correct: true },
          { emoji: "🧲", label: "سحب المغناطيس للدبابيس", correct: true }
        ],
        successMessage: "✅ ممتاز! السحب لتقريب الجسم (السنارة، الباب، المغناطيس).",
        errorMessage: "❌ الدفع لإبعاد الجسم."
      },
      {
        id: "l112_ex3",
        type: "select-option",
        title: "🔄 تغيير الحركة",
        instruction: "ما هو الشيء الذي يغير جهة حركة الأجسام (الأشياء)؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["السرعة", "القوة", "الموقع"],
        correctAnswer: "القوة",
        successMessage: "✅ صحيح! القوة هي التي تحرك الأجسام أو تغير جهة حركتها.",
        errorMessage: "❌ القوة هي التي تسبب الحركة أو التغيير."
      }
    ]
  },
  113: {
    title: "الوحدة الثالثة - الدرس ١: أنمو وأكبر",
    exercises: [
      {
        id: "l113_ex1",
        type: "multi-select",
        title: "🧍 أقسام جسم الإنسان",
        instruction: "اختر الأقسام الرئيسية لجسم الإنسان.",
        items: [
          { emoji: "🧠", label: "رأس", correct: true },
          { emoji: "👕", label: "جذع (الجزء الأوسط)", correct: true },
          { emoji: "🦶", label: "أطراف (أيدي وأرجل)", correct: true },
          { emoji: "🫀", label: "قلب", correct: false }
        ],
        successMessage: "✅ صحيح! رأس، جذع، وأطراف.",
        errorMessage: "❌ القلب عضو داخلي، ليس قسماً رئيسياً خارجياً."
      },
      {
        id: "l113_ex2",
        type: "select-option",
        title: "👶 التغير والنمو",
        instruction: "نحن ننمو ونتغير ...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["كلما كبرنا بالعمر", "عندما ننام فقط", "عندما نأكل السكريات"],
        correctAnswer: "كلما كبرنا بالعمر",
        successMessage: "✅ صحيح! النمو والتغير يحدثان مع التقدم في العمر.",
        errorMessage: "❌ النمو يحدث باستمرار مع العمر."
      },
      {
        id: "l113_ex3",
        type: "multi-select",
        title: "🗂️ أجزاء الجذع",
        instruction: "اختر الأجزاء التي يتكون منها الجذع (الجزء الأوسط من الجسم).",
        items: [
          { emoji: "👔", label: "صدر", correct: true },
          { emoji: "🍗", label: "ذراع", correct: false },
          { emoji: "🍉", label: "بطن", correct: true },
          { emoji: "🧠", label: "رأس", correct: false }
        ],
        successMessage: "✅ ممتاز! الصدر والبطن من أجزاء الجذع.",
        errorMessage: "❌ الذراع والرأس ليسا من الجذع."
      }
    ]
  },
  114: {
    title: "الوحدة الثالثة - الدرس ٢: حياتي .... صحتي",
    exercises: [
      {
        id: "l114_ex1",
        type: "multi-select",
        title: "🧼 قواعد صحية",
        instruction: "اختر القواعد الصحية التي يجب اتباعها يومياً.",
        items: [
          { emoji: "⏰", label: "الاستيقاظ باكراً", correct: true },
          { emoji: "🚿", label: "غسل الوجه واليدين", correct: true },
          { emoji: "🦷", label: "تنظيف الأسنان", correct: true },
          { emoji: "🍔", label: "تناول الوجبات السريعة", correct: false }
        ],
        successMessage: "✅ ممتاز! هذه قواعد صحية أساسية.",
        errorMessage: "❌ الوجبات السريعة ليست من القواعد الصحية."
      },
      {
        id: "l114_ex2",
        type: "select-option",
        title: "🏃‍♂️ الرياضة",
        instruction: "ما هي الفائدة الأساسية لممارسة رياضة الصباح؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["تسبب التعب", "تساعد على النشاط والحيوية", "تزيد من النوم"],
        correctAnswer: "تساعد على النشاط والحيوية",
        successMessage: "✅ صحيح! الرياضة تزيد النشاط.",
        errorMessage: "❌ الرياضة تساعد على النشاط."
      },
      {
        id: "l114_ex3",
        type: "select-option",
        title: "🍽️ أهمية الفطور",
        instruction: "متى يجب أن نتناول طعام الفطور؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["قبل الذهاب إلى المدرسة", "قبل النوم مباشرة", "في منتصف الليل"],
        correctAnswer: "قبل الذهاب إلى المدرسة",
        successMessage: "✅ صحيح! وجبة الفطور ضرورية قبل الانطلاق للنشاط.",
        errorMessage: "❌ الفطور يكون في الصباح."
      }
    ]
  },
  115: {
    title: "الوحدة الثالثة - الدرس ٣: تنير حياتي",
    exercises: [
      {
        id: "l115_ex1",
        type: "select-option",
        title: "⚡ الكهرباء الساكنة",
        instruction: "الكهرباء الساكنة تنتج عن فرك جسمين معاً (مثل البالون والصوف)، وتسبب ...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["انجذاب الأجسام", "ذوبان الثلج", "انفجار البالون"],
        correctAnswer: "انجذاب الأجسام",
        successMessage: "✅ صحيح! الكهرباء الساكنة تسبب انجذاب الشعر للبالون.",
        errorMessage: "❌ الشحنات المختلفة تتجاذب."
      },
      {
        id: "l115_ex2",
        type: "multi-select",
        title: "💡 فوائد الكهرباء المتحركة",
        instruction: "اختر فوائد الكهرباء (المتحركة) في حياتنا اليومية.",
        items: [
          { emoji: "💡", label: "توليد الضوء", correct: true },
          { emoji: "🌬️", label: "تشغيل المراوح", correct: true },
          { emoji: "🪶", label: "جعل الشعر خفيفاً", correct: false },
          { emoji: "🧺", label: "تشغيل المكواة", correct: true }
        ],
        successMessage: "✅ ممتاز! الكهرباء تولد الضوء وتشغل الأجهزة.",
        errorMessage: "❌ الكهرباء المتحركة تشغل الأجهزة."
      },
      {
        id: "l115_ex3",
        type: "select-option",
        title: "🏠 أصل الكهرباء",
        instruction: "الكهرباء المتحركة التي نشغل بها الأجهزة تأتي من:",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["المقابس في المنزل فقط", "مصانع ومحطات توليد", "فرك البالونات"],
        correctAnswer: "مصانع ومحطات توليد",
        successMessage: "✅ صحيح! نحتاج مصانع لتوليد الكهرباء المتحركة.",
        errorMessage: "❌ الكهرباء الساكنة تأتي من الفرك."
      }
    ]
  },
  116: {
    title: "الوحدة الثالثة - الدرس ٤: القوة الخفية",
    exercises: [
      {
        id: "l116_ex1",
        type: "multi-select",
        title: "🧲 المغناطيس",
        instruction: "اختر الأجسام التي يجذبها المغناطيس.",
        items: [
          { emoji: "📎", label: "دبوس ورقي (حديدي)", correct: true },
          { emoji: "✏️", label: "قلم رصاص (خشبي)", correct: false },
          { emoji: "🥫", label: "علبة معدنية (حديدية)", correct: true },
          { emoji: "🧸", label: "دمية", correct: false }
        ],
        successMessage: "✅ صحيح! المغناطيس يجذب الأجسام الحديدية.",
        errorMessage: "❌ المغناطيس يجذب الحديد فقط."
      },
      {
        id: "l116_ex2",
        type: "select-option",
        title: "🧲 القوة الخفية",
        instruction: "المغناطيس يجذب الأجسام الحديدية حتى لو وضعنا بينهما ...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["لوحاً خشبياً", "ورقة", "حديداً"],
        correctAnswer: "ورقة",
        successMessage: "✅ صحيح! المغناطيس يجذب عبر مواد خفيفة مثل الورق.",
        errorMessage: "❌ يمكن أن يجذب عبر الورق."
      }
    ]
  },
  117: {
    title: "الوحدة الثالثة - الدرس ٥: تجاذب ... تنافر",
    exercises: [
      {
        id: "l117_ex1",
        type: "select-option",
        title: "🔄 الأقطاب المتماثلة",
        instruction: "عند تقريب قطب شمالي (N) من قطب شمالي (N)، ماذا يحدث؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["يتجاذبان (يلتصقان)", "يتنافران (يبتعدان)", "لا يحدث شيء"],
        correctAnswer: "يتنافران (يبتعدان)",
        successMessage: "✅ صحيح! الأقطاب المتشابهة تتنافر.",
        errorMessage: "❌ N مع N يحدث تنافر."
      },
      {
        id: "l117_ex2",
        type: "select-option",
        title: "🤝 الأقطاب المختلفة",
        instruction: "عند تقريب قطب شمالي (N) من قطب جنوبي (S)، ماذا يحدث؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["يتجاذبان (يلتصقان)", "يتنافران (يبتعدان)", "لا يحدث شيء"],
        correctAnswer: "يتجاذبان (يلتصقان)",
        successMessage: "✅ صحيح! الأقطاب المختلفة تتجاذب.",
        errorMessage: "❌ N مع S يحدث تجاذب."
      },
      {
        id: "l117_ex3",
        type: "select-option",
        title: "🧲 موقع الأقطاب",
        instruction: "أين يقع قطبا المغناطيس؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["في منتصفه", "في طرفيه", "في كل مكان"],
        correctAnswer: "في طرفيه",
        successMessage: "✅ صحيح! القوة تكون مركزة في أطراف المغناطيس (القطبين).",
        errorMessage: "❌ القوة تكون في الأطراف."
      }
    ]
  },
  118: {
    title: "الوحدة الرابعة - الدرس ١: حواسي",
    exercises: [
      {
        id: "l118_ex1",
        type: "multi-select",
        title: "👃 حاسة الشم",
        instruction: "اختر العضو المسؤول عن حاسة الشم.",
        items: [
          { emoji: "👁️", label: "العين", correct: false },
          { emoji: "👃", label: "الأنف", correct: true },
          { emoji: "👂", label: "الأذن", correct: false },
          { emoji: "👅", label: "اللسان", correct: false }
        ],
        successMessage: "✅ صحيح! الأنف هو عضو حاسة الشم.",
        errorMessage: "❌ نستخدم الأنف للشم."
      },
      {
        id: "l118_ex2",
        type: "multi-select",
        title: "👁️ حاسة الرؤية",
        instruction: "اختر العضو المسؤول عن حاسة الرؤية.",
        items: [
          { emoji: "👁️", label: "العين", correct: true },
          { emoji: "👃", label: "الأنف", correct: false },
          { emoji: "👂", label: "الأذن", correct: false },
          { emoji: "🖐️", label: "الجلد (اليد)", correct: false }
        ],
        successMessage: "✅ صحيح! العين هي عضو حاسة الرؤية.",
        errorMessage: "❌ نستخدم العين للرؤية."
      },
      {
        id: "l118_ex3",
        type: "multi-select",
        title: "👂 حاسة السمع",
        instruction: "اختر العضو المسؤول عن حاسة السمع.",
        items: [
          { emoji: "👁️", label: "العين", correct: false },
          { emoji: "👃", label: "الأنف", correct: false },
          { emoji: "👂", label: "الأذن", correct: true },
          { emoji: "🖐️", label: "الجلد (اليد)", correct: false }
        ],
        successMessage: "✅ صحيح! الأذن هي عضو حاسة السمع.",
        errorMessage: "❌ نستخدم الأذن للسمع."
      }
    ]
  },
  119: {
    title: "الوحدة الرابعة - الدرس ٢: كيف تساعدني حواسي",
    exercises: [
      {
        id: "l119_ex1",
        type: "multi-select",
        title: "🚨 الحواس والأمان",
        instruction: "اختر الطرق التي تساعدك بها حواسك على البقاء بأمان.",
        items: [
          { emoji: "👃", label: "شم رائحة طعام فاسد.", correct: true },
          { emoji: "👂", label: "سماع صوت إنذار الخطر.", correct: true },
          { emoji: "👁️", label: "رؤية سيارة مسرعة قادمة.", correct: true },
          { emoji: "👅", label: "تذوق الحلوى فقط.", correct: false }
        ],
        successMessage: "✅ صحيح! حواسنا تحذرنا من الأخطار.",
        errorMessage: "❌ تذوق الحلوى ليس له علاقة بالبقاء بأمان."
      },
      {
        id: "l119_ex2",
        type: "select-option",
        title: "🍕 حاسة الشم",
        instruction: "عند شم رائحة طعام (بيتزا) لذيذة، ما هي الحاسة التي تخبرك بذلك؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["حاسة الشم", "حاسة اللمس", "حاسة السمع"],
        correctAnswer: "حاسة الشم",
        successMessage: "✅ صحيح! الشم يخبرنا عن الروائح.",
        errorMessage: "❌ الشم يحدد الروائح."
      },
      {
        id: "l119_ex3",
        type: "select-option",
        title: "🤢 تنبيه الطعام الفاسد",
        instruction: "كيف تدلني حواسي على أن الطعام فاسد؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["تذوق طعم كريه أو شم رائحة سيئة", "رؤية لونه الأحمر الزاهي", "سماع صوت عال"],
        correctAnswer: "تذوق طعم كريه أو شم رائحة سيئة",
        successMessage: "✅ صحيح! الرائحة والطعم هما المنبهان الأساسيان.",
        errorMessage: "❌ الرائحة والطعم يحددان فساد الطعام."
      }
    ]
  },
  120: {
    title: "الوحدة الرابعة - الدرس ٣: الأصدقاء الخمسة",
    exercises: [
      {
        id: "l120_ex1",
        type: "select-option",
        title: "📖 لغة برايل",
        instruction: "لغة برايل تستخدم لمساعدة الأشخاص الذين فقدوا حاسة الرؤية على القراءة عن طريق ...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["اللمس", "السمع", "الشم"],
        correctAnswer: "اللمس",
        successMessage: "✅ صحيح! لغة برايل تعتمد على اللمس لتمييز الحروف.",
        errorMessage: "❌ لغة برايل تعتمد على اللمس."
      },
      {
        id: "l120_ex2",
        type: "select-option",
        title: "👂 لغة الإشارة",
        instruction: "لغة الإشارة (الإيماء) تساعد الأشخاص الذين فقدوا حاسة ... على التواصل.",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الشم", "السمع", "اللمس"],
        correctAnswer: "السمع",
        successMessage: "✅ صحيح! لغة الإشارة تساعد فاقدي حاسة السمع.",
        errorMessage: "❌ لغة الإشارة تستخدم للتعويض عن السمع."
      },
      {
        id: "l120_ex3",
        type: "select-option",
        title: "💡 تعويض الحواس",
        instruction: "عند فقد إحدى الحواس، تساعد الحواس الباقية على ...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الاستسلام والجلوس", "تمييز ما حولنا والبقاء بأمان", "نسيان كل شيء"],
        correctAnswer: "تمييز ما حولنا والبقاء بأمان",
        successMessage: "✅ ممتاز! الحواس الباقية تعوض الحاسة المفقودة.",
        errorMessage: "❌ الحواس المتبقية تساعدنا في الحياة."
      }
    ]
  },
  121: {
    title: "الوحدة الرابعة - الدرس ٤: سلامة حواسي",
    exercises: [
      {
        id: "l121_ex1",
        type: "multi-select",
        title: "👁️ قواعد سلامة النظر",
        instruction: "اختر القواعد الصحية للحفاظ على سلامة حاسة النظر.",
        items: [
          { emoji: "📺", label: "مشاهدة التلفاز من مسافة مناسبة", correct: true },
          { emoji: "💡", label: "الإضاءة الجيدة في أثناء الدراسة", correct: true },
          { emoji: "☀️", label: "النظر مباشرة إلى أشعة الشمس", correct: false }
        ],
        successMessage: "✅ صحيح! المسافة والإضاءة الجيدة مهمة للنظر.",
        errorMessage: "❌ النظر مباشرة للشمس مضر جداً."
      },
      {
        id: "l121_ex2",
        type: "multi-select",
        title: "👂 قواعد سلامة السمع",
        instruction: "اختر القواعد الصحية للحفاظ على سلامة حاسة السمع.",
        items: [
          { emoji: "🎵", label: "سماع الأصوات العالية جداً", correct: false },
          { emoji: "🧻", label: "استخدام منديل معقم لتنظيف الأذن", correct: true },
          { emoji: "📌", label: "عدم إدخال الأشياء الصلبة في الأذن", correct: true }
        ],
        successMessage: "✅ صحيح! تجنب الأصوات العالية والأشياء الصلبة يحافظ على الأذن.",
        errorMessage: "❌ الأصوات العالية جداً تضر الأذن."
      },
      {
        id: "l121_ex3",
        type: "multi-select",
        title: "🖐️ قواعد صحية عامة",
        instruction: "اختر قواعد صحية عامة تحافظ على سلامة حواسك وجسمك.",
        items: [
          { emoji: "🔪", label: "الابتعاد عن الأدوات الحادة", correct: true },
          { emoji: "🧼", label: "الاستحمام بالماء والصابون", correct: true },
          { emoji: "🍎", label: "تنظيف الأنف بالأصابع", correct: false }
        ],
        successMessage: "✅ ممتاز! النظافة والابتعاد عن الأدوات الحادة ضروريان.",
        errorMessage: "❌ لا ننظف الأنف بالأصابع."
      }
    ]
  },
  122: {
    title: "الوحدة الرابعة - الدرس ٥: رحلة الضوء",
    exercises: [
      {
        id: "l122_ex1",
        type: "select-option",
        title: "☀️ مصادر الضوء",
        instruction: "ما هو مصدر الضوء الطبيعي الرئيسي الذي يضيء لنا نهارنا؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الشمس", "مصباح كهربائي", "شمعة"],
        correctAnswer: "الشمس",
        successMessage: "✅ صحيح! الشمس مصدر ضوء طبيعي.",
        errorMessage: "❌ الشمس مصدر طبيعي للضوء."
      },
      {
        id: "l122_ex2",
        type: "select-option",
        title: "💡 مصادر الضوء",
        instruction: "من أمثلة مصادر الضوء الصناعية:",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["النجوم", "ضوء البرق", "المصباح الكهربائي"],
        correctAnswer: "المصباح الكهربائي",
        successMessage: "✅ صحيح! المصباح اخترعه الإنسان.",
        errorMessage: "❌ النجوم والبرق طبيعية."
      },
      {
        id: "l122_ex3",
        type: "select-option",
        title: "➡️ مسار الضوء",
        instruction: "كيف ينتشر الضوء ليصل إلينا؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["وفق خطوط متعرجة", "وفق خطوط مستقيمة", "ينحني حول الأجسام"],
        correctAnswer: "وفق خطوط مستقيمة",
        successMessage: "✅ صحيح! الضوء ينتشر في خطوط مستقيمة.",
        errorMessage: "❌ الضوء يسير في خط مستقيم."
      },
      {
        id: "l122_ex4",
        type: "select-option",
        title: "🪞 الانعكاس",
        instruction: "ارتداد الضوء عن سطح عاكس (مثل المرآة) يسمى...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["انكسار", "انعكاس", "تشتت"],
        correctAnswer: "انعكاس",
        successMessage: "✅ صحيح! ارتداد الضوء هو انعكاس.",
        errorMessage: "❌ الانعكاس هو الارتداد."
      }
    ]
  },
  123: {
    title: "الوحدة الرابعة - الدرس ٦: الأجسام الشفافة",
    exercises: [
      {
        id: "l123_ex1",
        type: "multi-select",
        title: "🔍 تصنيف الأجسام",
        instruction: "اختر الأجسام (الشفافة) التي تسمح بمرور الضوء ورؤية الأشياء من خلالها.",
        items: [
          { emoji: "🪟", label: "زجاج النافذة", correct: true },
          { emoji: "📖", label: "الكتاب", correct: false },
          { emoji: "👓", label: "عدسة النظارة", correct: true },
          { emoji: "🧱", label: "جدار الغرفة", correct: false }
        ],
        successMessage: "✅ صحيح! الزجاج والعدسة يسمحان بمرور الضوء.",
        errorMessage: "❌ الكتاب والجدار جسمان عاتمان."
      },
      {
        id: "l123_ex2",
        type: "multi-select",
        title: "❌ الأجسام العاتمة",
        instruction: "اختر الأجسام (العاتمة) التي لا تسمح بمرور الضوء من خلالها.",
        items: [
          { emoji: "🪟", label: "زجاج النافذة", correct: false },
          { emoji: "🧱", label: "جدار الغرفة", correct: true },
          { emoji: "📃", label: "ورق مقوى", correct: true }
        ],
        successMessage: "✅ ممتاز! الجدار والورق المقوى لا يسمحان بمرور الضوء.",
        errorMessage: "❌ الجسم العاتم لا يسمح بمرور الضوء."
      },
      {
        id: "l123_ex3",
        type: "select-option",
        title: "👓 فوائد العدسات",
        instruction: "تُستخدم عدسات النظارات الطبية لـ:",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["توليد الكهرباء", "تصحيح عيوب الرؤية", "لعب الألعاب"],
        correctAnswer: "تصحيح عيوب الرؤية",
        successMessage: "✅ صحيح! العدسات الطبية تعالج عيوب النظر.",
        errorMessage: "❌ العدسات تستخدم في تصحيح الرؤية."
      }
    ]
  },
  124: {
    title: "الوحدة الرابعة - الدرس ٧: الظل رفيق الضوء",
    exercises: [
      {
        id: "l124_ex1",
        type: "select-option",
        title: "👤 تشكل الظل",
        instruction: "الظل يتشكل عندما يمنع الجسم ... من المرور خلاله.",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الماء", "الصوت", "الضوء"],
        correctAnswer: "الضوء",
        successMessage: "✅ صحيح! الظل هو شكل مظلم يتشكل بحجب الضوء.",
        errorMessage: "❌ الظل مرتبط بالضوء."
      },
      {
        id: "l124_ex2",
        type: "select-option",
        title: "👤 صفات الظل",
        instruction: "شكل الظل يكون ... شكل الجسم الذي يحجبه.",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["مختلفاً تماماً عن", "شبيهاً بـ", "أصغر دائماً من"],
        correctAnswer: "شبيهاً بـ",
        successMessage: "✅ صحيح! شكل الظل شبيه بشكل الجسم.",
        errorMessage: "❌ الظل يحاكي شكل الجسم."
      },
      {
        id: "l124_ex3",
        type: "select-option",
        title: "📏 طول الظل",
        instruction: "كيف يتغير طول الظل خلال ساعات النهار؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["يبقى ثابتاً", "يزداد في منتصف النهار", "يتغير (يكون أطول في الصباح والمساء)" ],
        correctAnswer: "يتغير (يكون أطول في الصباح والمساء)",
        successMessage: "✅ صحيح! طول الظل يتغير حسب زاوية الشمس.",
        errorMessage: "❌ الظل يتغير طوله حسب وقت اليوم."
      }
    ]
  },
  125: {
    title: "الوحدة الرابعة - الدرس ٨: رحلة الصوت",
    exercises: [
      {
        id: "l125_ex1",
        type: "select-option",
        title: "🔊 مصدر الصوت",
        instruction: "الصوت هو عبارة عن حركة...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["حرارية", "دائرية", "اهتزازية"],
        correctAnswer: "اهتزازية",
        successMessage: "✅ صحيح! الصوت ينتج عن اهتزاز الأشياء.",
        errorMessage: "❌ الصوت حركة اهتزازية."
      },
      {
        id: "l125_ex2",
        type: "multi-select",
        title: "📢 شدة الصوت",
        instruction: "اختر مصادر الأصوات التي تعتبر (قوية الشدة).",
        items: [
          { emoji: "🚑", label: "صفارة الإسعاف", correct: true },
          { emoji: "🚂", label: "صوت القطار", correct: true },
          { emoji: "🤫", label: "الهمس", correct: false }
        ],
        successMessage: "✅ ممتاز! صفارة الإسعاف والقطار أصوات قوية.",
        errorMessage: "❌ الهمس صوت ضعيف."
      },
      {
        id: "l125_ex3",
        type: "multi-select",
        title: "👂 انتشار الصوت",
        instruction: "ينتشر الصوت عبر أي من الأوساط التالية؟",
        items: [
          { emoji: "🧱", label: "الأجسام الصلبة (كالخشب)", correct: true },
          { emoji: "💧", label: "الأوساط السائلة (كالماء)", correct: true },
          { emoji: "💨", label: "الأوساط الغازية (كالهواء)", correct: true }
        ],
        successMessage: "✅ صحيح! الصوت ينتشر عبر الصلب والسائل والغاز.",
        errorMessage: "❌ الصوت ينتقل في الأجسام الصلبة."
      }
    ]
  },
  126: {
    title: "الوحدة الخامسة - الدرس ٩: غذائي",
    exercises: [
      {
        id: "l126_ex1",
        type: "multi-select",
        title: "🍎 الغذاء الصحي",
        instruction: "اختر الأطعمة التي تعتبر جزءاً من نظام غذائي صحي.",
        items: [
          { emoji: "🥛", label: "حليب وبيض", correct: true },
          { emoji: "🍰", label: "حلويات وسكريات كثيرة", correct: false },
          { emoji: "🥩", label: "لحوم وأسماك", correct: true },
          { emoji: "🥬", label: "خضار وفواكه", correct: true }
        ],
        successMessage: "✅ صحيح! الحليب واللحوم والخضار هي أغذية صحية.",
        errorMessage: "❌ السكريات والحلويات يجب عدم الإكثار منها."
      },
      {
        id: "l126_ex2",
        type: "select-option",
        title: "🍔 الغذاء غير الصحي",
        instruction: "الوجبات السريعة تعتبر غذاءً ...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["مفيداً جداً", "صحياً", "غير صحي"],
        correctAnswer: "غير صحي",
        successMessage: "✅ صحيح! يجب التقليل من الوجبات السريعة.",
        errorMessage: "❌ الإكثار منها غير صحي."
      },
      {
        id: "l126_ex3",
        type: "select-option",
        title: "💡 أهمية الغذاء",
        instruction: "لماذا نحتاج إلى الطعام؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["لنلعب فقط", "لننمو ونعيش ونبقى أقوياء", "لنشاهد التلفاز"],
        correctAnswer: "لننمو ونعيش ونبقى أقوياء",
        successMessage: "✅ صحيح! الغذاء ضروري للحياة والنمو.",
        errorMessage: "❌ الطعام له دور حيوي في النمو."
      }
    ]
  },
  127: {
    title: "الوحدة الخامسة - الدرس ١٠: عالمي الجميل أحبه أن يكون",
    exercises: [
      {
        id: "l127_ex1",
        type: "multi-select",
        title: "🧹 مهامي في المنزل والمدرسة",
        instruction: "اختر المهام التي عليك القيام بها للمحافظة على نظافة عالمك.",
        items: [
          { emoji: "🗑️", label: "رمي القمامة في السلة", correct: true },
          { emoji: "🛏️", label: "ترتيب السرير", correct: true },
          { emoji: "🧼", label: "غسل الأطباق الخفيفة", correct: true },
          { emoji: "🤫", label: "ترك القمامة على الأرض", correct: false }
        ],
        successMessage: "✅ ممتاز! هذه مهام تساعد في جعل عالمنا نظيفاً وصحياً.",
        errorMessage: "❌ رمي القمامة على الأرض سلوك خاطئ."
      },
      {
        id: "l127_ex2",
        type: "select-option",
        title: "🤝 قيمة المهام",
        instruction: "عندما ينفذ كل إنسان مهامه بإتقان، يصبح عالَمُنا...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["فوضوياً", "صحياً ونظيفاً", "حزيناً"],
        correctAnswer: "صحياً ونظيفاً",
        successMessage: "✅ صحيح! إتقان المهام يؤدي إلى عالم أفضل.",
        errorMessage: "❌ الجميع مسؤول عن نظافة العالم."
      },
      {
        id: "l127_ex3",
        type: "select-option",
        title: "📝 قاعدة النظافة",
        instruction: "أي من قواعد النظافة التالية يجب الالتزام بها دوماً في كل مكان؟",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["رمي القمامة", "غسل اليدين بعد اللعب وقبل الطعام", "الركض داخل الصف"],
        correctAnswer: "غسل اليدين بعد اللعب وقبل الطعام",
        successMessage: "✅ صحيح! غسل اليدين يحافظ على صحتنا وسلامتنا.",
        errorMessage: "❌ غسل اليدين قاعدة أساسية للنظافة."
      }
    ]
  },
  128: {
    title: "الوحدة الخامسة - الدرس ١: تنمو وتتحرك",
    exercises: [
      {
        id: "l128_ex1",
        type: "multi-select",
        title: "🌱 حركة النبات",
        instruction: "اختر العبارات الصحيحة حول نمو وحركة النبات.",
        items: [
          { emoji: "➡️", label: "ينمو النبات باتجاه الضوء.", correct: true },
          { emoji: "💧", label: "يحتاج النبات للضوء والماء لينمو.", correct: true },
          { emoji: "🪨", label: "النبات لا يتحرك أبداً.", correct: false }
        ],
        successMessage: "✅ صحيح! النبات ينمو ويتحرك باتجاه الضوء ويحتاج للماء.",
        errorMessage: "❌ النبات يتحرك (ببطء) باتجاه الضوء."
      },
      {
        id: "l128_ex2",
        type: "multi-select",
        title: "💡 حاجات النبات",
        instruction: "اختر الحاجات الأساسية التي تلزم النبات لينمو ويبقى سليماً.",
        items: [
          { emoji: "💧", label: "الماء", correct: true },
          { emoji: "💡", label: "الضوء", correct: true },
          { emoji: "🍬", label: "الحلويات", correct: false },
          { emoji: "💨", label: "الهواء", correct: true }
        ],
        successMessage: "✅ ممتاز! الماء والضوء والهواء حاجات أساسية.",
        errorMessage: "❌ الحلويات لا تفيد النبات."
      },
      {
        id: "l128_ex3",
        type: "select-option",
        title: "🔄 اتجاه النمو",
        instruction: "عندما يوضع النبات في غرفة فيها ضوء خفيف من جانب واحد، فإنه ينمو ...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["باتجاه الضوء", "بعيداً عن الضوء", "يبقى مستقيماً"],
        correctAnswer: "باتجاه الضوء",
        successMessage: "✅ صحيح! النبات ينمو باتجاه مصدر الضوء.",
        errorMessage: "❌ النبات يبحث عن الضوء."
      }
    ]
  },
  129: {
    title: "الوحدة الخامسة - الدرس ٢: أقسام النبات",
    exercises: [
      {
        id: "l129_ex1",
        type: "multi-select",
        title: "🍃 أقسام النبات الرئيسية",
        instruction: "اختر الأقسام المشتركة الموجودة في جميع النباتات.",
        items: [
          { emoji: "🌱", label: "جذر", correct: true },
          { emoji: "🌸", label: "زهرة", correct: false },
          { emoji: "🌿", label: "ورقة", correct: true },
          { emoji: "🪵", label: "ساق", correct: true }
        ],
        successMessage: "✅ صحيح! الجذر والساق والأوراق هي الأقسام المشتركة.",
        errorMessage: "❌ الزهرة والثمرة ليست موجودة في كل النباتات."
      },
      {
        id: "l129_ex2",
        type: "multi-select",
        title: "🥕 أقسام النبات القابلة للأكل",
        instruction: "أي من أقسام النبات التالية يمكننا أكله؟",
        items: [
          { emoji: "🥕", label: "الجذر (كالجزر والفجل)", correct: true },
          { emoji: "🍎", label: "الثمرة (كالتفاح)", correct: true },
          { emoji: "🥬", label: "الأوراق (كالملفوف)", correct: true },
          { emoji: "🪵", label: "الساق (كقصب السكر)", correct: true }
        ],
        successMessage: "✅ ممتاز! يمكننا أكل الجذور والثمار والأوراق والساق.",
        errorMessage: "❌ هناك أجزاء أخرى يمكن أكلها."
      },
      {
        id: "l129_ex3",
        type: "select-option",
        title: "🌼 وظيفة الزهرة",
        instruction: "بعد نمو النبات، تتحول الزهرة إلى...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["بذور", "جذر", "ثمار"],
        correctAnswer: "ثمار",
        successMessage: "✅ صحيح! الزهرة تتحول إلى ثمرة، والثمرة بداخلها بذور.",
        errorMessage: "❌ الزهرة هي التي تعطي الثمرة."
      }
    ]
  },
  130: {
    title: "الوحدة الخامسة - الدرس ٣: من البذور إلى النبات",
    exercises: [
      {
        id: "l130_ex1",
        type: "click-cycle-emoji",
        title: "🔄 دورة حياة النبات",
        instruction: "رتّب مراحل نمو النبات من البذرة حتى العودة للبذرة مجدداً.",
        pattern: [
          { type: "interactive", emojis: ["❓", "بذرة", "نبات صغير", "نبات يزهر", "ثمرة"] },
          { type: "interactive", emojis: ["❓", "نبات صغير", "نبات يزهر", "ثمرة"] },
          { type: "interactive", emojis: ["❓", "نبات يزهر", "ثمرة"] },
          { type: "interactive", emojis: ["❓", "ثمرة"] }
        ],
        correctAnswer: ["بذرة", "نبات صغير", "نبات يزهر", "ثمرة"],
        successMessage: "✅ صحيح! دورة الحياة تبدأ بالبذرة وتمر بالنمو ثم الثمرة.",
        errorMessage: "❌ الترتيب: بذرة ➡️ نمو ➡️ إزهار ➡️ ثمرة."
      },
      {
        id: "l130_ex2",
        type: "select-option",
        title: "💧 حاجات البذور",
        instruction: "عند زراعة البذور في التراب، فإنها تحتاج إلى الماء وال... لتنمو في البداية.",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الدفء", "الضوء القوي", "الريح القوية"],
        correctAnswer: "الدفء",
        successMessage: "✅ صحيح! البذور تحتاج الماء والدفء.",
        errorMessage: "❌ البذور لا تحتاج الضوء في البداية."
      },
      {
        id: "l130_ex3",
        type: "multi-select",
        title: "🚫 البذور الضارة",
        instruction: "هل تستطيع أكل جميع البذور؟",
        items: [
          { emoji: "✅", label: "نعم، كل البذور آمنة للأكل.", correct: false },
          { emoji: "❌", label: "لا، بعض البذور سامة أو غير صالحة للأكل.", correct: true }
        ],
        successMessage: "✅ صحيح! يجب الحذر، بعض البذور سامة.",
        errorMessage: "❌ لا تأكل أي بذرة دون أن تعرف أنها آمنة."
      }
    ]
  },
  131: {
    title: "الوحدة الخامسة - الدرس ٤: حاجات النبات",
    exercises: [
      {
        id: "l131_ex1",
        type: "multi-select",
        title: "🌱 الحاجات الأساسية للنبات",
        instruction: "اختر جميع الحاجات الأساسية التي تحتاجها معظم النباتات لتنمو وتبقى سليمة.",
        items: [
          { emoji: "💧", label: "الماء", correct: true },
          { emoji: "💡", label: "الضوء", correct: true },
          { emoji: "🪨", label: "الحجارة", correct: false },
          { emoji: "💨", label: "الهواء", correct: true },
          { emoji: "🌳", label: "التربة والدفء", correct: true }
        ],
        successMessage: "✅ ممتاز! الماء والضوء والهواء والتربة والدفء أساسية.",
        errorMessage: "❌ الحجارة ليست حاجة أساسية."
      },
      {
        id: "l131_ex2",
        type: "select-option",
        title: "😔 ذبول النبات",
        instruction: "إذا لم يتوافر للنبات الضوء والماء الكافي فإنه...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["ينمو أسرع", "يذبل ويموت", "يصبح أصغر حجماً"],
        correctAnswer: "يذبل ويموت",
        successMessage: "✅ صحيح! نقص الماء والضوء يسبب الذبول والموت.",
        errorMessage: "❌ نقص الحاجات الأساسية يؤدي إلى الموت."
      },
      {
        id: "l131_ex3",
        type: "select-option",
        title: "❓ ما هي الحاجة المفقودة؟",
        instruction: "إذا وضعت نبتة في الظلام وعملت على سقيها، فإن الحاجة المفقودة هي...",
        pattern: [
          { type: "missing", placeholder: "؟" }
        ],
        options: ["الماء", "التربة", "الضوء"],
        correctAnswer: "الضوء",
        successMessage: "✅ صحيح! عند وضعها في الظلام تكون الحاجة المفقودة هي الضوء.",
        errorMessage: "❌ الظلام يعني عدم وجود الضوء."
      }
    ]
  },

  /*اللغة الانجليزية */
132: {
    title: "Unit 1: Hello!",
    exercises: [
      {
        id: "l132_ex1",
        type: "select-option",
        title: "Hello!",
        instruction: "Choose the correct greeting.",
        pattern: [
          { type: "static", emoji: "👋" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Hello.", "Desk."],
        correctAnswer: "Hello.",
        successMessage: "✅ Correct! Hello.",
        errorMessage: "❌ Try again! The correct word is Hello."
      },
      {
        id: "l132_ex2",
        type: "select-option",
        title: "Asking about your name",
        instruction: "Choose the correct question to ask someone's name.",
        pattern: [
          { type: "static", emoji: "🗣️" },
          { type: "missing", placeholder: "Name?" }
        ],
        options: ["How old are you?", "What's your name?"],
        correctAnswer: "What's your name?",
        successMessage: "✅ Correct! What's your name?",
        errorMessage: "❌ Try again! The correct phrase is What's your name?"
      },
      {
        id: "l132_ex3",
        type: "select-option",
        title: "How are you?",
        instruction: "Choose the correct response to 'How are you?'",
        pattern: [
          { type: "static", emoji: "🤔 How are you?" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["I'm Bill.", "I'm fine, thank you."],
        correctAnswer: "I'm fine, thank you.",
        successMessage: "✅ Correct! I'm fine, thank you.",
        errorMessage: "❌ Try again! You must respond to the question."
      }
    ]
  },
  133: {
    title: "Unit 2: Counting",
    exercises: [
      {
        id: "l133_ex1",
        type: "count-and-input",
        title: "Count to 5",
        instruction: "Count the objects in each group and write the number.",
        groups: [
          { emoji: "🍎", count: 1 },
          { emoji: "🍎", count: 3 },
          { emoji: "🍎", count: 5 }
        ],
        numbers: ["?", "1", "2", "3", "4", "5"],
        correctAnswer: ["1", "3", "5"],
        successMessage: "✅ Well done! You can count to 5.",
        errorMessage: "❌ Try again! Count carefully."
      },
      {
        id: "l133_ex2",
        type: "select-option",
        title: "Commands",
        instruction: "Choose the correct word to complete the command: '... up!'",
        pattern: [
          { type: "missing", placeholder: "?" },
          { type: "static", emoji: "👆" },
          { type: "static", emoji: "up!" }
        ],
        options: ["Sit", "Stand"],
        correctAnswer: "Stand",
        successMessage: "✅ Correct! Stand up!",
        errorMessage: "❌ Try again! The correct command is Stand up."
      },
      {
        id: "l133_ex3",
        type: "multi-select",
        title: "Matching numbers to words",
        instruction: "Select the correct number for the word 'Four'.",
        items: [
          { emoji: "1", label: "One", correct: false },
          { emoji: "4", label: "Four", correct: true },
          { emoji: "2", label: "Two", correct: false }
        ],
        successMessage: "✅ Correct! Four is 4.",
        errorMessage: "❌ Try again! Check the number for Four."
      }
    ]
  },
  134: {
    title: "Unit 3: Classroom objects",
    exercises: [
      {
        id: "l134_ex1",
        type: "select-option",
        title: "Classroom objects",
        instruction: "Choose the correct word: 'What's this? It's a...'",
        pattern: [
          { type: "static", emoji: "✏️" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Book.", "Pencil."],
        correctAnswer: "Pencil.",
        successMessage: "✅ Correct! It's a pencil.",
        errorMessage: "❌ Try again! That is a pencil."
      },
      {
        id: "l134_ex2",
        type: "select-option",
        title: "Asking about objects",
        instruction: "Choose the correct question to ask about a book.",
        pattern: [
          { type: "static", emoji: "❓" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["What's your name?", "What's this?"],
        correctAnswer: "What's this?",
        successMessage: "✅ Correct! What's this?",
        errorMessage: "❌ Try again! The question is What's this?"
      },
      {
        id: "l134_ex3",
        type: "count-and-input",
        title: "Count the objects",
        instruction: "Count the number of books.",
        groups: [
          { emoji: "📚", count: 5 }
        ],
        numbers: ["?", "1", "2", "3", "4", "5"],
        correctAnswer: ["5"],
        successMessage: "✅ Correct! There are 5 books.",
        errorMessage: "❌ Try again! Count the books carefully."
      }
    ]
  },
  135: {
    title: "Unit 4: Instructions and Describing",
    exercises: [
      {
        id: "l135_ex1",
        type: "select-option",
        title: "Giving instructions",
        instruction: "Choose the correct word to complete the command: '... the window, please.'",
        pattern: [
          { type: "missing", placeholder: "?" },
          { type: "static", emoji: "🖼️" },
          { type: "static", emoji: "the window, please." }
        ],
        options: ["Open", "Sit"],
        correctAnswer: "Open",
        successMessage: "✅ Correct! Open the window, please.",
        errorMessage: "❌ Try again! The correct verb is Open."
      },
      {
        id: "l135_ex2",
        type: "select-option",
        title: "Describing people",
        instruction: "If you are a girl, what do you say?",
        pattern: [
          { type: "static", emoji: "👧" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["I'm a boy.", "I'm a girl."],
        correctAnswer: "I'm a girl.",
        successMessage: "✅ Correct! I'm a girl.",
        errorMessage: "❌ Try again! The word for female child is girl."
      },
      {
        id: "l135_ex3",
        type: "multi-select",
        title: "Commands checklist",
        instruction: "Select all the correct commands.",
        items: [
          { emoji: "👍", label: "Open the door.", correct: true },
          { emoji: "❌", label: "Door the open.", correct: false },
          { emoji: "👍", label: "Close the window.", correct: true }
        ],
        successMessage: "✅ Correct! The commands are Open the door and Close the window.",
        errorMessage: "❌ Try again! Check the word order."
      }
    ]
  },
  136: {
    title: "Unit 6: Let's eat! (Food)",
    exercises: [
      {
        id: "l136_ex1",
        type: "select-option",
        title: "Asking about food",
        instruction: "Choose the correct response: 'Is this a sandwich?' (If the picture is a sandwich)",
        pattern: [
          { type: "static", emoji: "🥪 Is this a sandwich?" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Yes, it is.", "No, it isn't."],
        correctAnswer: "Yes, it is.",
        successMessage: "✅ Correct! Yes, it is.",
        errorMessage: "❌ Try again! It is a sandwich."
      },
      {
        id: "l136_ex2",
        type: "select-option",
        title: "Identifying food",
        instruction: "Choose the correct name for the red fruit.",
        pattern: [
          { type: "static", emoji: "🍅" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Banana.", "Tomato."],
        correctAnswer: "Tomato.",
        successMessage: "✅ Correct! Tomato.",
        errorMessage: "❌ Try again! Check the word for Tomato."
      },
      {
        id: "l136_ex3",
        type: "select-option",
        title: "Negative response",
        instruction: "Choose the correct response: 'Is this a banana?' (If the picture is a pen)",
        pattern: [
          { type: "static", emoji: "🍌 Is this a banana?" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Yes, it is.", "No, it's a pen."],
        correctAnswer: "No, it's a pen.",
        successMessage: "✅ Correct! No, it's a pen.",
        errorMessage: "❌ Try again! It is not a banana."
      }
    ]
  },
  137: {
    title: "Unit 7: What colour is the...?",
    exercises: [
      {
        id: "l137_ex1",
        type: "select-option",
        title: "Asking about colour",
        instruction: "Choose the correct question to ask about the house's color.",
        pattern: [
          { type: "static", emoji: "🏠" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["What's your name?", "What colour is the house?"],
        correctAnswer: "What colour is the house?",
        successMessage: "✅ Correct! What colour is the house?",
        errorMessage: "❌ Try again! The correct question is What colour is the house?"
      },
      {
        id: "l137_ex2",
        type: "click-cycle-colors",
        title: "Describing colour",
        instruction: "Choose the correct colour for the boat.",
        pattern: [
          { type: "static", emoji: "⛵", color: "white" },
          { type: "interactive", colors: ["white", "red", "blue", "green"], isCircle: true }
        ],
        correctAnswer: ["green"],
        successMessage: "✅ Correct! The boat is green.",
        errorMessage: "❌ Try again! The boat is green."
      },
      {
        id: "l137_ex3",
        type: "select-option",
        title: "Describing colour",
        instruction: "Choose the correct color for the school bus.",
        pattern: [
          { type: "static", emoji: "🚌" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["The bus is red.", "The bus is yellow."],
        correctAnswer: "The bus is yellow.",
        successMessage: "✅ Correct! The bus is yellow.",
        errorMessage: "❌ Try again! School buses are usually yellow."
      }
    ]
  },
  138: {
    title: "Unit 8: My face",
    exercises: [
      {
        id: "l138_ex1",
        type: "select-option",
        title: "Parts of the face",
        instruction: "Choose the correct word for the part used for seeing.",
        pattern: [
          { type: "static", emoji: "👁️" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Eye", "Nose", "Mouth"],
        correctAnswer: "Eye",
        successMessage: "✅ Correct! This is my eye.",
        errorMessage: "❌ Try again! The correct word is Eye."
      },
      {
        id: "l138_ex2",
        type: "multi-select",
        title: "Identifying parts",
        instruction: "Select all the words for parts of the face.",
        items: [
          { emoji: "👂", label: "Ear", correct: true },
          { emoji: "🖐️", label: "Hand", correct: false },
          { emoji: "👄", label: "Mouth", correct: true }
        ],
        successMessage: "✅ Correct! Ear and Mouth are parts of the face.",
        errorMessage: "❌ Try again! Hand is not on the face."
      },
      {
        id: "l138_ex3",
        type: "select-option",
        title: "Giving instructions (Body)",
        instruction: "Choose the correct command: 'Touch your ...'",
        pattern: [
          { type: "static", emoji: "👃" },
          { type: "missing", placeholder: "Touch your...?" }
        ],
        options: ["Hand", "Nose"],
        correctAnswer: "Nose",
        successMessage: "✅ Correct! Touch your nose.",
        errorMessage: "❌ Try again! Touch your nose."
      }
    ]
  },
  139: {
    title: "Unit 9: My family",
    exercises: [
      {
        id: "l139_ex1",
        type: "select-option",
        title: "Family members",
        instruction: "Choose the correct word for your male parent.",
        pattern: [
          { type: "static", emoji: "👨" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Mother", "Father"],
        correctAnswer: "Father",
        successMessage: "✅ Correct! This is my father.",
        errorMessage: "❌ Try again! The correct word is Father."
      },
      {
        id: "l139_ex2",
        type: "select-option",
        title: "Asking about people",
        instruction: "Choose the correct question to ask who a person is.",
        pattern: [
          { type: "static", emoji: "❓" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["What's your name?", "Who's this?"],
        correctAnswer: "Who's this?",
        successMessage: "✅ Correct! Who's this?",
        errorMessage: "❌ Try again! The question is Who's this?"
      },
      {
        id: "l139_ex3",
        type: "multi-select",
        title: "Family members",
        instruction: "Select the words that name family members.",
        items: [
          { emoji: "👧", label: "Sister", correct: true },
          { emoji: "🪑", label: "Chair", correct: false },
          { emoji: "👩", label: "Mother", correct: true }
        ],
        successMessage: "✅ Correct! Sister and Mother are family members.",
        errorMessage: "❌ Try again! Chair is an object."
      }
    ]
  },
  140: {
    title: "Unit 11: My birthday (Numbers 6-10)",
    exercises: [
      {
        id: "l140_ex1",
        type: "count-and-input",
        title: "Count to 10",
        instruction: "Count the objects in each group and write the number.",
        groups: [
          { emoji: "🎈", count: 6 },
          { emoji: "🎈", count: 8 },
          { emoji: "🎈", count: 10 }
        ],
        numbers: ["?", "6", "7", "8", "9", "10"],
        correctAnswer: ["6", "8", "10"],
        successMessage: "✅ Well done! You can count to 10.",
        errorMessage: "❌ Try again! Count carefully."
      },
      {
        id: "l140_ex2",
        type: "select-option",
        title: "Asking about age",
        instruction: "Choose the correct question to ask about Walid's age.",
        pattern: [
          { type: "static", emoji: "❓" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["What's your name?", "How old's Walid?"],
        correctAnswer: "How old's Walid?",
        successMessage: "✅ Correct! How old's Walid?",
        errorMessage: "❌ Try again! The question for age is How old...?"
      },
      {
        id: "l140_ex3",
        type: "select-option",
        title: "Stating age",
        instruction: "If Walid is seven, what is the correct response?",
        pattern: [
          { type: "static", emoji: "🎂 How old is Walid?" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Walid's seven.", "Walid's fine."],
        correctAnswer: "Walid's seven.",
        successMessage: "✅ Correct! Walid's seven.",
        errorMessage: "❌ Try again! State the age."
      }
    ]
  },
  141: {
    title: "Unit 12: Is the bed green?",
    exercises: [
      {
        id: "l141_ex1",
        type: "select-option",
        title: "Asking about color (Yes)",
        instruction: "Choose the correct response: 'Is the bed green?' (If the bed IS green)",
        pattern: [
          { type: "static", emoji: "🟢 Is the bed green?" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Yes, it is.", "No, it isn't."],
        correctAnswer: "Yes, it is.",
        successMessage: "✅ Correct! Yes, it is.",
        errorMessage: "❌ Try again! If the answer is yes, use Yes, it is."
      },
      {
        id: "l141_ex2",
        type: "select-option",
        title: "Asking about color (No)",
        instruction: "Choose the correct response: 'Is the chair black?' (If the chair IS blue)",
        pattern: [
          { type: "static", emoji: "⚫ Is the chair black?" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Yes, it is.", "No, it isn't. It's blue."],
        correctAnswer: "No, it isn't. It's blue.",
        successMessage: "✅ Correct! No, it isn't. It's blue.",
        errorMessage: "❌ Try again! If the answer is no, state the correct color."
      },
      {
        id: "l141_ex3",
        type: "multi-select",
        title: "Identifying colors",
        instruction: "Select the colors mentioned in the picture list.",
        items: [
          { emoji: "🔴", label: "Red", correct: true },
          { emoji: "💜", label: "Purple", correct: false },
          { emoji: "⚪️", label: "White", correct: true },
          { emoji: "⚫", label: "Black", correct: true }
        ],
        successMessage: "✅ Correct! Red, White, and Black were mentioned.",
        errorMessage: "❌ Try again! Purple was not mentioned."
      }
    ]
  },
  142: {
    title: "Unit 13: My body",
    exercises: [
      {
        id: "l142_ex1",
        type: "select-option",
        title: "Body parts",
        instruction: "Choose the correct word: 'What's this? It's a...'",
        pattern: [
          { type: "static", emoji: "🖐️" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Leg.", "Hand."],
        correctAnswer: "Hand.",
        successMessage: "✅ Correct! It's a hand.",
        errorMessage: "❌ Try again! The correct word is Hand."
      },
      {
        id: "l142_ex2",
        type: "select-option",
        title: "Asking about body parts (Yes)",
        instruction: "Choose the correct response: 'Is it a leg?' (If the picture IS a leg)",
        pattern: [
          { type: "static", emoji: "🦵 Is it a leg?" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Yes, it is.", "No, it isn't."],
        correctAnswer: "Yes, it is.",
        successMessage: "✅ Correct! Yes, it is.",
        errorMessage: "❌ Try again! It is a leg."
      },
      {
        id: "l142_ex3",
        type: "select-option",
        title: "Action verbs",
        instruction: "Choose the correct word for the action shown: 'Clap your...'",
        pattern: [
          { type: "static", emoji: "👏" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Heads.", "Hands."],
        correctAnswer: "Hands.",
        successMessage: "✅ Correct! Clap your hands.",
        errorMessage: "❌ Try again! The action is Clap your hands."
      }
    ]
  },
  143: {
    title: "Unit 14: What's that? (Size)",
    exercises: [
      {
        id: "l143_ex1",
        type: "select-option",
        title: "Asking about objects (Far)",
        instruction: "Choose the correct question to ask about a far object.",
        pattern: [
          { type: "static", emoji: "❓ (Far)" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["What's this?", "What's that?"],
        correctAnswer: "What's that?",
        successMessage: "✅ Correct! What's that?",
        errorMessage: "❌ Try again! Use What's that? for distant objects."
      },
      {
        id: "l143_ex2",
        type: "select-option",
        title: "Describing size (Small)",
        instruction: "Choose the word describing a small key.",
        pattern: [
          { type: "static", emoji: "🔑" },
          { type: "missing", placeholder: "It's a... key." }
        ],
        options: ["big", "small"],
        correctAnswer: "small",
        successMessage: "✅ Correct! It's a small key.",
        errorMessage: "❌ Try again! The key is described as small."
      },
      {
        id: "l143_ex3",
        type: "select-option",
        title: "Describing size (Big)",
        instruction: "Choose the word describing a large umbrella.",
        pattern: [
          { type: "static", emoji: "☂️" },
          { type: "missing", placeholder: "It's a... umbrella." }
        ],
        options: ["big", "small"],
        correctAnswer: "big",
        successMessage: "✅ Correct! It's a big umbrella.",
        errorMessage: "❌ Try again! The umbrella is big."
      }
    ]
  },
  144: {
    title: "Unit 16: Our clothes",
    exercises: [
      {
        id: "l144_ex1",
        type: "select-option",
        title: "Asking about people",
        instruction: "Choose the correct question to ask who Huda is.",
        pattern: [
          { type: "static", emoji: "❓" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["What's your name?", "Who's that?"],
        correctAnswer: "Who's that?",
        successMessage: "✅ Correct! Who's that?",
        errorMessage: "❌ Try again! The question for people is Who's that?"
      },
      {
        id: "l144_ex2",
        type: "multi-select",
        title: "Describing clothes",
        instruction: "Salah has a blue shirt. Select the correct items.",
        items: [
          { emoji: "👕", label: "Shirt", correct: true },
          { emoji: "🔵", label: "Blue", correct: true },
          { emoji: "👗", label: "Dress", correct: false }
        ],
        successMessage: "✅ Correct! Shirt and Blue are correct.",
        errorMessage: "❌ Try again! Salah has a shirt, not a dress."
      },
      {
        id: "l144_ex3",
        type: "select-option",
        title: "Clothing item",
        instruction: "Choose the correct word for a piece of clothing worn on the upper body.",
        pattern: [
          { type: "static", emoji: "🧥" },
          { type: "missing", placeholder: "It's a..." }
        ],
        options: ["Jacket", "Shoe"],
        correctAnswer: "Jacket",
        successMessage: "✅ Correct! It's a jacket.",
        errorMessage: "❌ Try again! A jacket is an item of clothing."
      }
    ]
  },
  145: {
    title: "Unit 17: Where is it? (Location)",
    exercises: [
      {
        id: "l145_ex1",
        type: "select-option",
        title: "Preposition of place",
        instruction: "If the doll is resting on the table, choose the correct preposition.",
        pattern: [
          { type: "static", emoji: "❓" },
          { type: "missing", placeholder: "It's... the table." }
        ],
        options: ["on", "under"],
        correctAnswer: "on",
        successMessage: "✅ Correct! It's on the table.",
        errorMessage: "❌ Try again! On means resting on the surface."
      },
      {
        id: "l145_ex2",
        type: "select-option",
        title: "Preposition of place",
        instruction: "If the ball is directly below the table, choose the correct preposition.",
        pattern: [
          { type: "static", emoji: "❓" },
          { type: "missing", placeholder: "It's... the table." }
        ],
        options: ["in", "under"],
        correctAnswer: "under",
        successMessage: "✅ Correct! It's under the table.",
        errorMessage: "❌ Try again! Under means below."
      },
      {
        id: "l145_ex3",
        type: "select-option",
        title: "Preposition of place",
        instruction: "If the umbrella is inside the box, choose the correct preposition.",
        pattern: [
          { type: "static", emoji: "❓" },
          { type: "missing", placeholder: "It's... the box." }
        ],
        options: ["in", "on"],
        correctAnswer: "in",
        successMessage: "✅ Correct! It's in the box.",
        errorMessage: "❌ Try again! In means inside."
      }
    ]
  },
  146: {
    title: "Unit 18: I like ice cream. (Likes/Offering)",
    exercises: [
      {
        id: "l146_ex1",
        type: "multi-select",
        title: "Expressing likes",
        instruction: "Select all the sentences that express something you like.",
        items: [
          { emoji: "🍦", label: "I like ice cream.", correct: true },
          { emoji: "❌", label: "I like lamp.", correct: false },
          { emoji: "🍚", label: "I like rice.", correct: true }
        ],
        successMessage: "✅ Correct! I like ice cream. and I like rice. express likes.",
        errorMessage: "❌ Try again! You only like things that are fun or edible."
      },
      {
        id: "l146_ex2",
        type: "select-option",
        title: "Offering food",
        instruction: "Choose the correct polite response to 'Water?' when accepting.",
        pattern: [
          { type: "static", emoji: "💧 Water?" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Yes, please.", "No, it isn't."],
        correctAnswer: "Yes, please.",
        successMessage: "✅ Correct! Yes, please.",
        errorMessage: "❌ Try again! The polite way to accept is Yes, please."
      },
      {
        id: "l146_ex3",
        type: "select-option",
        title: "Stating quantity",
        instruction: "Choose the correct response: 'How many apples are there?' (If there are seven)",
        pattern: [
          { type: "static", emoji: "🍎🍎🍎🍎🍎🍎🍎" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["There are eight apples.", "There are seven apples."],
        correctAnswer: "There are seven apples.",
        successMessage: "✅ Correct! There are seven apples.",
        errorMessage: "❌ Try again! Count the apples."
      }
    ]
  },
  147: {
    title: "Unit 19: Animals",
    exercises: [
      {
        id: "l147_ex1",
        type: "select-option",
        title: "Asking about animals",
        instruction: "Choose the correct word: 'What's that? It's a...'",
        pattern: [
          { type: "static", emoji: "🐴" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Bird.", "Horse."],
        correctAnswer: "Horse.",
        successMessage: "✅ Correct! It's a horse.",
        errorMessage: "❌ Try again! That is a horse."
      },
      {
        id: "l147_ex2",
        type: "select-option",
        title: "Identifying animals",
        instruction: "Choose the animal that says 'cheep-cheep'.",
        pattern: [
          { type: "static", emoji: "🎶 Cheep-cheep" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["The cat.", "The bird."],
        correctAnswer: "The bird.",
        successMessage: "✅ Correct! The bird says cheep-cheep.",
        errorMessage: "❌ Try again! Birds say cheep-cheep."
      },
      {
        id: "l147_ex3",
        type: "select-option",
        title: "Asking about animals (Yes/No)",
        instruction: "Choose the correct response: 'Is that a dog?' (If the picture IS a dog)",
        pattern: [
          { type: "static", emoji: "🐕 Is that a dog?" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Yes, it is.", "No, it isn't."],
        correctAnswer: "Yes, it is.",
        successMessage: "✅ Correct! Yes, it is.",
        errorMessage: "❌ Try again! It is a dog."
      }
    ]
  },
  148: {
    title: "Unit 21: Is that Zeina's vase? (Possession)",
    exercises: [
      {
        id: "l148_ex1",
        type: "select-option",
        title: "Asking about possession (Yes)",
        instruction: "Choose the correct response: 'Is that Zeina's sandwich?' (If the answer IS yes)",
        pattern: [
          { type: "static", emoji: "🥪 Is that Zeina's sandwich?" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Yes, it is.", "No, it isn't."],
        correctAnswer: "Yes, it is.",
        successMessage: "✅ Correct! Yes, it is.",
        errorMessage: "❌ Try again! The positive answer is Yes, it is."
      },
      {
        id: "l148_ex2",
        type: "select-option",
        title: "Asking about possession (No)",
        instruction: "Choose the correct response: 'Is this Bill's sandwich?' (If the answer IS no)",
        pattern: [
          { type: "static", emoji: "🥪 Is this Bill's sandwich?" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Yes, it is.", "No, it isn't."],
        correctAnswer: "No, it isn't.",
        successMessage: "✅ Correct! No, it isn't.",
        errorMessage: "❌ Try again! The negative answer is No, it isn't."
      },
      {
        id: "l148_ex3",
        type: "select-option",
        title: "Possessive form",
        instruction: "Choose the correct word to indicate possession: 'This is Salma... bag.'",
        pattern: [
          { type: "static", emoji: "🛍️ This is Salma... bag." },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Salma", "Salma's"],
        correctAnswer: "Salma's",
        successMessage: "✅ Correct! Salma's shows possession.",
        errorMessage: "❌ Try again! Salma's indicates possession."
      }
    ]
  },
  149: {
    title: "Unit 22: Where's Mother? (Location)",
    exercises: [
      {
        id: "l149_ex1",
        type: "select-option",
        title: "Asking for location",
        instruction: "Choose the correct question to ask where Father is.",
        pattern: [
          { type: "static", emoji: "👨" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["What's your name?", "Where's Father?"],
        correctAnswer: "Where's Father?",
        successMessage: "✅ Correct! Where's Father?",
        errorMessage: "❌ Try again! The question for location is Where's...?"
      },
      {
        id: "l149_ex2",
        type: "select-option",
        title: "Location: Room",
        instruction: "Choose the correct response: 'Where's Mother?' (If she is in the sitting room)",
        pattern: [
          { type: "static", emoji: "🛋️" },
          { type: "missing", placeholder: "She's in the..." }
        ],
        options: ["bedroom.", "sitting room."],
        correctAnswer: "sitting room.",
        successMessage: "✅ Correct! She's in the sitting room.",
        errorMessage: "❌ Try again! The room with sofas is the sitting room."
      },
      {
        id: "l149_ex3",
        type: "select-option",
        title: "Location: Object",
        instruction: "Choose the correct response: 'Where's Hassan's book?' (If the book is under the bed)",
        pattern: [
          { type: "static", emoji: "📖" },
          { type: "missing", placeholder: "It's..." }
        ],
        options: ["It's on the bed.", "It's under the bed."],
        correctAnswer: "It's under the bed.",
        successMessage: "✅ Correct! It's under the bed.",
        errorMessage: "❌ Try again! The book is under the bed."
      }
    ]
  },
  150: {
    title: "Unit 23: I'm tall. (Describing People)",
    exercises: [
      {
        id: "l150_ex1",
        type: "select-option",
        title: "Describing size (Tall)",
        instruction: "Choose the correct word for a very high person.",
        pattern: [
          { type: "static", emoji: "🦒" },
          { type: "missing", placeholder: "I'm..." }
        ],
        options: ["short.", "tall."],
        correctAnswer: "tall.",
        successMessage: "✅ Correct! I'm tall.",
        errorMessage: "❌ Try again! The correct word is tall."
      },
      {
        id: "l150_ex2",
        type: "select-option",
        title: "Describing size (Short)",
        instruction: "Choose the correct word for a small person.",
        pattern: [
          { type: "static", emoji: "🧍" },
          { type: "missing", placeholder: "I'm..." }
        ],
        options: ["short.", "big."],
        correctAnswer: "short.",
        successMessage: "✅ Correct! I'm short.",
        errorMessage: "❌ Try again! The correct word is short."
      },
      {
        id: "l150_ex3",
        type: "multi-select",
        title: "Describing objects (Size)",
        instruction: "Select the words used to describe the size of objects.",
        items: [
          { emoji: "🐘", label: "Big", correct: true },
          { emoji: "🐜", label: "Small", correct: true },
          { emoji: "🌳", label: "Tall", correct: true },
          { emoji: "😁", label: "Happy", correct: false }
        ],
        successMessage: "✅ Correct! Big, Small, and Tall are used for size.",
        errorMessage: "❌ Try again! Happy is a feeling, not a size."
      }
    ]
  }
,
151: {
    title: "Unit 20: Revision 4",
    exercises: [
      {
        id: "l151_ex1",
        type: "select-option",
        title: "Revision: Location",
        instruction: "Choose the correct preposition: 'The ball is ... the chair.'",
        pattern: [
          { type: "static", emoji: "⚽ (Below a chair)" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["in", "on", "under"],
        correctAnswer: "under",
        successMessage: "✅ Correct! The ball is under the chair.",
        errorMessage: "❌ Try again! Under means below."
      },
      {
        id: "l151_ex2",
        type: "multi-select",
        title: "Revision: Food and Likes",
        instruction: "Select all the sentences that express something you like.",
        items: [
          { emoji: "🍚", label: "I like rice.", correct: true },
          { emoji: "❌", label: "I like computer.", correct: false },
          { emoji: "🍦", label: "I like ice cream.", correct: true }
        ],
        successMessage: "✅ Correct! I like rice and I like ice cream.",
        errorMessage: "❌ Try again! You only like things that are food or fun."
      },
      {
        id: "l151_ex3",
        type: "select-option",
        title: "Revision: Offering",
        instruction: "Choose the correct polite response to 'Water?' when accepting.",
        pattern: [
          { type: "static", emoji: "💧 Water?" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Yes, please.", "No, thank you.", "I'm fine."],
        correctAnswer: "Yes, please.",
        successMessage: "✅ Correct! Yes, please.",
        errorMessage: "❌ Try again! The polite way to accept is Yes, please."
      }
    ]
  },
  152: {
    title: "Unit 21: Is that Zeina's vase? (Possession)",
    exercises: [
      {
        id: "l152_ex1",
        type: "select-option",
        title: "Asking about possession (Yes)",
        instruction: "Choose the correct affirmative response: 'Is that Zeina's sandwich?' (If the answer IS yes)",
        pattern: [
          { type: "static", emoji: "🥪 Is that Zeina's sandwich?" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Yes, it is.", "No, it isn't."],
        correctAnswer: "Yes, it is.",
        successMessage: "✅ Correct! Yes, it is.",
        errorMessage: "❌ Try again! The positive answer is Yes, it is."
      },
      {
        id: "l152_ex2",
        type: "select-option",
        title: "Asking about possession (No)",
        instruction: "Choose the correct negative response: 'Is this Hassan's book?' (If the answer IS no)",
        pattern: [
          { type: "static", emoji: "📚 Is this Hassan's book?" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Yes, it is.", "No, it isn't."],
        correctAnswer: "No, it isn't.",
        successMessage: "✅ Correct! No, it isn't.",
        errorMessage: "❌ Try again! The negative answer is No, it isn't."
      },
      {
        id: "l152_ex3",
        type: "select-option",
        title: "Possessive form",
        instruction: "Choose the correct form to indicate possession: 'This is Salma... bag.'",
        pattern: [
          { type: "static", emoji: "🛍️ This is Salma... bag." },
          { type: "missing", placeholder: "?" }
        ],
        options: ["Salma", "Salma's"],
        correctAnswer: "Salma's",
        successMessage: "✅ Correct! Salma's shows possession.",
        errorMessage: "❌ Try again! Salma's indicates possession."
      }
    ]
  },
  153: {
    title: "Unit 22: Where's Mother? (Location)",
    exercises: [
      {
        id: "l153_ex1",
        type: "select-option",
        title: "Asking for location",
        instruction: "Choose the correct question to ask where Father is.",
        pattern: [
          { type: "static", emoji: "👨" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["What's your name?", "Where's Father?"],
        correctAnswer: "Where's Father?",
        successMessage: "✅ Correct! Where's Father?",
        errorMessage: "❌ Try again! The question for location is Where's...?"
      },
      {
        id: "l153_ex2",
        type: "select-option",
        title: "Location: Room",
        instruction: "Choose the correct response: 'Where's Mother?' (If she is in the sitting room)",
        pattern: [
          { type: "static", emoji: "🛋️ Mother" },
          { type: "missing", placeholder: "She's in the..." }
        ],
        options: ["bedroom.", "sitting room."],
        correctAnswer: "sitting room.",
        successMessage: "✅ Correct! She's in the sitting room.",
        errorMessage: "❌ Try again! The room with sofas is the sitting room."
      },
      {
        id: "l153_ex3",
        type: "select-option",
        title: "Location: Object",
        instruction: "Choose the correct response: 'Where's Hassan's book?' (If the book is under the bed)",
        pattern: [
          { type: "static", emoji: "📖 Book" },
          { type: "missing", placeholder: "It's..." }
        ],
        options: ["It's on the bed.", "It's under the bed."],
        correctAnswer: "It's under the bed.",
        successMessage: "✅ Correct! It's under the bed.",
        errorMessage: "❌ Try again! The book is under the bed."
      }
    ]
  },
  154: {
    title: "Unit 23: I'm tall. (Describing People)",
    exercises: [
      {
        id: "l154_ex1",
        type: "select-option",
        title: "Describing size (Tall)",
        instruction: "Choose the correct word for a very high person.",
        pattern: [
          { type: "static", emoji: "🦒" },
          { type: "missing", placeholder: "I'm..." }
        ],
        options: ["short.", "tall."],
        correctAnswer: "tall.",
        successMessage: "✅ Correct! I'm tall.",
        errorMessage: "❌ Try again! The correct word is tall."
      },
      {
        id: "l154_ex2",
        type: "select-option",
        title: "Describing size (Short)",
        instruction: "Choose the correct word for a small person.",
        pattern: [
          { type: "static", emoji: "🐜" },
          { type: "missing", placeholder: "I'm..." }
        ],
        options: ["short.", "big."],
        correctAnswer: "short.",
        successMessage: "✅ Correct! I'm short.",
        errorMessage: "❌ Try again! The correct word is short."
      },
      {
        id: "l154_ex3",
        type: "multi-select",
        title: "Describing clothes",
        instruction: "Select the words used to describe clothes or objects.",
        items: [
          { emoji: "🔴", label: "Red", correct: true },
          { emoji: "😁", label: "Happy", correct: false },
          { emoji: "🧥", label: "Jacket", correct: true }
        ],
        successMessage: "✅ Correct! Red and Jacket describe clothes/objects.",
        errorMessage: "❌ Try again! Happy is a feeling, not a description of clothes."
      }
    ]
  },
  155: {
    title: "Unit 24: The alphabet",
    exercises: [
      {
        id: "l155_ex1",
        type: "select-option",
        title: "Alphabet Sounds: 't'",
        instruction: "Choose the word that begins with the 't' sound.",
        pattern: [
          { type: "missing", placeholder: "T is for...?" }
        ],
        options: ["car", "toy", "hand"],
        correctAnswer: "toy",
        successMessage: "✅ Correct! T is for toy.",
        errorMessage: "❌ Try again! T makes the 't' sound."
      },
      {
        id: "l155_ex2",
        type: "select-option",
        title: "Alphabet Sounds: 'c'",
        instruction: "Choose the word that begins with the 'c' sound.",
        pattern: [
          { type: "missing", placeholder: "C is for...?" }
        ],
        options: ["cat", "dog", "umbrella"],
        correctAnswer: "cat",
        successMessage: "✅ Correct! C is for cat.",
        errorMessage: "❌ Try again! C makes the 'c' sound."
      },
      {
        id: "l155_ex3",
        type: "multi-select",
        title: "Alphabet Order",
        instruction: "Which two letters follow 'E' in the English alphabet?",
        items: [
          { emoji: "F", label: "F", correct: true },
          { emoji: "G", label: "G", correct: true },
          { emoji: "H", label: "H", correct: false },
          { emoji: "D", label: "D", correct: false }
        ],
        successMessage: "✅ Correct! F and G follow E (E, F, G).",
        errorMessage: "❌ Try again! Say the alphabet."
      }
    ]
  },
  156: {
    title: "Unit 25: Revision 5",
    exercises: [
      {
        id: "l156_ex1",
        type: "select-option",
        title: "Revision: Animals",
        instruction: "Choose the animal that says 'cheep-cheep'.",
        pattern: [
          { type: "static", emoji: "🎶 Cheep-cheep" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["The cat.", "The bird.", "The dog."],
        correctAnswer: "The bird.",
        successMessage: "✅ Correct! The bird says cheep-cheep.",
        errorMessage: "❌ Try again! Birds say cheep-cheep."
      },
      {
        id: "l156_ex2",
        type: "select-option",
        title: "Revision: Location (Object)",
        instruction: "Choose the correct response: 'Where is the book?' (If the book is on the table)",
        pattern: [
          { type: "static", emoji: "📚" },
          { type: "missing", placeholder: "?" }
        ],
        options: ["It's in the fridge.", "It's on the table."],
        correctAnswer: "It's on the table.",
        successMessage: "✅ Correct! It's on the table.",
        errorMessage: "❌ Try again! The book is on the table."
      },
      {
        id: "l156_ex3",
        type: "select-option",
        title: "Revision: Describing Size",
        instruction: "Choose the word describing a small object.",
        pattern: [
          { type: "static", emoji: "🐜" },
          { type: "missing", placeholder: "It's..." }
        ],
        options: ["big", "small", "tall"],
        correctAnswer: "small",
        successMessage: "✅ Correct! It's small.",
        errorMessage: "❌ Try again! Ant is small."
      }
    ]
  }


};